export const es = {
  common: {
    appName: "noaretraite",
    tagline: "Balance de Jubilación Individual por Aon.",
    loading: "Cargando…",
    error: "Se produjo un error",
    retry: "Reintentar",
    back: "Volver",
    next: "Siguiente",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    confirm: "Confirmar",
    learnMore: "Más información",
    getStarted: "Comenzar",
    contactUs: "Contáctenos",
    search: "Buscar",
    close: "Cerrar",
    open: "Abrir",
    add: "Añadir",
    create: "Crear",
    update: "Actualizar",
    remove: "Quitar",
    yes: "Sí",
    no: "No",
    all: "Todos",
    none: "Ninguno",
    export: "Exportar",
    export_excel: "Exportar (Excel)",
    export_csv: "Exportar CSV",
    no_name: "(sin nombre)",
    import: "Importar",
    download: "Descargar",
    upload: "Subir",
    filter: "Filtrar",
    sort: "Ordenar",
    reset: "Restablecer",
    apply: "Aplicar",
    select: "Seleccionar",
    selected: "seleccionado(s)",
    actions: "Acciones",
    details: "Detalles",
    status: "Estado",
    date: "Fecha",
    name: "Nombre",
    email: "Correo electrónico",
    phone: "Teléfono",
    description: "Descripción",
    notes: "Notas",
    total: "Total",
    of: "de",
    noResults: "Sin resultados",
    showMore: "Ver más",
    showLess: "Ver menos",
    showHelp: "Mostrar la ayuda",
    required: "Obligatorio",
    optional: "Opcional",
    enabled: "Activado",
    disabled: "Desactivado",
    active: "Activo",
    inactive: "Inactivo",
    pending: "Pendiente",
    success: "Éxito",
    warning: "Advertencia",
    info: "Información",
    copy: "Copiar",
    copied: "¡Copiado!",
    preview: "Vista previa",
    send: "Enviar",
    ctrl_cmd: "Ctrl/Cmd",
    sent: "Enviado",
    archive: "Archivar",
    restore: "Restaurar",
    today: "Hoy",
    yesterday: "Ayer",
    tomorrow: "Mañana",
    days: "días",
    hours: "horas",
    minutes: "minutos",
    and: "y",
    or: "o",
    notAvailable: "no proporcionado",
    size_kb: "{{size}} KB",
    size_mb: "{{size}} MB",
  },
  ui: {
    pagination: {
      range: "de {{total}} {{unit}}",
      items: "elementos",
      page_of: "Página {{page}} / {{pages}}",
      prev: "Anterior",
      next: "Siguiente",
    },
    list: {
      truncated: "Lista limitada a las primeras 20.000 filas, ajuste los filtros.",
    },
    combobox: {
      placeholder: "Seleccionar…",
      search: "Buscar…",
      empty: "Sin resultados",
      refine: "Afine la búsqueda para ver más resultados…",
    },
    collapsible: {
      collapse: "Contraer la sección",
      expand: "Desplegar la sección",
    },
    imageUploader: {
      too_big: "El archivo supera {{max}} MB.",
      unsupported: "Tipo no compatible ({{type}}).",
      unknown_type: "desconocido",
      upload_failed: "Error al subir el archivo",
      saved: "Imagen guardada",
      replace: "Reemplazar",
      remove: "Eliminar",
      uploading: "Subiendo…",
      drop_here: "Suelte el archivo aquí",
      drop_or_click: "Suelte o haga clic para subir",
      formats: "PNG, JPG, WEBP o SVG · máx. {{max}} MB",
    },
    editor: {
      aria_label: "Editor de texto",
      bold: "Negrita",
      italic: "Cursiva",
      heading: "Título",
      subheading: "Subtítulo",
      paragraph: "Texto normal",
      bullet_list: "Lista con viñetas",
      ordered_list: "Lista numerada",
      quote: "Cita",
      insert_link: "Insertar un enlace",
      confirm_link: "Validar el enlace",
      placeholder: "Escriba el texto aquí y luego déle formato con la barra de herramientas.",
    },
    emailPreview: {
      title: "Vista previa del correo",
      description: "Revise el contenido del mensaje antes de enviarlo.",
      to: "Para",
      subject: "Asunto",
      loading: "Cargando la vista previa…",
      iframe_title: "Vista previa del correo",
    },
    password: {
      strength: "Robustez:",
      hint: "{{min}} caracteres como mínimo, con mayúscula, minúscula y número.",
      score_0: "Muy débil",
      score_1: "Débil",
      score_2: "Media",
      score_3: "Buena",
      score_4: "Excelente",
    },
    assistant: {
      title: "Noa",
      subtitle: "Su asistente de jubilación",
      open: "Abrir el asistente",
      placeholder: "Haga su pregunta…",
      disclaimer: "Noa puede equivocarse: verifique la información importante con su asesor.",
      thinking: "Noa está pensando…",
      empty_title: "¿Cómo puedo ayudarle?",
      empty_subtitle: "Haga una pregunta sobre sus datos o solicite una acción.",
      new_conversation: "Nueva conversación",
      fullscreen: "Pantalla completa",
      exit_fullscreen: "Salir de pantalla completa",
      history: "Historial",
      no_history: "Todavía no hay conversaciones.",
      untitled: "Conversación",
      error_generic: "Se produjo un error. Inténtelo de nuevo.",
      action_title: "Acción a confirmar",
      action_running: "Ejecutando…",
      action_done: "Acción ejecutada",
      action_failed: "La acción falló",
      action_rejected: "Acción cancelada",
      open_dossier_bri: "Abrir el expediente para generar el BRI",
      tools: {
        run_sql_select: "Consultando datos",
        get_schema: "Leyendo la estructura",
        call_rpc: "Función de negocio",
        get_dossier_overview: "Leyendo el expediente",
        get_simulation_results: "Leyendo resultados",
        get_career: "Leyendo la carrera",
        search_salaries: "Buscando empleados",
        export_data: "Preparando la exportación",
        compute: "Calculando",
        run_pension_calculation: "Ejecutando el cálculo de pensión",
        create_simulation: "Creando simulación",
        update_dossier_souhaits: "Actualizando los deseos de jubilación",
        update_salarie_contact: "Actualizando los datos de contacto",
        replace_retraite_supplementaire: "Actualizando el ahorro para la jubilación",
        generate_bri: "Preparando el BRI",
        set_dossier_status: "Cambiando el estado",
        assign_dossier: "Asignando el expediente",
        log_relance: "Registrando el seguimiento",
        send_message: "Enviando mensaje",
        create_formation: "Creando sesión de formación",
        enroll_formation: "Inscribiendo en la formación",
        set_formation_presence: "Registrando la asistencia a la formación",
        code_interpreter: "Generando archivo (Python)",
      },
      sugg: {
        explain_results: "Explícame mis resultados de simulación",
        fill_projet: "Quiero completar mis deseos de salida",
        best_departure: "¿Cuál es mi mejor fecha de salida?",
        rachat_worth: "¿Me conviene recomprar trimestres?",
        compare_runs: "Compara mis diferentes cálculos",
        missing_docs: "¿Qué documentos me faltan?",
        explain_ris: "Explícame mi historial de carrera",
        draft_message: "Ayúdame a escribir un mensaje a mi asesor",
        where_dossier: "¿En qué estado está mi expediente?",
        explain_notion: "Explícame la penalización y la bonificación",
        export_formation_xlsx: "Exporta a Excel los inscritos en formaciones",
        participation_summary: "Resume la participación de mis empleados",
        top_risques: "¿Qué empleados tienen anomalías de carrera?",
        salaries_inactifs: "¿Qué empleados nunca se conectaron?",
        export_salaries: "Exporta la lista de empleados a Excel",
        relance_targets: "¿A quién hay que recordar primero?",
        sessions_remplissage: "¿Cuál es la tasa de ocupación de las sesiones?",
        resume_salarie: "Resume la situación de este empleado",
        resume_dossier: "Resume este expediente",
        generate_bri: "Genera el BRI de este expediente",
        next_action: "¿Cuál es la próxima acción en este expediente?",
        dispatch_stats: "¿Cuántos expedientes quedan por asignar?",
        oldest_pending: "¿Cuáles son los expedientes pendientes más antiguos?",
        my_workload: "Resume mi carga de trabajo",
        ai_costs_month: "¿Cuánto costó la IA este mes?",
        ai_top_users: "¿Quiénes son los mayores usuarios de la IA?",
        global_stats: "Dame las estadísticas globales de la plataforma",
      },
    },
  },
  nav: {
    home: "Inicio",
    employees: "Empleados",
    employers: "RRHH",
    aonTeam: "Equipo Aon",
    security: "Seguridad",
    login: "Iniciar sesión",
    signup: "Crear cuenta",
    logout: "Cerrar sesión",
    dashboard: "Mi espacio",
  },
  landing: {
    hero: {
      eyebrow: "Plataforma Aon Wealth",
      title: "Su Balance de Jubilación, con confianza.",
      subtitle:
        "noaretraite es la plataforma digital creada por Aon para producir y entregar balances de jubilación individuales — para empleados, directores de RRHH y equipos Aon.",
      ctaPrimary: "Acceder a mi espacio",
      ctaSecondary: "Descubrir la plataforma",
    },
    trust: {
      label: "Diseñado y operado por",
      items: [
        "Aon — líder mundial en riesgos y capital humano",
        "Alojamiento europeo conforme al RGPD",
        "Motor de cálculo de jubilación de referencia",
      ],
    },
    personas: {
      title: "Tres experiencias, una sola plataforma.",
      subtitle:
        "Cada perfil tiene un espacio dedicado, con sus propios datos, permisos y nivel de detalle.",
      salarie: {
        tag: "Espacio Empleado",
        title: "Su balance de jubilación en pocos clics",
        bullets: [
          "Centralizo mis documentos (RIS, Agirc-Arrco, nómina)",
          "Lanzo mis simulaciones de forma autónoma",
          "Dialogo con mi consultor Aon dedicado",
          "Consulto mi Balance de Jubilación y el historial de actualizaciones",
        ],
        cta: "Descubrir el espacio empleado",
      },
      drh: {
        tag: "Espacio RRHH",
        title: "Pilotaje de jubilaciones con precisión",
        bullets: [
          "Seguimiento en tiempo real del avance de la operación",
          "Visión agregada por unidad de negocio, región, categoría",
          "Distribución de fechas de jubilación posibles",
          "Exportaciones CSV/Excel para su planificación de plantilla",
        ],
        cta: "Descubrir el espacio RRHH",
      },
      aon: {
        tag: "Equipos Aon",
        title: "Producción industrial de balances de jubilación",
        bullets: [
          "Gestión de clientes empresas, operaciones y poblaciones",
          "Asignación de expedientes al equipo de producción",
          "Integración nativa del motor de cálculo de jubilación",
          "Generación de Balances de Jubilación cobrandados",
        ],
        cta: "Descubrir el back-office",
      },
    },
    features: {
      title: "Una plataforma pensada para la producción industrial.",
      items: [
        {
          title: "Motor de cálculo integrado",
          body: "Todos los regímenes soportados por el motor de cálculo (CNIEG, Función Pública, regímenes específicos). Más de 15 alertas automáticas.",
        },
        {
          title: "Marca por empresa",
          body: "Logo, colores, tipografías, textos, entregables PDF — cada empresa cliente tiene su propia identidad visual, cobrandada Aon × Empresa.",
        },
        {
          title: "RGPD por diseño",
          body: "Alojamiento europeo, cifrado en base de datos, Row Level Security, trazabilidad, derecho al olvido y portabilidad.",
        },
        {
          title: "Multilingüe",
          body: "Francés, inglés y español disponibles. Las etiquetas y los correos son configurables por operación.",
        },
        {
          title: "Mensajería integrada",
          body: "Conversaciones directas entre empleados, equipo de producción, jefe de proyecto y RRHH — con adjuntos y trazabilidad.",
        },
        {
          title: "Citas y recordatorios",
          body: "Restitución por Teams / teléfono, agenda de consultores, recordatorios automáticos configurables.",
        },
      ],
    },
    security: {
      title: "Seguridad y cumplimiento en el corazón de la plataforma.",
      subtitle:
        "Diseñada para tratar datos personales sensibles, noaretraite cumple con los estándares más exigentes.",
      items: [
        "Autenticación fuerte (MFA) y SSO empresarial disponible",
        "Cifrado AES-256 en reposo, TLS 1.2/1.3 en tránsito",
        "Alojamiento UE — SOC 2, ISO 27001 / 27018, RGPD",
        "Row Level Security Postgres en cada tabla",
        "Trazabilidad completa y derecho al olvido",
        "Sin almacenamiento de tarjetas (pago delegado a Stripe)",
      ],
    },
    cta: {
      title: "¿Listo para industrializar sus balances de jubilación?",
      subtitle: "Hablemos de su operación. Nuestro equipo responde en 24h laborables.",
      ctaPrimary: "Solicitar una demo",
      ctaSecondary: "Acceder a mi cuenta",
    },
  },
  auth: {
    login: {
      title: "Acceder a su espacio",
      subtitle: "Introduzca sus credenciales para acceder a su Balance de Jubilación.",
      email: "Correo electrónico",
      password: "Contraseña",
      submit: "Iniciar sesión",
      forgot: "¿Contraseña olvidada?",
      noAccount: "¿No tiene cuenta?",
      signup: "Crear una cuenta",
      orContinueWith: "o continuar con",
      remember: "Recordarme",
      noAccountContact: "¿No tiene cuenta? Contacte a su administrador Aon.",
      timeoutTitle: "Ha sido desconectado",
      timeoutDesc:
        "Por su seguridad, su sesión se cerró tras un periodo de inactividad. Vuelva a iniciar sesión para continuar.",
      expiredTitle: "Enlace caducado o ya utilizado",
      expiredDesc:
        "Introduzca su correo electrónico a continuación para recibir un nuevo enlace de conexión.",
      close: "Cerrar",
      modePassword: "Contraseña",
      modeOtp: "Enlace por correo",
      otpInfoTitle: "Conexión mediante enlace por correo.",
      otpInfoBody:
        "Introduzca su correo profesional o personal. Le enviaremos un enlace de conexión seguro. No se requiere contraseña.",
      otpSentTitle: "Correo enviado",
      otpSentBody1: "Se ha enviado un enlace de conexión a",
      otpSentBody2: ". Recuerde revisar su carpeta de spam. El enlace es válido durante 1 hora.",
      otpSubmit: "Recibir un enlace de conexión",
      otpSubmitSent: "Enlace enviado",
    },
    mfa: {
      enrollTitle: "Proteja su cuenta",
      enrollSubtitle:
        "La doble autenticación añade una segunda verificación en cada conexión. Se gestiona con una aplicación gratuita en su teléfono.",
      preparing: "Preparando la inscripción…",
      enrollAppsHint:
        "Instale una aplicación de autenticación gratuita, por ejemplo Microsoft Authenticator o Google Authenticator.",
      step1: "Escanee este código con su aplicación",
      step2: "O introduzca esta clave manualmente",
      step3: "Introduzca el código mostrado por la aplicación",
      qrAlt: "Código QR para escanear con su aplicación de autenticación",
      manualKey: "Clave de configuración",
      codeLabel: "Código de 6 dígitos",
      autoVerifyHint: "El código se verifica automáticamente al introducir los seis dígitos.",
      verify: "Verificar",
      errorInvalidCode:
        "El código no corresponde a esta configuración. Utilice la entrada asociada a este QR y su código más reciente. Si el problema persiste, compruebe la hora automática del teléfono.",
      errorExpiredCode:
        "La solicitud de verificación ha expirado. Inténtelo de nuevo con el código que aparece en su aplicación.",
      errorGeneric:
        "El servicio de autenticación no ha podido completar la solicitud. Inténtelo de nuevo en unos instantes.",
      errorFactorMissing:
        "Esta configuración de autenticación ha expirado o se ha eliminado. Reinicie la activación con un nuevo código QR.",
      errorRejected:
        "La política de seguridad ha rechazado la verificación. Inicie sesión de nuevo o contacte con su administrador.",
      errorNetworkChanged:
        "Su conexión de red ha cambiado durante la verificación. Mantenga la misma conexión e inténtelo de nuevo.",
      errorEnrollmentConflict: "Ya hay una activación en curso. Recargue la página para retomarla.",
      errorSessionExpired: "Su sesión ha expirado. Inicie sesión de nuevo antes de continuar.",
      errorRateLimit:
        "Demasiados intentos seguidos. Espere un minuto antes de volver a intentarlo.",
      errorNetwork:
        "No se puede contactar con el servicio de autenticación. Compruebe su conexión e inténtelo de nuevo.",
      errorRecoveryCodes:
        "La doble autenticación está activada, pero no se han podido obtener los códigos de recuperación. Inténtelo de nuevo para obtenerlos.",
      preparingRecovery: "Doble autenticación activada. Preparando los códigos de recuperación…",
      retryRecovery: "Obtener mis códigos de recuperación",
      resumeWithoutQr:
        "Ya hay una activación en curso. Introduzca el código de la entrada NOA Retraite añadida a su aplicación. Si aún no ha escaneado el QR, seleccione «Reiniciar la activación».",
      restart: "Reiniciar la activación",
      restartWarning:
        "Se creará un nuevo QR y el anterior dejará de funcionar. Elimine únicamente la entrada NOA Retraite añadida para esta activación en su aplicación y escanee el nuevo QR.",
      retry: "Reintentar",
      recoveryIntro:
        "Estos códigos le permiten volver a conectarse si pierde su teléfono. Cada código funciona una sola vez.",
      recoveryWarning:
        "No se mostrarán de nuevo. Consérvelos en un lugar seguro (por ejemplo, un gestor de contraseñas).",
      copied: "Copiado al portapapeles",
      copyCodes: "Copiar los códigos",
      downloadCodes: "Descargar (.txt)",
      recoveryConfirm: "He guardado mis códigos de recuperación",
      continue: "Continuar",
      logout: "Cerrar sesión",
      challengeTitle: "Verificación en dos pasos",
      challengeSubtitle:
        "Introduzca el código de 6 dígitos mostrado por su aplicación de autenticación.",
      challengeHint: "Código de 6 dígitos",
      useRecovery: "Usar un código de recuperación",
      recoveryHint: "¿Ha perdido su teléfono? Introduzca uno de sus códigos de recuperación.",
      recoveryLabel: "Código de recuperación",
      recoverySubmit: "Validar el código",
      backToTotp: "Volver al código de 6 dígitos",
      recoveryFileHeader: "NOA Retraite: códigos de recuperación",
    },
    layout: {
      featMfa: "Autenticación fuerte (MFA) y SSO",
      featEncryption: "Cifrado AES-256 y TLS 1.2/1.3",
      featHosting: "Alojamiento europeo, conforme al RGPD",
    },
    signup: {
      title: "Crear su cuenta",
      subtitle:
        "El registro se realiza por invitación de su empleador. Introduzca el correo electrónico que recibió la invitación.",
      email: "Correo electrónico",
      password: "Elegir una contraseña",
      passwordHelp: "Mínimo 12 caracteres, combinando mayúsculas / minúsculas / cifras / símbolos.",
      firstName: "Nombre",
      lastName: "Apellido",
      submit: "Crear mi cuenta",
      hasAccount: "¿Ya tiene una cuenta?",
      login: "Iniciar sesión",
      acceptTos:
        "Al crear su cuenta, acepta nuestros términos de uso y nuestra política de privacidad.",
    },
    reset: {
      title: "Contraseña olvidada",
      subtitle:
        "Introduzca su correo electrónico — le enviaremos un enlace seguro para restablecer su contraseña.",
      email: "Correo electrónico",
      submit: "Enviar el enlace",
      backToLogin: "Volver al inicio de sesión",
      sent: "Si existe una cuenta para esta dirección, se ha enviado un correo electrónico.",
    },
    callback: {
      title: "Definir su contraseña",
      subtitle: "Elija una contraseña para acceder a su espacio.",
      password: "Contraseña",
      confirm: "Confirmar contraseña",
      submit: "Validar",
      success: "Contraseña definida con éxito.",
    },
    errors: {
      invalidEmail: "Correo electrónico no válido.",
      passwordTooShort: "La contraseña debe tener al menos 12 caracteres.",
      passwordsDoNotMatch: "Las contraseñas no coinciden.",
      generic: "Inicio de sesión imposible. Verifique sus credenciales o inténtelo más tarde.",
      emailRequired: "El correo electrónico es obligatorio.",
      invalidCredentials: "Correo electrónico o contraseña incorrectos.",
      accountLocked: "Cuenta bloqueada. Contacte a su administrador.",
      sessionExpired: "Su sesión ha expirado. Por favor, inicie sesión de nuevo.",
    },
  },
  legal: {
    privacy: {
      title: "Compromiso de confidencialidad de Aon",
      updated: "Este texto ha sido actualizado: léalo de nuevo y acéptelo.",
      accept: "He leído y acepto el compromiso de confidencialidad de Aon",
      enter: "Acceder a mi espacio",
      logout: "Cerrar sesión",
      error: "No se ha podido registrar su aceptación. Inténtelo de nuevo o contacte a su asesor.",
      impersonation_banner: "Este empleado aún no ha aceptado el compromiso de confidencialidad.",
    },
    ia: {
      learn_more: "Más información",
      mention_default:
        "Contenido generado por inteligencia artificial (OpenAI). Su nombre, apellido y correo electrónico no se transmiten, y sus datos no se utilizan para entrenar los modelos.",
      conditions_default: `NOA utiliza un servicio de inteligencia artificial (OpenAI, a través de su interfaz de programación) para dos usos: preparar una síntesis de su expediente (análisis Noa) y responder a sus preguntas generales sobre la jubilación (asistente).

- Datos transmitidos: únicamente la información útil para el análisis (carrera, resultados de cálculo, situación familiar, deseos). Su nombre, apellido y dirección de correo electrónico no se transmiten.
- Sin entrenamiento: los datos enviados por la plataforma no se utilizan para entrenar los modelos del proveedor.
- Conservación: el proveedor puede conservar las solicitudes un máximo de 30 días, por seguridad y prevención de abusos, y luego las elimina.
- Localización: el proveedor puede tratar los datos fuera de la Unión Europea, en el marco de las garantías previstas por el RGPD.
- Sin decisión automatizada: el análisis es una ayuda. Es revisado por un consultor de Aon antes de comunicárselo, salvo en los recorridos 100 % digitales, donde se presenta como una ayuda orientativa.`,
    },
  },
  footer: {
    legalDocuments: "Documentos legales (nueva pestaña)",
    builtBy: "Plataforma creada por Aon France",
    legal: "© 2026 Aon France. 31-35 rue de la Fédération, 75015 Paris.",
    privacy: "Privacidad",
    terms: "Condiciones",
    contact: "Contacto",
    dataProtection: "Protección de datos",
    legalNotice: "Aviso legal",
    complaint: "Reclamación de cliente",
  },
  salariesView: {
    kicker_admin: "Administración",
    kicker_drh: "Espacio RRHH",
    kicker_aon: "Producción Aon",
    subtitle_admin: "Beneficiarios de las operaciones BRI. Creación manual o importación CSV.",
    subtitle_drh: "Sus empleados dentro de su perímetro. Creación manual o importación CSV.",
    subtitle_aon: "Los expedientes de su perímetro. Creación manual o importación CSV.",
    item_salarie: "empleado",
    items_salarie: "empleados",
    item_dossier: "expediente",
    items_dossier: "expedientes",
    import_file: "Importar un archivo",
    new_item: "Nuevo {{item}}",
    search: "Buscar",
    search_placeholder: "Apellido, nombre, matrícula, correo…",
    filter_society: "Empresa",
    filter_operation: "Operación",
    filter_type: "Tipo",
    filter_urgence: "Urgencia",
    urgents_only: "Urgentes",
    badge_urgent: "Urgente",
    all_f: "Todas",
    all_m: "Todos",
    vip: "VIP",
    standard: "Estándar",
    empty_filtered_title: "Ningún resultado con estos filtros",
    empty_title: "Ningún {{item}} por el momento",
    empty_filtered_desc: "Ajuste sus filtros o cree una nueva ficha.",
    confidential_masked_title: "Datos de los empleados ocultos: sociedad confidencial",
    confidential_masked_desc:
      "Los datos personales de los empleados de esta sociedad solo son accesibles para los super-admins y los internos de Aon autorizados.",
    empty_desc: "Importe un archivo CSV o cree fichas manualmente.",
    count: "{{count}} {{item}}",
    badge_exited: "Salido",
    badge_outgoing: "Saliente el {{date}}",
    filter_depart: "Salida",
    outgoing_only: "Salientes",
    exited_only: "Salidos",
    badge_account: "Cuenta activada",
    open_dossier: "El expediente",
    open_dossier_title: "Abrir el expediente (recorrido de jubilación)",
    view_sheet: "Ver la ficha",
    edit: "Modificar",
    delete: "Eliminar",
    send_invitation: "Enviar una invitación",
    resend_link: "Reenviar un enlace de conexión",
    none_dossier: "Ningún expediente",
    change_status: "Cambiar el estado",
    change_status_aria: "Cambiar el estado del expediente",
    delete_title: "¿Eliminar {{name}}?",
    delete_desc: "También se eliminarán todos los expedientes asociados a este {{item}}.",
    delete_irreversible: "Esta acción es irreversible.",
    delete_confirm: "Eliminar definitivamente",
    status_title: "Cambiar el estado del expediente",
    status_reason_label: "Motivo (opcional, registrado en el historial)",
    status_reason_placeholder: "Ej. documentos aportados, BRI entregado…",
    status_confirm: "Validar el cambio",
    status_incomplete_warn: "Este expediente aún no está completo",
    status_incomplete_body:
      "(estado actual: {{status}}). Aun así puede cambiar su estado, pero pueden faltar elementos en el balance.",
    status_updated: "Estado actualizado: {{status}}.",
    status_error: "Error al cambiar el estado",
    invitation_sent: "Invitación enviada a {{recipient}}.",
    invitation_error: "Error al enviar",
    preview_error: "Error al previsualizar",
    send_invitation_confirm: "Enviar la invitación",
    invitation_preview_title: "Invitación: {{name}}",
    email_preview: "Vista previa del correo",
    preview_desc: "Verifique el contenido antes de enviar el enlace mágico al {{item}}.",
    category_cadre: "Ejecutivo",
    category_oetam: "OETAM",
    category_dirigeant: "Directivo",
    close: "Cerrar",
  },
  relancesBoard: {
    kicker_aon: "Seguimiento Aon",
    kicker_rh: "Seguimiento RRHH",
    title: "Recordatorios",
    description:
      "Realice el seguimiento de los empleados cuyo expediente espera una acción por su parte.",
    kpi_to_relance: "Por recordar",
    kpi_to_relance_hint: "Expedientes a la espera del empleado",
    kpi_due: "Por volver a contactar",
    kpi_due_hint: "Recordatorio planificado vencido",
    kpi_never: "Nunca recordados",
    kpi_never_hint: "Ningún recordatorio registrado",
    kpi_month: "Recordatorios este mes",
    kpi_month_hint: "Correo + teléfono",
    kpi_total: "Total de recordatorios",
    kpi_total_hint: "En el perímetro mostrado",
    search_placeholder: "Buscar un empleado, matrícula, empresa…",
    only_mine: "Solo mis expedientes",
    filter_operation_all: "Todas las operaciones",
    filter_operation_aria: "Filtrar por operación",
    filter_status_all: "Todos los estados",
    filter_status_aria: "Filtrar por estado del expediente",
    queue_title: "Cola de recordatorios ({{count}})",
    without_dossier: "Sin expediente",
    operation_employees: "Empleados",
    operation_employees_hint: "Empleados de la operación según los filtros",
    operation_queue_title: "Empleados de la operación ({{count}})",
    operation_scope_hint:
      "Esta lista incluye a los empleados sin expediente. Seleccionar todos incluye a quienes tienen un correo y cumplen los filtros, en todas las páginas. Se excluyen los rechazos de contacto y las salidas.",
    operation_empty_title: "Ningún empleado coincide con estos filtros",
    operation_empty_desc:
      "Compruebe la operación y los filtros. Se excluyen los empleados que rechazaron el contacto o tienen una fecha de salida.",
    load_error: "No se pudieron cargar los empleados. Recargue la página para volver a intentarlo.",
    queue_empty_title: "Ningún recordatorio pendiente",
    queue_empty_desc: "Todos los expedientes de su perímetro están al día o avanzados.",
    recent_title: "Actividad reciente",
    recent_empty_title: "Aún no hay recordatorios",
    recent_empty_desc: "Los recordatorios registrados aparecerán aquí.",
    never_relanced: "Nunca recordado",
    last_relance: "Último recordatorio {{when}}",
    relance_count_one: "{{count}} recordatorio",
    relance_count_other: "{{count}} recordatorios",
    badge_due: "Por volver a contactar",
    badge_planned: "Previsto",
    email_title: "Recordar a {{email}} por correo",
    call_title: "Llamar a {{phone}}",
    relance: "Recordar",
    never: "Nunca recordado",
    today: "Hoy",
    yesterday: "Ayer",
    days_ago: "Hace {{count}} d",
    weeks_ago: "Hace {{count}} sem",
    months_ago: "Hace {{count}} meses",
    channel_email: "Correo",
    channel_phone: "Teléfono",
    outcome_repondu: "Respondió",
    outcome_pas_de_reponse: "Sin respuesta",
    outcome_message_laisse: "Mensaje dejado",
    outcome_a_rappeler: "Volver a llamar",
    outcome_refus: "Rechazo",
    outcome_injoignable: "Ilocalizable",
    drawer_title: "Recordar a {{name}}",
    drawer_title_default: "Recordar",
    open_dossier: "Abrir el expediente",
    send_email: "Enviar un correo de recordatorio",
    no_email: "Ninguna dirección de correo conocida",
    record_title: "Registrar un recordatorio",
    notes_placeholder: "Comentario de seguimiento (respuesta obtenida, próxima acción…)",
    outcome_label_call: "Resultado de la llamada",
    outcome_label_relance: "Resultado del recordatorio",
    outcome_none: "No indicado",
    next_relance_label: "Próximo recordatorio previsto",
    record_submit: "Registrar el recordatorio",
    save_error: "Error al guardar",
    history_title: "Historial ({{count}})",
    history_empty: "Ningún recordatorio registrado.",
    auto: "Auto",
    by_author: "por {{author}}",
    next_relance_history: "Próximo recordatorio previsto {{date}}",
    delete_relance_aria: "Eliminar el recordatorio",
    delete: "Eliminar",
    delete_title: "¿Eliminar este recordatorio?",
    delete_desc: "La entrada se eliminará definitivamente del registro de recordatorios.",
    not_provided: "No indicado",
    select_all: "Seleccionar todo",
    deselect_all: "Deseleccionar todo",
    select_aria: "Seleccionar a {{name}}",
    selected_count_one: "{{count}} empleado seleccionado",
    selected_count_other: "{{count}} empleados seleccionados",
    clear_selection: "Cancelar",
    export_excel: "Exportar a Excel",
    export_hint: "Descarga la lista mostrada y el registro de recordatorios en formato Excel",
    export_error: "No se pudo generar la exportación",
    export_sheet_rows: "Recordatorios",
    export_sheet_journal: "Registro",
    export_col_salarie: "Empleado",
    export_col_matricule: "Matrícula",
    export_col_societe: "Empresa",
    export_col_operation: "Operación",
    export_col_statut: "Estado del expediente",
    export_col_email: "Email",
    export_col_telephone: "Teléfono",
    export_col_relance_count: "Nº recordatorios",
    export_col_last_relance_at: "Último recordatorio",
    export_col_last_channel: "Último canal",
    export_col_last_outcome: "Último resultado",
    export_col_next_relance_at: "Próximo recordatorio",
    export_col_is_due: "Pendiente",
    export_col_relance_at: "Fecha",
    export_col_channel: "Canal",
    export_col_outcome: "Resultado",
    export_col_author: "Autor",
    export_col_automatic: "Automático",
    export_col_notes: "Notas",
    export_yes: "Sí",
    export_no: "No",
    bulk_send_email: "Email agrupado",
    bulk_title: "Recordatorio agrupado por email",
    bulk_desc:
      "Una misma plantilla, personalizada automáticamente para cada empleado (nombre, empresa, operación).",
    bulk_recipients_one: "{{count}} destinatario",
    bulk_recipients_other: "{{count}} destinatarios",
    bulk_template: "Plantilla",
    bulk_preview_note_one: "Vista previa mostrada para {{name}}.",
    bulk_preview_note_other:
      "Vista previa mostrada para {{name}}. El email se personalizará para cada uno de los {{count}} destinatarios.",
    bulk_no_recipient: "Ningún destinatario con dirección de email conocida.",
    bulk_excluded_one: "{{count}} empleado sin dirección de email, excluido del envío:",
    bulk_excluded_other: "{{count}} empleados sin dirección de email, excluidos del envío:",
    bulk_done_one: "{{count}} email enviado.",
    bulk_done_other: "{{count}} emails enviados.",
    bulk_failures_one: "{{count}} envío fallido:",
    bulk_failures_other: "{{count}} envíos fallidos:",
    bulk_send_one: "Enviar a {{count}} destinatario",
    bulk_send_other: "Enviar a {{count}} destinatarios",
    bulk_sending: "Enviando {{sent}}/{{total}}…",
    bulk_send_error: "Fallo en el envío",
    bulk_customize: "Personalizar el mensaje",
    bulk_reset: "Restablecer",
    bulk_subject: "Asunto",
    bulk_body: "Mensaje",
    bulk_customize_hint:
      "Contenido HTML: las variables (nombre, apellido, empresa, enlace del expediente…) siguen personalizadas para cada destinatario. El encabezado y el pie de página de Aon se añaden automáticamente. La vista previa se actualiza en tiempo real.",
  },
  roles: {
    salarie: "Empleado",
    drh: "Director RRHH",
    consultant_aon: "Consultor Aon",
    chef_projet_aon: "Jefe de proyecto Aon",
    admin_aon: "Admin Aon",
    desc_salarie: "Beneficiario del BRI",
    desc_drh: "RRHH / Director RRHH cliente",
    desc_consultant_aon: "Producción de BRI",
    desc_chef_projet_aon: "Piloto operación Aon",
    desc_admin_aon: "Administración de la plataforma",
    no_role: "Ningún rol asignado",
  },
  statuses: {
    non_demarre: "No iniciado",
    demarre_non_complete: "Iniciado",
    complete_incomplet: "Completado — incompleto",
    complete_complet: "Completado — completo",
    en_production: "En producción",
    a_restituer: "Pendiente de entrega",
    restitue_avec_rdv: "Entregado (reunión)",
    restitue_sans_rdv: "Entregado",
    maj_sans_restitution: "Actualizado — sin reunión",
    maj_avec_restitution: "Actualizado — con reunión",
    sans_suite: "Cerrado",
    desc_non_demarre: "El empleado aún no ha activado su expediente.",
    desc_demarre_non_complete: "El empleado ha comenzado a completar su expediente.",
    desc_complete_incomplet: "Enviado pero faltan documentos o información.",
    desc_complete_complet: "El expediente está listo para producción.",
    desc_en_production: "El consultor Aon prepara su Balance de Jubilación.",
    desc_a_restituer: "El BRI está listo — se planificará la reunión de entrega.",
    desc_restitue_avec_rdv: "El BRI fue entregado en una reunión.",
    desc_restitue_sans_rdv: "El BRI fue entregado sin reunión.",
    desc_maj_sans_restitution: "Se produjo una actualización del BRI sin nueva reunión.",
    desc_maj_avec_restitution: "Una actualización fue entregada.",
    desc_sans_suite: "El expediente fue cerrado sin BRI.",
    group_draft: "Borrador",
    group_review: "En revisión",
    group_production: "Producción",
    group_delivered: "Entregado",
    group_closed: "Cerrado",
  },
  journey: {
    demarrage: "Inicio",
    completion: "Completar",
    production: "Producción",
    restitution: "Entrega",
    suivi: "Seguimiento",
    desc_demarrage: "Activación de la cuenta y primeros intercambios.",
    desc_completion: "Documentos, situación personal, escenarios.",
    desc_production: "Cálculo de la pensión y preparación del BRI.",
    desc_restitution: "Presentación del BRI por un consultor Aon.",
    desc_suivi: "Actualizaciones posteriores del BRI.",
  },
  app: {
    evaluation: {
      title: "Evaluación del servicio",
      desc: "Su balance está disponible: ayúdenos a mejorar el acompañamiento.",
      satisfaction: "Su satisfacción global",
      pick: "Elija una nota",
      satisfaction_1: "Muy insatisfecho",
      satisfaction_2: "Insatisfecho",
      satisfaction_3: "Neutro",
      satisfaction_4: "Satisfecho",
      satisfaction_5: "Muy satisfecho",
      nps: "¿Recomendaría este acompañamiento a un colega?",
      nps_min: "En absoluto",
      nps_max: "Totalmente",
      optional: "(opcional)",
      comment: "¿Un comentario que transmitirnos?",
      comment_placeholder: "Lo que le fue útil, lo que podría mejorarse…",
      submit: "Enviar mi evaluación",
      update: "Actualizar",
      sending: "Enviando…",
      edit: "Modificar mi evaluación",
      recorded: "Gracias, su evaluación ha sido registrada.",
      stars: "{{count}} estrella(s)",
    },
    appetences: {
      title: "Sus preferencias de jubilación",
      title_salarie: "Mis deseos",
      required_badge: "Obligatorio para acceder a su BRI",
      optional_badge: "Opcional",
      confirm: "Validar mis deseos",
      update: "Actualizar",
      confirmed_on: "Deseos registrados el {{date}}",
      description:
        "Sus deseos para el futuro: orientan el acompañamiento y alimentan el reporting de su empresa (de forma anonimizada).",
      souhait_depart_au_plus_tot: "Jubilarse lo antes posible",
      souhait_depart_au_plus_tard: "Jubilarse lo más tarde posible",
      souhait_rupture_conventionnelle: "Interés en una rescisión de mutuo acuerdo",
      souhait_temps_partiel_progressive: "Tiempo parcial / jubilación progresiva",
      interet_rachat_trimestres: "Interés en el rescate de trimestres",
      interet_cumul_emploi_retraite: "Interés en compaginar empleo y jubilación",
      souhait_date_depart: "Fecha de jubilación deseada",
      hint: "Cada respuesta se guarda inmediatamente.",
    },
    scenarios: {
      des_que_possible: "Lo antes posible",
      des_que_possible_desc:
        "Jubilación lo antes posible, en cuanto pueda abonarse una primera pensión (a menudo con penalización).",
      des_que_possible_result: "Jubilación lo antes posible",
      age_legal: "A la edad legal",
      age_legal_desc:
        "Jubilación a la edad legal de apertura de derechos, que depende de su año de nacimiento.",
      age_legal_perso: "Su edad legal: {{age}} (salida posible el {{date}}).",
      age_legal_result: "Jubilación a la edad legal",
      age_62: "A los 62 años",
      age_62_desc:
        "Jubilación anticipada a los 62 años (generalmente con penalización si no se alcanza la tasa plena).",
      age_62_result: "Jubilación a los 62 años",
      age_65: "A los 65 años",
      age_65_desc: "Jubilación a los 65 años.",
      age_65_result: "Jubilación a los 65 años",
      taux_plein_naturel: "A tasa plena",
      taux_plein_naturel_desc:
        "Jubilación en cuanto se alcanza la tasa plena automática (entre 65 y 67 años según su fecha de nacimiento).",
      taux_plein_naturel_result: "Jubilación a tasa plena (pensión completa)",
      age_67: "A los 67 años (tasa plena garantizada)",
      age_67_desc:
        "Jubilación a los 67 años, edad de tasa plena automática sea cual sea el número de trimestres.",
      rachat_taux_plein: "Con compra de trimestres para la tasa plena",
      rachat_taux_plein_desc:
        "Jubilación a la edad legal tras comprar los trimestres que faltan (máximo 12) para obtener la tasa plena, con coste y plazo de amortización estimados.",
      rachat_taux_seul: "Compra a la edad legal (solo tasa)",
      rachat_taux_seul_desc: "Compra de trimestres que afecta solo a la tasa de liquidación.",
      rachat_taux_seul_result: "Jubilación a la edad legal con compra (solo tasa)",
      rachat_taux_plein_result: "Jubilación a la edad legal tras compra de trimestres",
      date_imposee: "Fecha fijada por la empresa",
      date_imposee_desc: "Fecha de salida solicitada por su empresa para toda la operación.",
      age_67_result: "Jubilación a los 67 años",
      date_departure: "Jubilación el {{date}}",
      date_chosen: "Jubilación en una fecha elegida",
      fallback: "Escenario",
    },
    nav: {
      group_employee: "Mi espacio",
      group_aon: "Espacio Aon",
      group_drh: "Espacio RRHH",
      group_admin: "Administración",
      dashboard: "Panel de control",
      parcours: "Mi recorrido de jubilación",
      historique: "Historial de mis cálculos",
      dossier: "Mi expediente",
      documents: "Mis documentos",
      simulations: "Mis simulaciones",
      bri: "Mi BRI",
      messages: "Mensajería",
      rdv: "Citas",
      formations: "Formaciones",
      profile: "Mi perfil",
      settings: "Configuración",
      help: "Ayuda y contactos",
      evaluation: "Evaluación del servicio",
      // RRHH
      operations: "Operaciones",
      salaries: "Empleados",
      relances: "Seguimientos",
      reporting: "Informes",
      synthese_mission: "Síntesis de la misión",
      // Aon
      mes_dossiers: "Mis expedientes",
      calendrier: "Mi agenda",
      bibliotheque: "Biblioteca",
      revue: "Revisión de calidad",
      anomalies: "Biblioteca de anomalías",
      equipe: "Mi equipo",
      pilotage: "Pilotaje",
      // Admin
      onboarding: "Nueva empresa",
      tenants: "Clientes",
      utilisateurs: "Usuarios",
      email_templates: "Plantillas de correo",
      branding: "Marca",
      audit: "Auditoría",
      roadmap: "Hoja de ruta",
      rachat_bareme: "Baremo de rescate",
      annexes_bri: "Anexos BRI",
      rgpd: "RGPD",
      controle_qualite: "Ficha de autocontrol",
      document_types: "Tipos de documentos",
      referentiels: "Actualidad de los referenciales",
      referentiel_professions: "Referencial de profesiones",
      conventions_collectives: "Convenios colectivos",
      parametres: "Configuración",
      couts_ia: "Costes IA",
      stats_usage: "Estadísticas de uso",
      external_services: "Servicios externos",
      suivi_messages: "Seguimiento de mensajes",
    },
    header: {
      greeting_morning: "Buenos días",
      greeting_afternoon: "Buenas tardes",
      greeting_evening: "Buenas noches",
      search_placeholder: "Buscar…",
      open_menu: "Abrir menú",
      change_language: "Cambiar idioma",
      breadcrumb: "Migas de pan",
    },
    dashboard: {
      welcome_back: "Bienvenido de nuevo",
      no_dossier_title: "Ningún expediente activo",
      no_dossier_body:
        "Su expediente aún no ha sido creado. Si su empleador acaba de inscribirle, espere unos minutos o contacte con su departamento de RRHH.",
      kpi_status: "Estado del expediente",
      kpi_consultant: "Consultor Aon",
      kpi_next_rdv: "Próxima cita",
      kpi_bri_type: "Tipo de BRI",
      no_consultant: "Por asignar",
      no_rdv: "Ninguna cita planificada",
      progression: "Progresión",
      actions_title: "Acciones a realizar",
      actions_empty: "Está al día, nada que hacer por el momento ✨",
      action_upload_ris: "Subir su informe de carrera (RIS)",
      action_upload_agirc: "Subir su informe Agirc-Arrco",
      action_upload_bulletin: "Subir su última nómina",
      action_complete_profile: "Completar sus datos de contacto",
      action_select_scenarios: "Elegir sus escenarios de simulación",
      action_book_rdv: "Reservar su cita de entrega",
      recent_activity: "Actividad reciente",
      urgent_title: "Expediente marcado urgente",
      urgent_body:
        "Su asesor Aon lo está tratando con prioridad. Su contacto de RR. HH. solo ve que es prioritario.",
      urgent_auto: "Marcado prioritario automáticamente (salida próxima)",
    },
    notFound: {
      title: "Página no encontrada",
      description: "Esta dirección no corresponde a ninguna página de su espacio.",
      back_home: "Volver al inicio",
    },
    profile: {
      title: "Mi perfil",
      subtitle: "Sus datos de contacto y preferencias personales.",
      section_identity: "Identidad",
      section_contact: "Datos de contacto",
      section_preferences: "Preferencias",
      first_name: "Nombre",
      last_name: "Apellido",
      civility: "Tratamiento",
      email: "Correo electrónico",
      phone: "Teléfono",
      locale: "Idioma de la interfaz",
      saved: "Cambios guardados.",
      save: "Guardar cambios",
      section_security: "Seguridad",
      contact_pref_title: "Preferencias de contacto",
      contact_pref_desc:
        "Puede pedir al equipo que deje de hacer seguimiento de su expediente. Conserva el acceso a su espacio y puede cambiar de opinión en cualquier momento.",
      contact_pref_label: "No deseo que me contacten sobre mi expediente",
      contact_pref_on: "Ya no recibirá recordatorios (correo, teléfono) del equipo.",
      contact_pref_off: "El equipo puede hacer seguimiento si su expediente sigue incompleto.",
      security_description: "Modifique su contraseña de acceso.",
      new_password: "Nueva contraseña",
      confirm_password: "Confirmar contraseña",
      password_hint: "Mínimo 8 caracteres.",
      password_too_short: "La contraseña debe tener al menos 8 caracteres.",
      password_mismatch: "Las contraseñas no coinciden.",
      change_password: "Cambiar contraseña",
      password_saved: "Contraseña actualizada.",
      mfa_title: "Doble autenticación",
      mfa_desc: "Proteja su cuenta con un código generado por una aplicación en su teléfono.",
      mfa_status_on: "2FA activada",
      mfa_status_off: "2FA no activada",
      mfa_required_badge: "Obligatoria para su perfil",
      mfa_enable: "Activar la doble autenticación",
      mfa_regenerate: "Regenerar mis códigos de recuperación",
      mfa_disable: "Desactivar la doble autenticación",
      mfa_codes_done: "He guardado mis nuevos códigos",
      mfa_error: "La operación ha fallado. Inténtelo de nuevo.",
      rgpd: {
        title: "Mis datos personales (RGPD)",
        description:
          "Ejercita sus derechos sobre sus datos: acceso, rectificación, supresión, oposición o limitación. Su solicitud será tratada en un plazo de un mes.",
        kind_label: "Tipo de solicitud",
        reason_label: "Precisaciones (opcional)",
        reason_placeholder: "Describa su solicitud si es necesario…",
        submit: "Enviar mi solicitud",
        submitted: "Solicitud registrada",
        my_requests: "Mis solicitudes ({{count}})",
        deposited: "Presentada el {{date}}",
      },
    },
    dossier: {
      title: "Mi expediente",
      subtitle: "Vista general de su expediente de jubilación.",
      tab_overview: "Resumen",
      tab_career: "Carrera",
      tab_family: "Situación familiar",
      tab_special: "Casos particulares",
      tab_scenarios: "Escenarios",
      not_assigned: "Aún no vinculado a una ficha de empleado.",
    },
    dossierDetail: {
      // Tabs
      tab_synthesis: "Resumen",
      tab_documents: "Documentos",
      tab_scenarios: "Escenarios",
      tab_career: "Carrera",
      tab_calculations: "Cálculos",
      tab_analysis: "Análisis Noa",
      tab_vip: "VIP",
      tab_appointments: "Citas",
      tab_history: "Historial",
      chomage_title: "Escenario de desempleo",
      chomage_desc:
        "Modeliza un periodo de desempleo antes de la jubilación, a partir de las fechas declaradas por el empleado.",
      chomage_active: "Activo",
      chomage_inactive: "No previsto",
      chomage_by_config: "Habilitado por la configuración de la operación.",
      chomage_request_cta: "Solicitar el escenario de desempleo",
      chomage_request_title: "Solicitar un escenario de desempleo",
      chomage_request_desc:
        "El escenario se tendrá en cuenta en el próximo cálculo, con las fechas indicadas por el empleado.",
      chomage_request_message: "Mensaje para el equipo Aon (opcional)",
      chomage_request_placeholder: "Ej.: baja acordada prevista para finales de 2027.",
      chomage_request_send: "Enviar la solicitud",
      chomage_request_received: "Escenario de desempleo solicitado el {{date}}",
      chomage_request_clear: "Retirar la solicitud",
      // Header
      not_found: "Expediente no encontrado",
      not_found_description: "Es posible que no tenga acceso a este expediente.",
      back_to_list: "← Volver a la lista",
      vip: "VIP",
      consultant: "Consultor:",
      me: "Yo",
      not_assigned: "no asignado",
      assign: "asignar",
      // Expediente urgente (B4)
      urgent_badge: "Urgente",
      urgence_delay_badge: "Plazo superado",
      urgent_detail_prefix: "desde el {{date}}",
      urgence_reason_depart_moins_6_mois: "Salida prevista en menos de 6 meses",
      urgence_reason_rupture_licenciement: "Ruptura o despido en curso",
      urgence_reason_decision_rapide: "Decisión que tomar rápidamente",
      urgence_reason_autre: "Otro",
      urgence_source_salarie: "empleado",
      urgence_source_consultant: "equipo Aon",
      urgence_source_automatique: "marcado automático",
      urgence_mark: "Marcar como urgente",
      urgence_lift: "Levantar la urgencia",
      urgence_lift_title: "¿Levantar la urgencia?",
      urgence_lift_desc:
        "El expediente perderá su distintivo de urgente. Esta acción queda registrada en el historial.",
      urgence_lift_desc_auto:
        "Esta urgencia se marcó automáticamente. Al levantarla, indica que no debe volver a marcarse: la tarea diaria ya no la reactivará.",
      urgence_dialog_title: "Marcar el expediente como urgente",
      urgence_dialog_desc:
        "El expediente aparecerá en primer lugar en las listas y se enviará una notificación al jefe de proyecto y al consultor asignados.",
      urgence_reason_label: "Motivo",
      urgence_reason_pick: "Elija un motivo",
      urgence_comment_label: "Comentario (opcional)",
      urgence_comment_ph: "Precisiones visibles únicamente para el equipo Aon.",
      urgence_history_title: "Historial de la urgencia",
      urgence_history_marked: "Marcado urgente",
      urgence_history_lifted: "Urgencia levantada",
      modify: "modificar",
      project_manager: "Jefe de proyecto:",
      reviewer: "Revisor:",
      restitution_consultant: "Consultor de restitución:",
      restitution_same_as_production: "Igual que el consultor de producción",
      release: "Liberar",
      open_file: "El expediente",
      edit_file: "Editar expediente",
      // Overview tab
      not_editable_warning:
        "Este expediente ya no está en fase de completación por el empleado. La modificación del expediente ahora se realiza solo en back-office.",
      identity: "Identidad",
      civility: "Civilidad",
      first_name: "Nombre",
      last_name: "Apellido",
      birth_name: "Apellido de nacimiento",
      birth_date: "Fecha de nacimiento",
      birth_place: "Lugar",
      email: "Email",
      phone: "Teléfono",
      career_current_company: "Carrera (empresa actual)",
      company: "Empresa",
      site: "Sitio",
      position: "Puesto",
      category: "Categoría",
      entry_date: "Fecha de entrada",
      presence: "Presencia",
      present: "Presente",
      left: "Salido",
      declared_salary: "Salario declarado",
      confirmed_salary: "Salario confirmado",
      family: "Familia",
      situation: "Situación",
      spouse_birth: "Cónyuge — nacimiento",
      wedding_date: "Fecha de matrimonio",
      children_count: "Número de hijos",
      children_charge_retirement: "Hijos a cargo jubilación",
      children_handicap: "Hijos en handicap",
      yes: "Sí",
      no: "No",
      special_cases: "Casos particulares",
      no_special_cases: "Ningún caso particular declarado.",
      cet_jours: "Días de CET ahorrados",
      cet_avant_depart: "Uso del CET antes de la salida",
      children_quarters_title: "Trimestres por hijo",
      children_quarters_hint:
        "Trimestres de bonificación retenidos por hijo. Vacío = regla general (8 trimestres, 4 para un hijo nacido muerto). Ajuste en caso de reparto entre progenitores, adopción o régimen especial.",
      children_quarters_total: "{{count}} trimestres en total",
      children_quarters_empty: "Ningún hijo declarado en la etapa Familia.",
      child_n: "Hijo {{index}}",
      child_stillborn: "Nacido muerto",
      child_handicap: "Discapacidad",
      child_quarters_label: "Trimestres",
      file_metadata: "Metadatos del expediente",
      id: "ID",
      bri_type: "Tipo BRI",
      created_on: "Creado el",
      submitted_on: "Enviado el",
      control_n1: "Control N1",
      control_n2: "Control N2",
      restored_on: "Restituido el",
      // Documents tab
      no_document_uploaded: "Ningún documento subido",
      no_document_description:
        "El empleado aún no ha proporcionado documentos. Haga un seguimiento si es necesario.",
      close: "Cerrar",
      reject_document: "Rechazar este documento",
      reject_reason: "Motivo del rechazo",
      reject_placeholder: "Ej. ilegible, documento incompleto, tipo de documento incorrecto…",
      reject_button: "Rechazar",
      document_rejected_default: "Documento rechazado",
      launch_ris_extraction: "Lanzar extracción RIS",
      launch_analysis: "Lanzar análisis",
      ris_extraction_description:
        "El RIS será transmitido al motor de cálculo para extraer automáticamente períodos de carrera, puntos y trimestres, alimentando la pestaña <strong>Carrera</strong>.",
      ris_revenue_note:
        "El ingreso de fin de carrera es recalculado (des-capado del PASS) por el motor.",
      validated: "Validado",
      rejected: "Rechazado",
      to_validate: "Para validar",
      parsed: "Parseado",
      parse_this_ris: "Parsear este RIS",
      uploaded_on: "Subido el",
      reason: "Motivo:",
      // Scenarios tab
      no_scenario_selected: "Ningún escenario seleccionado",
      no_scenario_description: "El empleado elegirá sus escenarios al completar el expediente.",
      selected_by: "por",
      inactive: "inactivo",
      selected_on: "Seleccionado el",
      // History tab
      no_history: "Ningún historial",
      current_status: "Estado actual:",
      // Diario de consentimientos
      consents_title: "Consentimientos",
      consent_privacy: "Confidencialidad Aon aceptada, versión {{version}}",
      consent_share: "Compartición con el empleador: {{from}} → {{to}}",
      share_full: "informe completo",
      share_date_only: "solo la fecha de salida",
      share_none: "ninguna información",
      share_initial: "sin elección",
      // Appointments tab
      appointments_count_one: "{{count}} cita",
      appointments_count_other: "{{count}} citas",
      schedule_appointment: "Programar una cita",
      no_appointment: "Ninguna cita",
      schedule_description: "Programe una cita de restitución con el empleado.",
      no_appointment_description: "Aún no se ha programado ninguna cita para este expediente.",
      open_meeting_link: "Abrir enlace de reunión",
      realized: "Realizado",
      cancel: "Cancelar",
      cancel_appointment: "Cancelar esta cita",
      appointment_cancellation_note:
        "El espacio de tiempo asociado volverá a estar disponible. El empleado no será notificado automáticamente en esta versión.",
      // Status transitions
      change_status: "Cambiar estado",
      status_change_description: "Cambio de estado",
      reason_optional: "Razón (opcional, trazada en el historial)",
      reason_placeholder: "Ej. empleado proporcionó documentos faltantes, cita programada…",
      validate_change: "Validar cambio",
      // Take over menu
      reassign: "Reasignar",
      assign_to_myself: "Asignarme a mí mismo",
      take_charge: "Tomar a cargo",
      i_become_consultant: "Me convierto en el consultor.",
      assign_to_consultant: "Asignar a un consultor…",
      choose_team_member: "Elegir un miembro del equipo.",
      // Dynamic labels
      reject_document_description: "Documento « {{filename}} ». El empleado será notificado.",
      parse_document_description: "Documento « {{filename}} ».",
      parsed_with_count_one: "{{count}} período",
      parsed_with_count_other: "{{count}} períodos",
      cancel_appointment_description: "Cita del {{date}}.",
      selected_on_date: "Seleccionado el {{date}}",
      uploaded_on_date: "Subido el {{date}}",
      reason_value: "Motivo: {{reason}}",
      full_rate_age_value: "{{years}} años{{months}}",
      full_rate_age_months: " {{months}} m",
      appointment_consultant: "Consultor: {{name}}",
      // Calculation tab
      retirement_calculation: "Cálculo jubilación",
      open_retirement_journey: "Abrir recorrido jubilación",
      no_calculation_available:
        "Ningún cálculo disponible. Importe un RIS, luego lance el cálculo desde el recorrido jubilación.",
      monthly_gross_pension: "Pensión mensual bruta",
      monthly_net_pension: "Pensión mensual neta",
      replacement_rate: "Tasa de reemplazo",
      validated_quarters: "Trimestres validados",
      contributed_quarters: "Trimestres cotizados",
      deemed_contributed_quarters: "Reputados cotizados",
      full_rate_age: "Edad tasa completa",
      // Appointment channels
      video: "Video",
      telephone: "Teléfono",
      in_person: "Presencial",
      // Appointment statuses
      proposed: "Propuesto",
      planned: "Planificado",
      cancelled: "Cancelado",
      absent: "Ausente",
      // Tracking
      file_tracking: "Seguimiento del expediente",
      closed_short: "Cerrado",
      to_do: "Por hacer",
      status_non_demarre: "No iniciado",
      status_demarre_non_complete: "Iniciado",
      status_complete_incomplet: "Completado — incompleto",
      status_complete_complet: "Completado — completo",
      status_en_production: "En producción",
      status_a_restituer: "Para restituir",
      status_restitue_avec_rdv: "Restituido (cita)",
      status_restitue_sans_rdv: "Restituido",
      status_maj_sans_restitution: "Actualización — sin restitución",
      status_maj_avec_restitution: "Actualización — con restitución",
      status_sans_suite: "Cerrado sin seguimiento",
      status_non_demarre_description: "El empleado aún no ha activado su expediente.",
      status_demarre_non_complete_description: "El empleado ha empezado a completar su expediente.",
      status_complete_incomplet_description: "Enviado pero faltan documentos o información.",
      status_complete_complet_description: "El expediente está listo para pasar a producción.",
      status_en_production_description:
        "El consultor Aon está preparando su Balance de Jubilación.",
      status_a_restituer_description: "El BRI está listo: se programará la restitución.",
      status_restitue_avec_rdv_description: "El BRI fue restituido en una cita.",
      status_restitue_sans_rdv_description: "El BRI fue entregado sin cita.",
      status_maj_sans_restitution_description:
        "Se produjo una actualización del BRI sin un nuevo intercambio.",
      status_maj_avec_restitution_description: "Se restituyó una actualización.",
      status_sans_suite_description: "El expediente se cerró sin BRI.",
      journey_step_demarrage: "Inicio",
      journey_step_demarrage_description: "Activación de la cuenta y primeros intercambios.",
      journey_step_completion: "Completación",
      journey_step_completion_description: "Documentos, situación, escenarios.",
      journey_step_production: "Producción",
      journey_step_production_description: "Cálculo de la pensión y preparación del BRI.",
      journey_step_restitution: "Restitución",
      journey_step_restitution_description: "Presentación del BRI por un consultor Aon.",
      journey_step_suivi: "Seguimiento",
      journey_step_suivi_description: "Actualizaciones posteriores del BRI.",
      next_action_non_demarre:
        "Invitar / hacer seguimiento al empleado para que active su espacio.",
      next_action_demarre_non_complete:
        "El empleado debe completar su expediente (información, documentos, escenarios).",
      next_action_complete_incomplet:
        "Faltan documentos o información: hacer seguimiento al empleado para completar.",
      next_action_complete_complet: "Expediente listo: asignar un consultor y pasar a producción.",
      next_action_en_production: "Cálculos y redacción del BRI en curso, luego controles N1 / N2.",
      next_action_a_restituer: "BRI listo: programar la cita de restitución con el empleado.",
      next_action_restitue_avec_rdv:
        "Bilan restituido: recoger opinión y tratar solicitudes de actualización.",
      next_action_restitue_sans_rdv:
        "Bilan restituido: recoger opinión y tratar solicitudes de actualización.",
      next_action_maj_sans_restitution:
        "Actualización producida: nada que hacer, seguimiento continuo.",
      next_action_maj_avec_restitution:
        "Actualización producida: nada que hacer, seguimiento continuo.",
      next_action_sans_suite: "Expediente cerrado sin seguimiento.",
      // BRI
      bri_delivered: "BRI entregado",
      bri_description:
        "Genera el PDF del Balance de Jubilación Individual — el mismo documento descargable desde el recorrido jubilación del empleado.",
      pptx_source_title: "Fuente PowerPoint (expediente VIP)",
      pptx_source_hint:
        "Las mismas páginas que el PDF, en formas editables, para retrabajar la restitución. Las ilustraciones de la plantilla se incluyen como imágenes de alta resolución.",
      pptx_source_download: "Descargar el .pptx",
      generation_blocked: "Generación bloqueada.",
      n1_must_be_validated: "El control N1 debe ser validado.",
      n2_must_be_validated: "El control N2 debe ser validado.",
      generate_new_version: "Generar una nueva versión",
      generate_bri: "Generar el BRI",
      create_version_vX:
        "Crea una v{{nextVersion}} (reemplaza la v{{currentVersion}} como versión actual).",
      first_bri_v1: "Primer BRI entregado (v1).",
      regenerate: "Regenerar",
      previous_versions: "Versiones anteriores ({{count}})",
      send_bri_to_employee: "Enviar el BRI al empleado",
      send_bri_description:
        "La versión {{version}} estará disponible en el espacio del empleado, quien será notificado por email.",
      send: "Enviar",
      employee_will_receive_email:
        "El empleado recibirá un email invitándole a consultar su Balance de Jubilación.",
      bri_version: "Versión {{version}}",
      draft: "Borrador",
      current: "Actual",
      sent_on: "Enviado el {{date}}",
      not_sent_to_employee: "No enviado al empleado",
      send_to_employee: "Enviar al empleado",
      open: "Abrir",
      bri_selection_title: "Simulaciones presentadas en el BRI",
      bri_selection_help:
        "El BRI presentará únicamente las simulaciones marcadas, en este orden. La elección se aplica a la próxima generación; los BRI ya producidos no cambian.",
      bri_selection_source_consultant: "Elección del consultor",
      bri_selection_source_operation: "Configuración de la operación",
      bri_selection_source_all: "Todas las simulaciones",
      bri_selection_degraded_warning:
        "Ningún elemento de la selección está disponible en el último cálculo: el BRI presentará todas las simulaciones.",
      bri_selection_empty:
        "Ninguna simulación disponible: ejecute primero el cálculo del expediente.",
      bri_selection_on_demand: "Simulación a petición",
      bri_selection_progressive_title: "Jubilación progresiva: cuantías presentadas",
      bri_selection_save: "Guardar la selección",
      bri_selection_reset: "Volver a la elección por defecto",
      // Controls
      controls_self_control_sheet: "Hoja de autocontrol",
      controls_description:
        "Revisión a dos niveles a completar antes de poner a disposición el BRI.",
      sim_settings_title: "Parámetros de simulación",
      sim_settings_desc:
        "Límites heredados de la operación y desbloqueo eventual de este expediente.",
      sim_parcours_type: "Tipo de recorrido",
      sim_max_age: "Fecha de jubilación máxima",
      sim_rachat: "Compra de trimestres",
      sim_quota: "Simulaciones / 12 meses",
      sim_quota_value: "{{count}} por empleado",
      sim_quota_unlimited: "Ilimitado",
      sim_policy_taux_plein_naturel: "Tasa plena natural",
      sim_policy_age_65: "Hasta los 65 años",
      sim_policy_age_67: "Hasta los 67 años",
      sim_policy_libre: "Libre",
      sim_request_title: "El empleado solicitó una fecha específica el {{date}}",
      sim_unlock_label: "Permitir fechas libres en este expediente",
      sim_unlock_active: "Desbloqueado",
      sim_unlock_hint:
        "El empleado podrá simular cualquier fecha de jubilación, sin el límite de la operación.",
      controls_n1_production: "Control N1 — Autocontrol de producción",
      controls_n1_description:
        "Autocontrol realizado por el consultor a cargo del expediente (jefe de proyecto y admin como respaldo).",
      controls_n1_reserved_consultant:
        "Reservado al consultor a cargo del expediente, al jefe de proyecto o a un admin.",
      controls_unvalidate_n1_cascade: "Anular el N1 también anula el control N2.",
      controls_n2_project_manager: "Control N2 — Jefe de proyecto",
      controls_n2_description_available:
        "Control final por el jefe de proyecto antes de la restitución.",
      controls_n2_description_waiting: "Espera la validación N1 antes de estar disponible.",
      controls_validated: "Validado",
      controls_validated_by: "Validado por {{name}}",
      controls_bri_can_be_generated: "El BRI ya puede ser generado.",
      controls_progress:
        "{{doneRequired}}/{{totalRequired}} requeridos · {{doneTotal}}/{{totalTotal}} en total",
      controls_validate_level: "Validar N{{level}}",
      controls_validate_blocked: "Marque todos los puntos requeridos del N{{level}} para validar.",
      controls_reserved_project_manager: "Reservado al jefe de proyecto",
      controls_loading_grid: "Cargando cuadrícula…",
      controls_no_checkpoints_defined: "Ningún punto de control definido para este nivel.",
      controls_required: "Requerido",
    },
    salarieFollowup: {
      // Salarie follow-up
      account_management: "Gestión de la cuenta",
      account_management_description: "Formación, activación y conexión del empleado.",
      formation_followed: "Formación seguida",
      formation_marked_on: "Marcada el {{date}}",
      formation_question: "¿El empleado ha seguido la formación de jubilación?",
      trained_check_title: "Empleado formado — verificación del seguimiento:",
      logged_in: "Se ha conectado",
      last_login_on: "Última conexión el {{date}}",
      login_detected: "Conexión detectada",
      checking: "Verificación…",
      account_created_never_logged_in: "Cuenta creada pero nunca conectada",
      no_account_send_invitation: "Sin cuenta — enviar una invitación",
      file_complete: "Expediente completo",
      all_required_elements_provided: "Todos los elementos requeridos están proporcionados",
      elements_provided: "{{done}}/{{total}} elementos proporcionados",
      trained_but_issue: "Empleado formado pero {{issue}}",
      not_connected: "no conectado",
      file_incomplete: "expediente incompleto",
      follow_up_below: "— hacer seguimiento (ver módulo Seguimientos abajo).",
      not_yet_trained: "Empleado aún no formado",
      invite_to_training:
        "— invitar a una sesión de formación antes del seguimiento conexión/completitud.",
      account_activated: "Cuenta activada",
      account_created: "Cuenta creada",
      no_account_send_invitation_from_list: "Sin cuenta — enviar una invitación desde la lista",
      file_completeness: "Completitud del expediente",
      all_elements_present: "Todos los elementos requeridos están presentes.",
      elements_missing: "Faltan algunos elementos en el expediente.",
      no_file_yet: "Sin expediente: se creará en la primera conexión del empleado.",
      checklist_infos: "Información individual",
      checklist_ris: "Informe de carrera",
      checklist_agirc_arrco: "Informe Agirc-Arrco",
      checklist_bulletin: "Nómina diciembre N-1",
      checklist_profil: "Otros elementos según perfil (penosidad, discapacidad…)",
      checklist_hypotheses: "Configuración de hipótesis de cálculo",
      profile_requires_justification:
        "El perfil del empleado (casos particulares) requiere un justificante.",
      no_special_case_no_justification:
        "Ningún caso particular declarado: no se requiere justificante.",
      not_required: "No requerido",
      account_closure_title: "Cierre de la cuenta",
      account_closure_description: "Registra la salida del empleado (fecha y motivo).",
      account_closed_badge: "Cerrada",
      account_outgoing_badge: "Saliente el {{date}}",
      account_active_badge: "Activa",
      exit_date: "Fecha de salida",
      exit_reason: "Motivo de salida",
      exit_reason_unspecified: "No especificado",
      reactivate_account: "Reactivar la cuenta",
      close_account: "Cerrar la cuenta",
      active_description:
        "El empleado está actualmente activo. Registre su salida cuando deje la empresa.",
      closure_warning:
        "El cierre marca al empleado como salido de la empresa. Su cuenta seguirá siendo accesible pero se mostrará como 'Salido'.",
      exit_comment_placeholder: "Comentario adicional sobre la salida (opcional)",
      exit_date_required: "La fecha de salida es obligatoria.",
      exit_reason_required: "El motivo de salida es obligatorio.",
      closure_error: "Error al cerrar la cuenta.",
      reactivate_account_title: "¿Reactivar esta cuenta?",
      reactivate_account_description:
        "La fecha y el motivo de salida se borrarán y el empleado volverá a estar activo.",
      exit_type_retraite: "Jubilación voluntaria",
      exit_type_mise_a_la_retraite: "Jubilación por iniciativa del empleador",
      exit_type_rupture_conventionnelle: "Ruptura convencional",
      exit_type_licenciement: "Despido",
      exit_type_demission: "Dimisión",
      exit_type_mutation: "Mutación",
      exit_type_deces: "Fallecimiento",
      exit_type_autre: "Otro",
      relances_title: "Seguimientos",
      refuse_contact_title: "Este empleado ha pedido no ser contactado de nuevo.",
      refuse_contact_body:
        "Está excluido de los recordatorios automáticos y de la cola de seguimiento. Respete esta elección: contáctelo solo por una obligación legal o contractual.",
      relances_description: "Seguimiento de los contactos realizados por email o teléfono.",
      new_relance: "Nuevo seguimiento",
      relance_channel_email: "Email",
      relance_channel_telephone: "Teléfono",
      relance_notes_placeholder: "Comentario de seguimiento (respuesta obtenida, próxima acción…)",
      relance_outcome_label: "Resultado del seguimiento ({{channel}})",
      relance_outcome_repondu: "Respondió",
      relance_outcome_pas_de_reponse: "Sin respuesta",
      relance_outcome_message_laisse: "Mensaje dejado",
      relance_outcome_a_rappeler: "A volver a llamar",
      relance_outcome_refus: "Rechazado",
      relance_outcome_injoignable: "Inalcanzable",
      next_relance_date: "Próximo seguimiento previsto",
      save_relance: "Guardar seguimiento",
      relance_save_error: "Error al guardar",
      no_relances: "Ningún seguimiento registrado para este empleado.",
      relance_auto: "Auto",
      relance_by: "por {{name}}",
      next_relance_on: "Próximo seguimiento previsto el {{date}}",
      delete_relance: "Eliminar seguimiento",
      delete_relance_title: "¿Eliminar este seguimiento?",
      delete_relance_description:
        "La entrada se eliminará permanentemente del registro de seguimientos.",
      evaluation_title: "Evaluación del servicio",
      evaluation_description: "Opinión del empleado después de la restitución de su balance.",
      no_evaluation_yet: "El empleado aún no ha evaluado el servicio.",
      evaluation_score: "{{score}}/5",
      evaluation_recommendation_badge: "Recomendación {{score}}/10",
      evaluated_on: "Evaluado el {{date}}",
      evaluation_invited_on: "Invitación enviada el {{date}}",
      evaluation_reminded_on: "Recordatorio enviado el {{date}}",
      satisfaction_1: "Muy insatisfecho",
      satisfaction_2: "Insatisfecho",
      satisfaction_3: "Neutral",
      satisfaction_4: "Satisfecho",
      satisfaction_5: "Muy satisfecho",
    },
    careerPeriods: {
      unavailable_title: "El editor de periodos de carrera no está disponible",
      unavailable_desc: "La tabla de periodos de carrera aún no está disponible en este entorno.",
      postgres_error: "Error de Postgres: {{msg}}",
      unknown_error: "Error desconocido",
      count_one: "{{count}} periodo",
      count_other: "{{count}} periodos",
      validated_count_one: "{{count}} validado",
      validated_count_other: "{{count}} validados",
      add_period: "Añadir un periodo",
      empty_title: "Ningún periodo registrado",
      empty_desc_editable: "Comience añadiendo el primer periodo profesional de este expediente.",
      empty_desc_readonly: "Aún no se ha registrado ningún periodo en este expediente.",
      add_first_period: "Añadir el primer periodo",
      activity_period: "Periodo de actividad",
      validated: "Validado",
      revenues: "Ingresos:",
      evolution: "evolución",
      remove_validation: "Retirar la validación",
      validate_period: "Validar el periodo",
      invalidate: "Invalidar",
      validate: "Validar",
      edit: "Editar",
      delete_confirm: "¿Eliminar el periodo «{{label}}»?",
      delete_desc:
        "Los datos de este periodo se eliminarán definitivamente. Esta acción es irreversible.",
      delete_desc_ris:
        "Los trimestres y puntos de este periodo siguen contados: figuran en el estado de carrera enviado al cálculo. Elimine un periodo del estado solo para corregir un duplicado de visualización.",
      delete: "Eliminar",
      cancel: "Cancelar",
      period_fallback: "periodo {{range}}",
      in_progress: "en curso",
    },
    noaAnalyse: {
      cancel: "Cancelar",
      save: "Guardar",
      edit_text: "Editar el texto",
      regenerate: "Regenerar (IA)",
      generate: "Generar con IA",
      generate_self: "Ejecutar mi análisis",
      regenerate_self: "Volver a ejecutar mi análisis",
      generate_failed: "La generación del análisis ha fallado.",
      save_failed: "El guardado ha fallado.",
      reset_failed: "El restablecimiento ha fallado.",
      title_aon: "Análisis completo por Noa",
      title_salarie: "Su análisis personalizado",
      description_aon:
        "Estudio de caso detallado del expediente, verificado con las fuentes oficiales. Genere una primera versión con la IA y luego ajuste libremente el texto: es esta versión la que verá el empleado.",
      description_salarie:
        "Un estudio detallado de su situación de jubilación: perfil, escenarios, palancas de optimización y recomendaciones personalizadas.",
      editor_aria: "Contenido del análisis",
      reset_to_ai: "Restablecer al texto generado por la IA",
      publish: "Publicar al empleado",
      unpublish: "Retirar la publicación",
      publish_failed: "No se ha podido guardar la publicación.",
      badge_published: "Publicado",
      badge_draft: "Borrador",
      pending_publication:
        "Su análisis está siendo revisado por su asesor de Aon. Aparecerá aquí en cuanto sea validado.",
      unpublish_confirm_title: "¿Retirar la publicación?",
      unpublish_confirm_desc:
        "El empleado dejará de tener acceso al análisis y al arbitraje Tramo C, y ambos desaparecerán de su informe. Podrá volver a publicarlo en cualquier momento.",
      empty_aon:
        "Ejecute el análisis para generar una primera versión con la IA y luego ajuste el texto antes de que sea visible para el empleado.",
      empty_salarie:
        "Su análisis personalizado estará disponible pronto. Su asesor de Aon lo está preparando para usted.",
      description_self:
        "Noa estudia su situación y redacta para usted un análisis detallado: perfil, escenarios de jubilación, palancas de optimización y recomendaciones.",
      empty_self:
        "Ejecute su análisis cuando quiera: Noa repasa su carrera, sus simulaciones y las normas vigentes para explicarle su situación. Espere de uno a dos minutos.",
      disclaimer_self:
        "Análisis redactado por Noa, nuestra inteligencia artificial especializada en jubilación, a partir de la información de su expediente. Ayuda a la decisión: no sustituye un asesoramiento jurídico o fiscal personalizado.",
      disclaimer_self_with_date:
        "Análisis redactado por Noa, nuestra inteligencia artificial especializada en jubilación, el {{date}}, a partir de la información de su expediente. Vuelva a ejecutarlo tras cualquier cambio. Ayuda a la decisión: no sustituye un asesoramiento jurídico o fiscal personalizado.",
      cooldown: "Su análisis acaba de generarse. Podrá volver a ejecutarlo en unos minutos.",
      no_credit:
        "El crédito del servicio de IA se ha agotado: la generación queda suspendida hasta recargar la cuenta. Inténtelo de nuevo después.",
      last_error_title: "Última generación fallida el {{date}}",
      last_error_retry: "Vuelva a ejecutar la generación una vez corregida la causa.",
      disclaimer_readonly:
        "Este análisis ha sido preparado para usted por su asesor de Aon. Constituye una ayuda a la decisión y no sustituye un asesoramiento jurídico o fiscal personalizado.",
      disclaimer_editable_with_date:
        "Primera versión generada por inteligencia artificial el {{date}}{{model}}, luego revisada y ajustada por el equipo de Aon. Ayuda a la decisión: no sustituye un asesoramiento jurídico o fiscal personalizado.",
      disclaimer_editable_no_date:
        "Primera versión generada por inteligencia artificial{{model}}, luego revisada y ajustada por el equipo de Aon. Ayuda a la decisión: no sustituye un asesoramiento jurídico o fiscal personalizado.",
      loading_title: "Noa está estudiando su expediente… puede tardar unos minutos.",
      background_hint:
        "Puede salir de esta página: el análisis continúa y aparecerá cuando vuelva.",
      did_you_know: "¿Lo sabía?",
      steps: [
        "Reconstitución de su carrera y de sus derechos",
        "Verificación de los parámetros legales vigentes",
        "Análisis de sus diferentes escenarios de jubilación",
        "Identificación de las palancas de optimización",
        "Redacción de su conclusión personalizada",
      ],
      facts: [
        "La tasa completa se obtiene reuniendo la duración de seguro requerida para su generación, o alcanzando la edad de tasa completa automática.",
        "Cada trimestre que falta conlleva una reducción; a la inversa, trabajar más allá de la tasa completa da derecho a un incremento.",
        "La jubilación complementaria Agirc-Arrco funciona por puntos, convertidos en pensión mediante el valor de servicio del punto.",
        "La pensión de base del régimen general se calcula sobre la media de sus 25 mejores años de salario, reducida a 24 o 23 años para ciertos padres desde la ley de financiación de la seguridad social para 2026.",
        "El dispositivo «carrera larga» puede permitir una jubilación antes de la edad legal, bajo condiciones de inicio de actividad.",
        "El coeficiente de solidaridad (penalización temporal) de Agirc-Arrco se suprimió para las jubilaciones con efecto desde el 1 de diciembre de 2023.",
      ],
    },
    documents: {
      title: "Mis documentos",
      subtitle:
        "Suba los documentos necesarios para la producción de su Balance de Jubilación Individual.",
      kind_ris: "Informe de carrera (RIS)",
      kind_agirc_arrco: "Informe Agirc-Arrco",
      kind_bulletin: "Nómina (diciembre N-1)",
      kind_other: "Otro justificante",
      uploaded_at: "Subido el",
      validated: "Validado",
      pending_validation: "Pendiente de validación",
      rejected: "Rechazado",
      add: "Subir un documento",
      drop_here: "Arrastre su archivo aquí o haga clic para navegar.",
      empty: "Ningún documento subido por el momento.",
      extracted_periods_one: "{{count}} período importado desde el RIS (pestaña Carrera).",
      extracted_periods_other: "{{count}} períodos importados desde el RIS (pestaña Carrera).",
      extract_failed: "Error en el análisis del RIS.",
      download: "Descargar",
      download_aria: "Descargar {{name}}",
      download_error: "No se pudo descargar el archivo. Inténtelo de nuevo en unos instantes.",
    },
    messages: {
      kicker: "Mi espacio",
      title: "Mensajes",
      subtitle: "Su canal directo con el equipo Aon a cargo de su expediente.",
      new_message: "Nuevo mensaje",
      no_messages: "Ningún mensaje por el momento.",
      send: "Enviar",
      type_message: "Escribir un mensaje…",
      attachment: "Adjunto",
      attachments: "Adjuntos",
      no_dossier_title: "La mensajería estará disponible pronto",
      no_dossier_body:
        "En cuanto se cree un expediente para usted, podrá comunicarse con su consultor Aon desde aquí.",
      no_consultant_title: "Ningún consultor asignado por el momento",
      no_consultant_body: "Podrá iniciar una conversación en cuanto se le asigne un consultor Aon.",
      start_title: "Iniciar una conversación",
      start_body: "Haga su primera pregunta a su consultor Aon.",
      start_button: "Iniciar la conversación",
      unknown_error: "Error desconocido",
      aon_team: "Equipo Aon Jubilación",
      role_chef_projet: "Jefe de proyecto Aon",
      role_consultant: "Consultor Aon",
      // Espacio Aon + hilo de conversación compartido
      aon_kicker: "Pilotaje Aon",
      aon_subtitle: "Sus conversaciones con empleados y jefes de proyecto.",
      new_conversation: "Nueva conversación",
      tab_active: "Activos",
      tab_archived: "Archivados",
      no_archived: "Ninguna conversación archivada",
      no_conversation: "Ninguna conversación",
      empty_hint: "Los hilos iniciados desde un expediente aparecerán aquí.",
      back_to_list: "Conversaciones",
      select_conversation: "Seleccione una conversación",
      dialog_title: "Nueva conversación",
      dialog_description:
        "Seleccione un empleado de su perímetro para iniciar (o reabrir) un intercambio.",
      search_employee_placeholder: "Buscar un empleado (apellido, nombre, correo, matrícula)…",
      error_create_dossier: "No se pudo crear el expediente del empleado.",
      no_employee_found: "Ningún empleado encontrado",
      no_employee: "Ningún empleado",
      no_employee_scope: "Ningún empleado está vinculado a su perímetro.",
      no_name: "(sin nombre)",
      opening: "Abriendo…",
      no_subject: "(sin asunto)",
      participants_count_one: "{{count}} participante",
      participants_count_other: "{{count}} participantes",
      channel_salarie_production: "Empleado ↔ Producción",
      channel_drh_chefprojet: "RRHH ↔ Jefe de proyecto",
      open_dossier_title: "Abrir el expediente vinculado",
      dossier: "Expediente",
      archive: "Archivar",
      restore: "Restaurar",
      no_one: "(nadie)",
      relative_min: "hace {{count}} min",
      relative_hour: "hace {{count}} h",
      relative_day: "hace {{count}} d",
      drop_files: "Suelte sus archivos aquí",
      no_messages_title: "Ningún mensaje",
      no_messages_body: "Inicie la discusión enviando un primer mensaje abajo.",
      remove_file: "Retirar",
      attach_file: "Adjuntar un archivo",
      archived_conversation: "Conversación archivada",
      send_shortcut: "Enviar (Ctrl/Cmd+Intro)",
      enter_key: "Intro",
      drop_hint: "para enviar · arrastre sus archivos a la conversación",
      deleted_message: "Mensaje eliminado",
      delete_message: "Eliminar mensaje",
      seen: "Visto",
      mark_unread: "Marcar como no leído",
      size_b: "{{value}} B",
      size_kb: "{{value}} KB",
      size_mb: "{{value}} MB",
      send_failed: "Error al enviar",
      file_too_big: "El archivo « {{name}} » supera 25 MB.",
      max_files: "Máximo {{count}} archivos por mensaje.",
    },
    bri_lock: {
      title: "Su Balance de Jubilación está listo",
      version: "Versión {{version}}",
      finalized_on: "finalizado el {{date}}",
      body: "Su consultor Aon ha finalizado su Balance Individual de Jubilación. Se lo presentará y comentará durante una entrevista de restitución: elija la fecha que le convenga en su agenda.",
      next_rdv_title: "Cita confirmada.",
      next_rdv_body: "Su restitución está prevista el {{date}}.",
      manage_rdv: "Gestionar mi cita",
      choose_date: "Elegir una fecha de cita",
      unlock_note:
        "El documento podrá descargarse aquí al término de su entrevista de restitución.",
      parcours_body:
        "Su documento está finalizado y se le entregará durante su entrevista de restitución con su consultor Aon. Podrá descargarlo aquí justo después.",
      appetences_title: "Indique sus deseos para acceder a su BRI",
      appetences_body:
        "Su Balance de Jubilación está listo. Para acceder a él, indique primero sus deseos de jubilación en la etapa « Mis resultados », aunque ninguno le convenga: basta con validar.",
      appetences_cta: "Indicar mis deseos",
    },
    rdv: {
      kicker: "Mi espacio",
      title: "Mis citas",
      subtitle: "Citas de entrega de su Balance de Jubilación.",
      book: "Reservar un horario",
      book_short: "Reservar",
      no_rdv: "Ninguna cita planificada.",
      upcoming: "Próximas",
      past: "Pasadas",
      cancel_rdv: "Cancelar la cita",
      confirm_cancel: "¿Está seguro de que desea cancelar esta cita?",
      no_consultant_title: "Ningún consultor asignado por el momento.",
      no_consultant_body: "Podrá reservar una cita en cuanto se le asigne un consultor Aon.",
      disabled_title: "Su recorrido es totalmente autónomo",
      disabled_body:
        "No incluye citas. Pregunte al asistente Noa o escriba al equipo desde la mensajería: recibirá una respuesta por escrito.",
      upcoming_title: "Próximas citas",
      upcoming_empty: "Ninguna cita programada",
      upcoming_empty_can_book: "Reserve un horario en la agenda de su consultor.",
      upcoming_empty_cannot_book: "Ninguna cita prevista por el momento.",
      history_title: "Historial",
      history_count: "{{count}} citas pasadas o canceladas.",
      join_meeting: "Unirse a la reunión",
      with: "con {{name}}",
      cancel: "Cancelar",
      cancel_dialog_title: "Cancelar esta cita",
      cancel_dialog_desc: "Cita del {{date}}.",
      cancel_dialog_confirm: "Cancelar la cita",
      cancel_dialog_body: "Podrá reservar una nueva cita en cualquier momento.",
      status_propose: "Propuesta",
      status_planifie: "Planificada",
      status_realise: "Realizada",
      status_annule: "Cancelada",
      status_no_show: "Ausente",
      channel_visio: "Videollamada",
      channel_phone: "Teléfono",
      channel_presentiel: "Presencial",
      book_dialog: {
        title: "Reservar una cita",
        desc_with: "Con su consultor {{name}}",
        desc_default: "Elija una franja horaria en la agenda de su consultor",
        cancel: "Cancelar",
        confirm: "Confirmar esta franja",
        error_unknown: "Error desconocido.",
        empty_title: "Ninguna franja disponible",
        empty_desc:
          "Su consultor aún no ha abierto franjas horarias. Inténtelo más tarde o contáctelo.",
        slots_label: "Franjas disponibles",
        notes_label: "¿Un mensaje para su consultor?",
        notes_hint: "Opcional: indique sus preguntas o expectativas para esta cita.",
        notes_placeholder: "Ej. me gustaría hablar de la jubilación progresiva…",
        summary_prefix: "Va a reservar:",
        duration_note: "La duración de cita prevista para su operación es de {{minutes}} minutos.",
        channel_teams: "Videollamada Teams",
        channel_phone: "Teléfono",
        channel_presentiel: "Presencial",
      },
    },
    aon: {
      appointments: {
        form: {
          title: "Programar una cita",
          desc_with: "Con {{name}}",
          mode_slot: "Franja existente",
          mode_custom: "Fecha personalizada",
          slot_label: "Elija una franja",
          no_slot:
            'No hay franjas abiertas. Abra franjas desde su agenda primero, o cambie a "Fecha personalizada".',
          date_label: "Fecha",
          start_label: "Hora de inicio",
          end_label: "Hora de fin",
          modality_label: "Modalidad",
          channel_teams: "Videollamada (Teams)",
          channel_phone: "Teléfono",
          channel_presentiel: "Presencial",
          url_label: "Enlace de Teams / videollamada",
          url_hint: "Opcional — se puede añadir más tarde",
          url_placeholder: "https://teams.microsoft.com/...",
          phone_label: "Número de teléfono",
          phone_hint: "Se mostrará al empleado",
          phone_placeholder: "+33 6 12 34 56 78",
          notes_label: "Notas internas (consultor)",
          notes_hint: "No visibles para el empleado",
          notes_placeholder: "Ej. preparar la maqueta PDF, pedir confirmación en Excel…",
          cancel: "Cancelar",
          submit: "Programar la cita",
          error_select_slot_or_date: "Seleccione una franja o introduzca una fecha.",
          error_unknown: "Error desconocido.",
        },
      },
    },
    library: {
      kicker: "Recursos de jubilación",
      title: "Mi biblioteca",
      subtitle:
        "Fichas, vídeos y artículos para entender su jubilación y preparar su salida con tranquilidad.",
      empty: "Ningún recurso",
      empty_search: "Ningún contenido coincide con su búsqueda.",
      empty_none: "Ningún recurso está disponible por el momento.",
      search_placeholder: "Buscar una ficha, un tema, una palabra clave…",
      category_all: "Todo",
      category_comprendre: "Comprender mejor mi jubilación",
      category_dispositifs: "Dispositivos y optimización",
      category_demarches: "Trámites",
      category_fiscalite: "Fiscalidad",
      category_outils: "Herramientas y simuladores",
      category_pilotage: "Dirección de RRHH",
      category_methode: "Método y producción",
      kind_article: "Artículo",
      kind_video: "Vídeo",
      kind_document: "Documento",
      kind_link: "Enlace",
      kind_pdf: "Documento",
      audience_salarie: "Empleado",
      audience_drh: "RRHH",
      audience_aon: "Aon",
      featured: "Destacado",
      min_suffix: "min",
      viewer_download: "Descargar",
      viewer_download_ext: "Descargar ({{ext}})",
      viewer_download_fallback: "el documento",
      viewer_open_link: "Abrir recurso",
      viewer_attachment: "Adjunto",
      viewer_unavailable_video: "Vídeo no disponible",
      viewer_unavailable_document: "Documento no disponible",
      viewer_unavailable_preview:
        "Vista previa no disponible. Descargue el documento a continuación.",
      viewer_unavailable_link: "Enlace no disponible",
    },
    formations_employee: {
      kicker: "Mi espacio",
      title: "Formación sobre jubilación",
      subtitle: "Consulte las sesiones de formación disponibles e inscríbase directamente.",
      no_formations: "Ninguna formación disponible",
      no_formations_desc:
        "Las sesiones de formación sobre jubilación organizadas para su empresa aparecerán aquí.",
      register: "Inscribirse",
      unregister: "Cancelar inscripción",
      registered: "Inscrito",
      period_upcoming: "Próximas",
      period_all: "Todas",
      period_past: "Pasadas",
      stat_sessions: "Sesiones",
      stat_upcoming: "Próximas",
      stat_enrolled: "Mis inscripciones",
      filter_empty: "Ninguna sesión para este filtro",
      filter_empty_desc: "Cambie el período para mostrar más sesiones.",
      badge_past: "Pasada",
      badge_full: "Completo",
      participants: "{{count}} inscrito(s)",
      unenroll_title: "¿Cancelar la inscripción a esta formación?",
      unenroll_desc: "Ya no estará inscrito en la sesión «{{title}}» del {{date}}.",
      unenroll_confirm: "Cancelar mi inscripción",
    },
    formations: {
      channel_presentiel: "Presencial",
      channel_visio: "Videollamada",
      channel_mixte: "Mixto",
      form: {
        title_edit: "Modificar la sesión",
        title_create: "Nueva sesión de formación",
        description: "Planifique una sesión de formación de jubilación vinculada a una operación.",
        title_label: "Título",
        title_placeholder: "Taller de jubilación — salida anticipada",
        operation_label: "Operación",
        operation_placeholder: "Seleccionar una operación",
        starts_label: "Inicio",
        ends_label: "Fin",
        channel_label: "Canal",
        channel_placeholder: "No especificado",
        capacity_label: "Capacidad máx.",
        capacity_placeholder: "Ilimitada",
        location_label: "Lugar",
        location_placeholder: "Sala, ciudad o enlace de conexión",
        description_label: "Descripción",
        description_placeholder: "Programa, objetivos, ponente…",
        cancel: "Cancelar",
        save: "Guardar",
        create: "Crear la sesión",
        error_title_required: "El título es obligatorio.",
        error_operation_required: "Seleccione una operación.",
        error_start_required: "La fecha de inicio es obligatoria.",
        error_start_invalid: "Fecha de inicio no válida.",
        error_end_after_start: "La fecha de fin debe ser posterior a la de inicio.",
        error_capacity_invalid: "La capacidad debe ser un entero positivo.",
        error_unknown: "Se ha producido un error.",
      },
      manage: {
        title: "Formación",
        kicker_aon: "Espacio AON · Producción",
        kicker_admin: "Espacio Admin · Aon",
        description:
          "Planifique las sesiones de formación de jubilación, gestione las inscripciones y el seguimiento de asistencia.",
        new_session: "Nueva sesión",
        empty_title: "Ninguna sesión de formación",
        empty_desc:
          "Cree su primera sesión de formación de jubilación para empezar a gestionar las inscripciones.",
        stats_sessions: "Sesiones",
        stats_upcoming: "Próximas",
        stats_inscriptions: "Inscripciones",
        filter_all: "Todas las sesiones",
        filter_upcoming: "Próximas",
        filter_past: "Pasadas",
        empty_filter_title: "Ninguna sesión para este filtro",
        empty_filter_desc: "Cambie el período para mostrar más sesiones.",
        badge_upcoming: "Próxima",
        badge_past: "Pasada",
        participants: "Participantes",
        present_label: "{{rate}} % presentes",
        edit_title: "Modificar",
        delete_title: "Eliminar",
        delete_title_dialog: "¿Eliminar esta sesión?",
        delete_desc:
          "La sesión «{{title}}» y sus {{count}} inscripciones serán eliminadas definitivamente.",
        delete_confirm: "Eliminar",
      },
      participants: {
        description: "{{count}} inscrito(s) · {{presents}} presente(s)",
        close_add: "Cerrar alta",
        add_one: "Añadir un participante",
        done: "Terminado",
        loading: "Cargando…",
        empty_title: "Ningún participante inscrito",
        empty_desc: "Añada empleados a esta sesión para gestionar las asistencias.",
        no_match: "Ningún inscrito coincide con «{{term}}».",
        range_label: "{{start}}–{{end}} de {{total}} inscrito(s)",
        range_filtered_suffix: " (filtrado sobre {{filtered}})",
        previous_page: "Página anterior",
        next_page: "Página siguiente",
        present: "Presente",
        absent: "Ausente",
        remove_title: "Retirar de la sesión",
        bulk_title: "Inscribir toda la operación",
        bulk_available: "{{count}} miembro(s) no inscrito(s)",
        bulk_all_enrolled: "Todos los miembros de la operación ya están inscritos.",
        bulk_enroll_all: "Inscribir a todos",
        bulk_cancel: "Cancelar",
        bulk_confirm: "Confirmar ({{count}})",
        bulk_success: "{{count}} empleado(s) inscrito(s) correctamente.",
        bulk_none: "Ningún empleado nuevo que inscribir.",
        add_search_placeholder: "Buscar un empleado (nombre, apellido, matrícula…)",
        list_search_placeholder: "Buscar un inscrito (nombre, apellido, matrícula, email…)",
        no_available: "Ningún empleado disponible para esta operación.",
        no_search_result: "Ningún resultado para esta búsqueda.",
        add_button: "Añadir",
        unnamed_salarie: "Empleado sin nombre",
        matricule_prefix: "Mat. {{matricule}}",
        unnamed_fallback: "Empleado",
      },
    },
    historique: {
      kicker: "Mi espacio",
      title: "Historial de mis cálculos",
      subtitle:
        "Encuentre todos sus cálculos de jubilación, del más reciente al más antiguo. Haga clic en un cálculo para revisar su estimación y el detalle por escenario.",
      empty_title: "Ningún cálculo por el momento",
      empty_desc:
        "En cuanto realice una estimación o una simulación, cada cálculo se archivará aquí con sus resultados. Podrá así volver a cualquier cálculo anterior.",
      base_estimate: "Estimación de base",
      calculated_on: "Calculado el {{date}}",
      badge_simulation: "Simulación",
      badge_parcours: "Recorrido",
      badge_carriere_longue: "Carrera larga",
      no_result: "Ningún resultado guardado para este cálculo.",
    },
    parcours: {
      evaluation_banner: "Dé su opinión sobre la prestación",
      tranchec: {
        kicker: "Arbitraje Tramo C",
        title: "¿Merecen la pena sus cotizaciones al Tramo C?",
        lead: "Hemos comparado lo que le cuestan sus cotizaciones al Tramo C con la renta que le generarán, y hemos contrastado el resultado con una compra de trimestres.",
        years: "{{value}} años",
        roi_caption: "de renta para amortizar sus cotizaciones",
        ratio_caption: " de renta recibida por euro cotizado",
        verdict_favorable: "Arbitraje favorable",
        verdict_neutre: "Arbitraje equilibrado",
        verdict_defavorable: "Arbitraje desfavorable",
        verdict_inconnu: "Arbitraje por completar",
        tile_cout: "Coste total de las cotizaciones",
        tile_cout_hint: "en {{years}} años de cotización",
        tile_rente: "Renta anual generada",
        tile_rente_hint: "es decir {{amount}} al mes",
        tile_esperance: "Periodo de percepción considerado",
        tile_age: "Edad de jubilación considerada",
        age_value: "{{age}} años",
        compare_title: "¿Tramo C o compra de trimestres?",
        compare_desc:
          "Cuanto más corta es la barra, más rentable es la palanca: es el tiempo necesario para recuperar lo aportado.",
        compare_tranchec: "Cotizaciones Tramo C",
        compare_rachat: "Compra de trimestres",
        compare_rachat_empty:
          "No se ha cuantificado ninguna compra para su situación. Coméntelo con su asesor si desea estudiarla.",
        advisor_note: "Comentario de su asesor",
        note: "Estimación basada en los parámetros seleccionados por su asesor. Es una ayuda a la decisión y no constituye asesoramiento de inversión.",
        note_with_point:
          "Estimación basada en un valor de servicio del punto de {{value}} € y en los parámetros seleccionados por su asesor. Ayuda a la decisión: no constituye asesoramiento de inversión.",
      },
      not_ready_title: "Su expediente aún no está listo",
      not_ready_body:
        "Su espacio de jubilación estará disponible en cuanto su empresa haya creado su expediente.",
      gate: {
        kicker: "Mi espacio",
        title: "Mi recorrido de jubilación",
        subtitle:
          "Su balance de jubilación se prepara en tres etapas: primero la formación, luego su recorrido personalizado.",
        step1_title: "Me inscribo en una formación",
        step1_desc: "Elija una sesión de formación sobre jubilación organizada para su empresa.",
        step2_title: "Participo en la formación",
        step2_desc: "El organizador confirma su asistencia al final de la sesión.",
        step3_title: "Accedo a mi recorrido de jubilación",
        step3_desc:
          "Su recorrido personalizado se desbloquea: información, documentos, simulaciones.",
        step_label: "Etapa {{index}}",
        badge_done: "Hecho",
        badge_active: "En curso",
        sessions_title: "Sesiones disponibles — inscríbase para empezar",
        no_sessions:
          "Ninguna sesión está planificada por el momento. Su empresa organizará próximamente sesiones de formación sobre jubilación: podrá entonces inscribirse aquí y desbloquear su recorrido.",
        see_all: "Ver todas las formaciones",
        enrolled_title: "Está inscrito — ¡ahora solo falta asistir!",
        enrolled_session:
          "Sesión «{{title}}» el {{date}} a las {{time}}{{place}}. Su recorrido de jubilación se desbloqueará automáticamente en cuanto el organizador confirme su asistencia.",
        enrolled_no_session:
          "Su recorrido de jubilación se desbloqueará automáticamente en cuanto el organizador confirme su asistencia a la formación.",
        my_formations: "Mis formaciones",
        rule: "El acceso al recorrido de jubilación está reservado a los empleados que han participado en una formación sobre jubilación. Esta etapa garantiza que dispone de todas las claves para aprovechar al máximo su balance.",
        participants: "{{count}} inscrito(s)",
        register: "Inscribirse",
      },
      layout: {
        step_of: "Etapa {{current}} de {{total}}",
        restart: "Reiniciar",
        restart_title: "Período de prueba: reiniciar el recorrido desde el principio",
        progress_label: "Progreso: etapa {{current}} de {{total}}",
        help_toggle: "¿Necesita ayuda para entender?",
        recap_default: "Lo que hemos registrado",
        back: "Volver",
        continue: "Continuar",
      },
      runner: {
        step_bienvenue_label: "Bienvenida",
        step_bienvenue_title: "Bienvenido a su recorrido de jubilación",
        step_confidentialite_label: "Confidencialidad",
        step_confidentialite_title: "La elección sobre la confidencialidad de sus datos",
        step_confidentialite_lead: "Elija lo que desea compartir con su empresa.",
        step_confidentialite_help:
          "El equipo Aon siempre tiene acceso a sus datos para realizar su balance. Estas casillas solo conciernen lo que su empleador puede ver. Algunas pueden ser impuestas por su empresa.",
        step_informations_label: "Mis datos",
        step_informations_title: "Mi información",
        step_informations_lead: "Revisemos juntos la información que le concierne.",
        step_informations_help:
          "Su fecha de nacimiento determina la edad a la que podrá jubilarse. Verifique que sea correcta.",
        step_famille_label: "Mi familia",
        step_famille_title: "Mi familia",
        step_famille_lead: "Su cónyuge y sus hijos pueden otorgarle derechos adicionales.",
        // B2 : las tres explicaciones traducen fielmente los textos fijados el
        // 30/09/2026 (también mostrados en los globos de ayuda).
        step_famille_help:
          "Haber tenido hijos a menudo aumenta el número de trimestres y el importe de la jubilación. Indíquelos para una estimación más precisa.\n\nHijo con discapacidad\nSi ha criado a un hijo con derecho a la asignación de educación del hijo con discapacidad (AEEH), puede beneficiarse de una mayoración de la duración de seguro de un trimestre por período de 30 meses de educación, con un límite de 8 trimestres por hijo. Esta mayoración no se integra automáticamente en su estimación: su caja la examina con justificantes al realizar su solicitud de jubilación.\n\nHijo nacido sin vida\nUn hijo nacido sin vida puede, según los casos, abrir derechos por maternidad. No se integran automáticamente en su estimación: acuda a su caja de jubilación, que los examina con justificantes.\n\nReparto de los trimestres\nPara un hijo nacido o adoptado desde 2010, los 4 trimestres concedidos por su educación pueden repartirse entre los padres. Sin elección expresada en los 6 meses siguientes a su 4.º cumpleaños, se atribuyen a la madre.",
        step_documents_label: "Mis documentos",
        step_documents_title: "Mi historial laboral",
        step_documents_lead: "Suba su historial laboral: leemos su trayectoria automáticamente.",
        step_documents_help:
          "El «historial laboral» (o RIS) es un documento enviado por la Seguridad Social de jubilación. Enumera todos sus empleos. Puede descargarlo en info-retraite.fr.",
        step_carriere_label: "Mi carrera",
        step_carriere_title: "Mi carrera",
        step_carriere_lead: "Esto es lo que hemos entendido de su trayectoria profesional.",
        step_carriere_help:
          "Cada línea corresponde a un período en el que trabajó. Si falta algún período, su asesor podrá corregirlo con usted.",
        step_carriere_help_self:
          "Cada línea corresponde a un período en el que trabajó. Si falta un período o es inexacto, corríjalo directamente: su estimación lo tendrá en cuenta.",
        step_situation_label: "Mi situación",
        step_situation_title: "Mi situación particular",
        step_situation_lead:
          "Algunas situaciones dan derecho a una salida anticipada o a un complemento.",
        step_situation_help:
          "Por ejemplo: un trabajo penoso, una discapacidad, o haber empezado a trabajar muy joven. Marque lo que le concierne, sin temor.",
        step_vip_label: "Mis proyectos",
        step_vip_title: "Mis proyectos posteriores",
        step_vip_lead: "Lo que prevé hacer tras jubilarse cambia el análisis de sus escenarios.",
        step_vip_help:
          "Crear una actividad de consultoría, compatibilizar empleo y jubilación o pasar por un periodo de desempleo no tienen el mismo efecto sobre su pensión. Responda con libertad: nada es vinculante.",
        step_chomage_label: "Mi desempleo",
        step_chomage_title: "Mi periodo de desempleo",
        step_chomage_lead:
          "Un periodo sin empleo antes de su jubilación modifica el cálculo de sus derechos.",
        step_chomage_help:
          "Los periodos de desempleo con prestación pueden validar trimestres, sin cotización por su parte. Indique las fechas que prevé, aunque sean aproximadas: se tendrán en cuenta en sus cálculos.",
        step_supplementaire_label: "Mi ahorro",
        step_supplementaire_title: "Mi jubilación complementaria",
        step_supplementaire_lead:
          "Indique sus planes de ahorro para la jubilación (PER, plan de ahorro, planes de empresa…).",
        step_supplementaire_help:
          "Estos productos no figuran en su historial laboral: son desconocidos para la Seguridad Social. Al indicarlos, aparecerán en la sección «Régimen complementario» de su balance.",
        step_supplementaire_epargne_title: "Localice sus contratos de ahorro para la jubilación",
        step_supplementaire_epargne_loi:
          "La ley francesa n.º 2021-219, de 26 de febrero de 2021, relativa a los contratos de jubilación complementaria en estado de desherencia, refuerza la información a los ahorradores: los contratos de ahorro para la jubilación (PER, contratos «artículo 83», PERCO, contratos Madelin…) pueden consultarse en su cuenta de jubilación en línea, en info-retraite.fr.",
        step_supplementaire_epargne_justif:
          "Documentos a adjuntar: para cada contrato, el último extracto anual (situación de sus ahorros a 31 de diciembre) o, en su defecto, una carta del organismo gestor que indique el importe de sus ahorros.",
        step_supplementaire_epargne_link_loi: "Consultar la ley en Légifrance",
        step_supplementaire_epargne_link_inforetraite: "Acceder a info-retraite.fr",
        step_projet_label: "Mi proyecto",
        step_projet_title: "Mi proyecto de salida",
        step_projet_lead: "Díganos cuándo le gustaría jubilarse y qué desea comparar.",
        step_projet_help:
          "Puede comparar varias situaciones: jubilarse lo antes posible, a la edad legal, etc. Cada opción dará una estimación diferente.",
        step_resultats_label: "Mis resultados",
        step_resultats_title: "Mi estimación y mis simulaciones",
        step_resultats_lead:
          "Aquí está su estimación de referencia. Justo debajo, cree y compare tantas simulaciones como desee.",
        step_resultats_help:
          "Su estimación de referencia solo cambia si la recalcula. Cada simulación es independiente: pruebe una fecha de salida precisa, una recompra de trimestres… sin modificar nunca su estimación de referencia.",
        tab_estimation: "Mi estimación",
        tab_simulations: "Mis simulaciones",
        tab_analyse: "Análisis Noa",
        tab_analyse_salarie: "Mi análisis",
        tab_document: "Mi documento",
        step_attention_appetences: "Deseos por validar para acceder a su BRI",
        prev: "Anterior",
        next: "Siguiente",
        error_required: "Complete los campos obligatorios antes de continuar.",
        error_save: "No se pudo guardar su progreso: {{error}}",
        reset_ok:
          "Expediente reiniciado: se han eliminado todos los datos. Puede empezar de nuevo desde el principio.",
        reset_failed: "El reinicio falló: {{error}}",
        reset_title: "¿Borrar todo y empezar de nuevo?",
        reset_desc:
          "Esta acción elimina DEFINITIVAMENTE todos los datos de este expediente: información, familia, documentos, carrera, escenarios y resultados. El recorrido empieza de cero.",
        reset_confirm: "Borrar todo",
        reset_cancel: "Cancelar",
      },
      steps: {
        bienvenue_hello: "Hola {{name}} 👋",
        bienvenue_intro:
          "Este recorrido le acompaña, paso a paso, para estimar su futura jubilación. Todo es simple: avanza a su ritmo, y puede detenerse y retomar cuando quiera.",
        bienvenue_prepare: "Para empezar bien, prepare si es posible:",
        bienvenue_prepare_ris: "Su historial laboral (el «RIS») en formato PDF, si lo tiene.",
        bienvenue_prepare_family: "Las fechas de nacimiento de su cónyuge y sus hijos.",
        bienvenue_outro_1:
          "No se preocupe si no tiene todo: podrá completarlo más tarde. Haga clic en",
        bienvenue_outro_continue: " «Continuar»",
        bienvenue_outro_2: " para empezar.",
        infos_title: "Verifiquemos su identidad",
        infos_desc:
          "Esta información sirve para calcular su jubilación. Verifíquela y corríjala si es necesario. Se guarda automáticamente en cada etapa y se sincroniza con su perfil; estos son los datos que cuentan para sus estimaciones.",
        infos_civility: "Tratamiento",
        infos_civility_m: "Señor",
        infos_civility_mme: "Señora",
        infos_first_name: "Nombre",
        infos_last_name: "Apellido",
        infos_birth_date: "Fecha de nacimiento",
        infos_birth_place: "Lugar de nacimiento",
        infos_postal_code: "Código postal de su domicilio actual",
        infos_postal_placeholder: "Ej. 75015",
        infos_phone: "Teléfono",
        infos_phone_placeholder: "Ej. 06 12 34 56 78",
        infos_email: "Correo electrónico",
        infos_email_placeholder: "nombre.apellido@empresa.com",
        infos_min_warning: "Indique al menos su nombre, apellido y fecha de nacimiento.",
        err_first_name_required: "Nombre obligatorio.",
        err_last_name_required: "Apellido obligatorio.",
        err_birth_required: "Fecha de nacimiento obligatoria.",
        err_postal: "Código postal de 5 dígitos (ej. 75015).",
        famille_conjoint_title: "Su cónyuge",
        famille_conjoint_desc: "¿Vive en pareja? Esto puede influir en sus derechos.",
        famille_has_conjoint: "Tengo cónyuge (casado, unión civil o en concubinato)",
        famille_union_type: "Tipo de unión",
        famille_union_epoux: "Casado(a)",
        famille_union_pacse: "Unión civil",
        famille_union_concubin: "Concubinato / unión libre",
        famille_conjoint_dob: "Fecha de nacimiento del cónyuge",
        famille_enfants_title: "Sus hijos",
        famille_enfants_desc: "El número de hijos puede aumentar su jubilación (bonificación).",
        famille_no_enfant: "Aún no ha añadido ningún hijo.",
        famille_add_enfant: "Añadir un hijo",
        famille_enfant_dob: "Hijo {{index}} — fecha de nacimiento",
        // B2 (30/09/2026): solo información, sin efecto en el cálculo.
        famille_enfant_handicap: "Hijo con discapacidad",
        famille_enfant_mort_ne: "Hijo nacido sin vida",
        famille_partage_label: "Reparto de los trimestres",
        famille_help_handicap:
          "Si ha criado a un hijo con derecho a la asignación de educación del hijo con discapacidad (AEEH), puede beneficiarse de una mayoración de la duración de seguro de un trimestre por período de 30 meses de educación, con un límite de 8 trimestres por hijo. Esta mayoración no se integra automáticamente en su estimación: su caja la examina con justificantes al realizar su solicitud de jubilación.",
        famille_help_mort_ne:
          "Un hijo nacido sin vida puede, según los casos, abrir derechos por maternidad. No se integran automáticamente en su estimación: acuda a su caja de jubilación, que los examina con justificantes.",
        famille_help_partage:
          "Para un hijo nacido o adoptado desde 2010, los 4 trimestres concedidos por su educación pueden repartirse entre los padres. Sin elección expresada en los 6 meses siguientes a su 4.º cumpleaños, se atribuyen a la madre.",
        famille_recap_couple: "Vive en pareja. ",
        famille_recap_single: "Vive solo(a). ",
        famille_recap_children_one: "Ha declarado {{count}} hijo.",
        famille_recap_children_many: "Ha declarado {{count}} hijos.",
        docs_ris_title: "Su historial laboral",
        docs_ris_desc:
          "Suba su historial laboral (RIS) en formato PDF. Leemos automáticamente su trayectoria profesional.",
        docs_ris_choose: "Haga clic para elegir su archivo PDF",
        docs_ris_drop: "o arrástrelo aquí — un solo historial a la vez (PDF, {{size}} MB máx.)",
        docs_analyzing: "Analizando su historial...",
        docs_sending: "Subiendo...",
        docs_analyzing_hint:
          'Esta operación puede tardar hasta un minuto. El botón "Continuar" se desbloqueará automáticamente.',
        docs_analyzing_wait: "Analizando el historial... Espere antes de continuar.",
        docs_analyzed: "Historial analizado: {{count}} períodos de carrera identificados.",
        docs_default_name: "Documento",
        docs_delete_aria: "Eliminar {{name}}",
        docs_delete_this: "este documento",
        docs_delete_title_default: "el documento",
        docs_replace_title: "Eliminar para subir otro",
        docs_delete_impossible: "No se puede eliminar: {{error}}",
        docs_others_title: "Sus otros documentos",
        docs_others_desc:
          "Estos elementos completan su expediente. La lista se adapta a su empresa y a su situación.",
        docs_missing_one: "Documento obligatorio faltante: {{labels}}.",
        docs_missing_many: "Documentos obligatorios faltantes: {{labels}}.",
        docs_no_extra: "No se solicita ningún documento adicional para su recorrido.",
        docs_howto: {
          toggle: "¿Dónde conseguir este documento?",
          ris: {
            steps: [
              "Conéctese a info-retraite.fr con FranceConnect (impots.gouv, Ameli o La Poste).",
              "Abra la sección «Ma carrière» y luego «Mon relevé de carrière».",
              "Descargue el extracto individual de situación (RIS) en PDF, con todas sus páginas.",
            ],
            tip: "Un extracto de menos de 6 meses ofrece los resultados más fiables. No suba una captura de pantalla: necesitamos el PDF completo.",
          },
          agirc_arrco: {
            steps: [
              "Conéctese a su espacio personal en agirc-arrco.fr (o mediante FranceConnect).",
              "En «Mes points», elija «Relevé de points» o «Mon relevé de carrière complémentaire».",
              "Descargue el extracto en PDF: detalla sus puntos año por año.",
            ],
            tip: "Si nunca ha creado una cuenta, el registro se hace en línea con su número de seguridad social.",
          },
          bulletin_salaire: {
            steps: [
              "Recupere su nómina del mes de diciembre del año pasado.",
              "Suele estar en su caja fuerte digital (p. ej. Digiposte, MyPeopleDoc) o en la intranet de RRHH.",
              "Si no, solicítela a su departamento de nóminas: se espera un PDF o un escaneo legible.",
            ],
          },
          retraite_supp: {
            steps: [
              "Reúna los extractos anuales de sus planes de jubilación complementaria (PER, artículo 83, artículo 39, PERCO…).",
              "Los envía cada año la aseguradora o el gestor (por correo o en su espacio en línea).",
              "Suba un extracto por plan; basta con el más reciente.",
            ],
            tip: "El servicio «Mes contrats d'épargne retraite» de info-retraite.fr enumera los planes conocidos a su nombre.",
          },
          justificatif_penibilite: {
            steps: [
              "Conéctese a compteprofessionnelprevention.fr para consultar su cuenta C2P.",
              "Descargue el extracto de puntos de penosidad o el certificado de exposición entregado por su empleador.",
            ],
          },
          justificatif_handicap: {
            steps: [
              "Reúna la notificación de RQTH emitida por la MDPH o la notificación de pensión de invalidez de la CPAM.",
              "Suba el documento que indique la fecha de inicio y, en su caso, el grado de incapacidad.",
            ],
          },
          justificatif_carriere: {
            steps: [
              "Para un periodo en el extranjero: extracto o certificado de la caja de pensiones del país correspondiente.",
              "Para el servicio militar: el «état signalétique et des services», que se solicita al centro de archivos del personal militar.",
              "Para cualquier otro periodo: certificados de trabajo, contratos o certificados del empleador.",
            ],
          },
        },
        docs_required: "Obligatorio",
        docs_optional: "Opcional",
        docs_add: "Añadir",
        docs_replace: "Reemplazar",
        docs_deposit: "Subir",
        docs_delete_doc_title: "¿Eliminar este documento?",
        docs_delete_doc_desc:
          "El archivo {{name}} se eliminará definitivamente. Esta acción es irreversible.",
        docs_delete: "Eliminar",
        docs_cancel: "Cancelar",
        docs_error: "Error: {{error}}",
        carriere_title: "Su carrera reconstituida",
        carriere_desc:
          "Aquí están los períodos de trabajo que hemos entendido de su historial. Verifique que le parezcan correctos.",
        carriere_empty_title: "Ningún período por el momento",
        carriere_empty_desc:
          "Vuelva a la etapa anterior para subir y analizar su historial laboral.",
        carriere_manual_hint:
          "¿Falta un período (por ejemplo un empleo en el extranjero que no aparece en su historial)? Agréguelo, modifíquelo o elimínelo aquí.",
        carriere_manual_empty_desc:
          "Primero suba su historial laboral en la etapa anterior, o agregue sus períodos manualmente (por ejemplo un período en el extranjero).",
        carriere_period_default: "Período de actividad",
        carriere_verified: "Verificada",
        carriere_ongoing: "en curso",
        carriere_convention: "Convenio:",
        carriere_revenus: "Ingresos:",
        carriere_revenus_ignored: "no se usa en el cálculo, prevalece el detalle anual siguiente",
        carriere_evolution: "evolución",
        carriere_source: "Fuente: {{source}}",
        situation_title: "Su situación particular",
        situation_desc: "Marque lo que le concierne. Si nada aplica, simplemente continúe.",
        situation_warn_many:
          "Ha marcado muchas situaciones. Un asesor verificará su coherencia y el impacto en su estimación.",
        situation_warn_many_self:
          "Ha marcado muchas situaciones. Compruebe que realmente le corresponden: influyen en su estimación.",
        situation_warn_invalidite:
          "«Invalidez» y «salida anticipada a tasa completa» a menudo corresponden a regímenes diferentes: a confirmar con su asesor.",
        situation_warn_invalidite_self:
          "«Invalidez» y «salida anticipada a tasa completa» a menudo corresponden a regímenes diferentes: su estimación sigue siendo indicativa en este punto.",
        cas_penibilite: "He realizado un trabajo penoso",
        cas_amiante: "He estado expuesto(a) al amianto",
        cas_rqth: "Estoy reconocido(a) como trabajador con discapacidad",
        cas_invalidite: "Estoy en situación de invalidez",
        cas_arret_long_maladie: "He tenido una baja por enfermedad de larga duración",
        cas_militaire: "He realizado el servicio militar",
        cas_expatriation_sans_cfe: "He trabajado en el extranjero sin cotizar en Francia",
        cas_poly_pension: "Tengo varios regímenes de jubilación",
        cas_multi_activite: "He tenido varias actividades al mismo tiempo",
        cas_travail_etudiant: "He trabajado durante mis estudios",
        cas_carriere_longue: "Empecé a trabajar muy joven",
        cas_taux_plein_anticipe: "Pienso jubilarme anticipadamente a tasa completa",
        cas_cet: "Dispongo de una cuenta de ahorro de tiempo",
        // Bloques de la etapa « Su situación particular » (B1, 30/09/2026).
        situation_block_carriere: "Mi carrera",
        situation_block_carriere_help:
          "Las situaciones que pudieron modificar su duración de seguro o abrir derecho a una jubilación anticipada.",
        situation_block_sante: "Mi salud",
        situation_block_sante_help:
          "Las situaciones de salud o de exposición que pueden abrir trimestres adicionales o una jubilación anticipada.",
        situation_block_autre: "Otro",
        situation_block_autre_help:
          "Los dispositivos que pueden influir en la fecha efectiva de su salida.",
        cet_title: "Su cuenta de ahorro de tiempo",
        cet_hint:
          "Esta información ayuda a su consultor a articular el final de carrera (permiso de fin de carrera, monetización) con la fecha de salida.",
        cet_jours_label: "Días ahorrados",
        cet_avant_depart_label: "Deseo utilizar mi CET antes de mi salida",
        cet_avant_depart_hint: "Por ejemplo como permiso de fin de carrera.",
        militaire_dates_title: "Fechas de su servicio militar",
        militaire_dates_hint:
          "Estas fechas se comparan con su informe de vida laboral para comprobar que coinciden.",
        militaire_debut: "Inicio",
        militaire_fin: "Fin",
        militaire_match: "Coincide con su informe de vida laboral.",
        militaire_mismatch:
          "Su informe indica el periodo del {{debut}} al {{fin}}. Un asesor revisará esta diferencia.",
        militaire_mismatch_self:
          "Su informe indica el periodo del {{debut}} al {{fin}}. Revise sus fechas: si el informe es erróneo, la corrección debe solicitarse al organismo de jubilación.",
        militaire_no_ris:
          "No aparece ningún periodo militar en su informe: estas fechas permitirán añadirlo.",
        vip_title: "Mis proyectos posteriores",
        vip_desc:
          "Estas respuestas permiten comparar sus escenarios de jubilación y preparar su devolución.",
        vip_no_work: "No quiero trabajar durante la jubilación",
        vip_no_work_hint: "Desea cesar toda actividad profesional.",
        vip_conseil: "Tengo una actividad de consultoría por montar",
        vip_conseil_hint: "Creación de una sociedad para una actividad independiente.",
        vip_ca: "Facturación prevista (€/año)",
        vip_forme: "Forma jurídica",
        vip_forme_sas: "SAS",
        vip_forme_sarl: "SARL",
        vip_remuneration: "Remuneración",
        vip_remu_salaire: "Salario",
        vip_remu_dividendes: "Dividendos",
        vip_remu_mixte: "Salario y dividendos",
        vip_undecided: "Aún sin decidir",
        vip_cumul: "Quiero compatibilizar empleo y jubilación",
        vip_cumul_hint: "Continuar una actividad mientras percibe su pensión.",
        vip_chomage: "Se prevé un periodo de desempleo antes de mi jubilación",
        vip_chomage_hint: "Por ejemplo tras una baja acordada.",
        vip_chomage_debut: "Inicio del desempleo",
        vip_chomage_fin: "Fin del desempleo",
        vip_comment: "Precisiones (opcional)",
        vip_comment_placeholder: "Cualquier información útil para su asesor…",
        vip_note:
          "Esta información se transmite a su asesor Aon, que la integra en el análisis de sus escenarios.",
        projet_when_title: "¿Cuándo desea jubilarse?",
        projet_when_desc: "Indique una fecha de salida prevista (podrá cambiarla).",
        projet_date_visee: "Fecha de salida prevista (opcional)",
        projet_date_eval: "Fecha de evaluación",
        projet_derive_title: "Revalorización de su salario",
        projet_derive_desc: "Hipótesis de progresión anual de su remuneración.",
        projet_derive_label: "Aumento anual estimado de su salario (%)",
        projet_derive_hint: "Hasta su jubilación. Valor propuesto: {{pct}} %",
        projet_compare_title: "¿Qué desea comparar?",
        projet_compare_desc: "Elija una o varias situaciones para simular.",
        projet_urgence_title: "Expediente urgente",
        projet_urgence_desc: "¿Un plazo próximo o una situación que requiere una respuesta rápida?",
        projet_urgence_label: "Mi expediente es urgente",
        projet_urgence_reason: "Motivo",
        projet_urgence_reason_pick: "Elija un motivo",
        projet_urgence_reason_required: "Elija un motivo para marcar su expediente como urgente.",
        projet_urgence_reason_depart_moins_6_mois: "Mi salida está prevista en menos de 6 meses",
        projet_urgence_reason_rupture_licenciement: "Hay una ruptura o un despido en curso",
        projet_urgence_reason_decision_rapide: "Debo tomar una decisión rápidamente",
        projet_urgence_reason_autre: "Otro",
        projet_urgence_comment: "Comentario (opcional)",
        projet_urgence_comment_ph: "Precise su situación a su asesor…",
        projet_urgence_privacy:
          "Su asesor Aon tratará su expediente con prioridad. Su contacto de RR. HH. solo ve que su expediente es prioritario, nunca el motivo ni su comentario.",
        projet_urgence_auto: "Marcado prioritario automáticamente (salida próxima)",
        projet_urgence_consultant: "Su expediente ha sido marcado prioritario por su asesor Aon.",
        resultats_estimation_title: "Su estimación de jubilación",
        resultats_estimation_desc:
          "Ejecute el cálculo para descubrir su estimación, escenario por escenario.",
        resultats_recalc: "Recalcular",
        resultats_calc: "Calcular mi estimación",
        resultats_calc_ok: "Su estimación ha sido calculada.",
        resultats_empty: "Ninguna estimación por el momento. Ejecute el cálculo arriba.",
        result_per_month_gross: "por mes (bruto)",
        result_per_month_net: " / mes (neto)",
        result_depart: "Salida estimada",
        result_depart_age: "{{age}} años",
        result_taux: "Tasa de reemplazo",
        result_trim_valid: "Trimestres validados",
        result_trim_cotises: "Trimestres cotizados",
        result_trim_reputes: "Reputados cotizados",
        result_trim_reputes_hint: "aprox.",
        result_trim_missing_age: "Trimestres que faltan para la tasa completa",
        result_penalite_tous_regimes: "Penalización / todos regímenes",
        result_decote_appliquee: "Descuento aplicado",
        result_penalite_cnav: "Trimestres de reducción aplicados al régimen de base",
        bubble_trim_missing:
          "Trimestres que le faltan en la fecha de jubilación para obtener la tasa completa.",
        bubble_penalite_cnav:
          "Número de trimestres de reducción efectivamente aplicados al cálculo de su pensión de base.",
        bubble_decote_base:
          "Reducción del régimen de base: 1,25 % por trimestre que falte, con un máximo de 20 trimestres (25 %), aquí {{n}} trimestres, es decir {{pct}} %.",
        bubble_decote_base_short:
          "Reducción del régimen de base: 1,25 % por trimestre que falte, con un máximo de 20 trimestres (25 %).",
        result_taux_cnav: "Tasa de pensión CNAV",
        result_points_agirc: "Puntos Agirc-Arrco",
        result_show_detail: "Ver el detalle",
        result_hide_detail: "Ocultar el detalle",
        result_estimation: "Estimación",
        result_date_visee: "En la fecha deseada",
        conf_intro_title: "Sus datos le pertenecen",
        conf_intro_body_1:
          "Para realizar su balance, el equipo Aon necesita acceder a su información. Sin embargo, ",
        conf_intro_you_decide: "usted decide",
        conf_intro_body_2: " lo que se comparte con su ",
        conf_company: "empresa",
        conf_rule: "Regla fijada por su empresa: {{label}}",
        conf_opt_date_title: "Compartir la fecha de mi salida a tasa completa",
        conf_opt_date_desc:
          "Mi empresa podrá conocer la fecha en la que podré jubilarme a tasa completa, sin ningún otro detalle.",
        conf_opt_full_title: "Compartir la totalidad de mi balance de jubilación (BRI)",
        conf_opt_full_desc:
          "Mi empresa tendrá acceso al soporte completo de mi balance de jubilación (importes, escenarios, etc.).",
        conf_required: "Obligatorio",
        conf_recap_full_1: "Comparte ",
        conf_recap_full_strong: "la totalidad de su balance",
        conf_recap_full_2: " con su empresa.",
        conf_recap_date_1: "Comparte ",
        conf_recap_date_strong: "únicamente su fecha de salida",
        conf_recap_date_2: " con su empresa.",
        conf_recap_none_1: "No comparte ",
        conf_recap_none_strong: "ninguna información",
        conf_recap_none_2: " con su empresa. Solo el equipo Aon tiene acceso.",
        supp_intro_title: "Sus planes de ahorro para la jubilación",
        supp_intro_body:
          "Indique aquí sus productos de jubilación complementaria (PER, PERCOL, plan de ahorro, planes de empresa…) y la renta mensual neta estimada. Estos importes no aparecen en su historial laboral: complementan su balance.",
        supp_hint:
          "Deje el importe vacío si aún no lo conoce: su asesor podrá completarlo. También puede añadir o quitar líneas según sus contratos.",
        supp_hint_self:
          "Deje el importe vacío si aún no lo conoce: podrá volver a ello más tarde. También puede añadir o quitar líneas según sus contratos.",
        supp_col_device: "Plan",
        supp_col_rente: "Renta neta / mes",
        supp_device_placeholder: "Nombre del plan",
        supp_per_month: "€/mes",
        supp_remove_aria: "Eliminar esta línea",
        supp_empty: "Ningún plan. Añada uno si tiene ahorro para la jubilación.",
        supp_add: "Añadir un plan",
        supp_total: "Total estimado",
        supp_footer_1: "Estos planes figurarán en la sección ",
        supp_footer_strong: "«Régimen complementario»",
        supp_footer_2: " de su balance (BRI).",
      },
      simulations: {
        title: "Mis simulaciones",
        intro:
          "Cree varias simulaciones para comparar diferentes situaciones: una jubilación en una fecha concreta, una compra de trimestres… Puede modificarlas y recalcularlas en cualquier momento.",
        create: "Crear una simulación",
        empty_title: "Ninguna simulación por el momento",
        empty_desc:
          "Cree su primera simulación para probar una fecha de jubilación o una compra de trimestres.",
        comparator_label: "Comparación de edades de jubilación",
        comparator_title: "Comparar las edades de jubilación",
        comparator_desc:
          "Calcule de una vez sus 6 escenarios de jubilación (62 años, lo antes posible, edad legal, 65 años, tasa plena, 67 años) para ver el impacto en su pensión.",
        comparator_refresh: "Actualizar la comparación",
        comparator_run: "Comparar mis opciones",
        comparator_hint:
          "Lance la comparación para visualizar, escenario por escenario, su pensión y la edad de jubilación correspondiente.",
        col_scenario: "Escenario de jubilación",
        col_depart: "Jubilación estimada",
        col_brut: "Pensión bruta / mes",
        col_net: "Pensión neta / mes",
        col_vs: "vs estimación",
        col_trim_missing: "Trimestres faltantes",
        best: "El más ventajoso",
        age_years: "{{age}} años",
        card_calculated: "Calculada",
        card_to_calculate: "Por calcular",
        card_requested_drh: "Solicitada por su RRHH",
        card_recalc: "Recalcular",
        card_calc: "Calcular",
        card_edit: "Modificar",
        card_delete_aria: "Eliminar la simulación {{label}}",
        card_show_details: "Ver el detalle de los resultados",
        card_hide_details: "Ocultar el detalle de los resultados",
        card_no_result: "Ningún resultado registrado. Lance el cálculo arriba.",
        card_no_params:
          "Esta simulación no tiene parámetros: el cálculo usará la jubilación a tasa plena.",
        card_calculated_notice: "La simulación «{{label}}» ha sido calculada.",
        delete_title: "¿Eliminar esta simulación?",
        delete_desc:
          "La simulación «{{label}}» y su historial de resultados serán desvinculados. Esta acción es definitiva.",
        delete_confirm: "Eliminar",
        result_per_month_gross: "al mes (bruto)",
        result_per_month_net: " / mes (neto)",
        result_depart: "Jubilación estimada",
        result_age: "{{age}} años",
        result_trim_valid: "Trimestres validados",
        result_trim_missing_age: "Trimestres que faltan para la tasa completa",
        result_penalite_tous_regimes: "Penalización / todos regímenes",
        result_decote_appliquee: "Descuento aplicado",
        result_penalite_cnav: "Trimestres de reducción aplicados al régimen de base",
        result_taux_cnav: "Tasa de pensión CNAV",
        result_rachat: "Compra",
        result_rachat_value: "Incluida",
        comp_identical: "Idéntico a su estimación",
        comp_delta: "{{sign}}{{amount}} / mes",
        comp_vs_base: "vs estimación de base",
        comp_vs_base_pct: "{{sign}}{{pct}} % vs estimación de base ({{kind}})",
        comp_net: "neto",
        bubble_decote_base:
          "Reducción del régimen de base: 1,25 % por trimestre que falte, con un máximo de 20 trimestres (25 %), aquí {{n}} trimestres, es decir {{pct}} %.",
        comp_delta_hint:
          "Diferencia entre esta simulación y su estimación de referencia, en pensión neta mensual (referencia {{ref}}, simulación {{sim}}).",
        delta_hint:
          "Diferencia entre esta simulación y su estimación de referencia, en pensión neta mensual (referencia {{ref}}, simulación {{sim}}).",
        bubble_trim_missing:
          "Trimestres que le faltan en la fecha de jubilación para obtener la tasa completa.",
        bubble_penalite_cnav:
          "Número de trimestres de reducción efectivamente aplicados al cálculo de su pensión de base.",
        comp_brut: "bruto",
        resume_title: "En resumen",
        resume_cl_yes:
          "Podría beneficiarse del dispositivo «carrera larga» (jubilación anticipada posible).",
        resume_cl_no: "El dispositivo «carrera larga» no se activa en esta simulación.",
        resume_missing_one:
          "Le falta todavía {{count}} trimestre para la tasa plena en el mejor de los casos.",
        resume_missing_other:
          "Le faltan todavía {{count}} trimestres para la tasa plena en el mejor de los casos.",
        resume_missing_none: "Tiene todos los trimestres necesarios para la tasa plena.",
        resume_rachat_one:
          "Esta simulación incluye la compra de {{count}} trimestre ({{effect}}). El coste estimado y la rentabilidad figuran arriba.",
        resume_rachat_other:
          "Esta simulación incluye la compra de {{count}} trimestres ({{effect}}). El coste estimado y la rentabilidad figuran arriba.",
        resume_effect_opt1: "mejora únicamente su tasa",
        resume_effect_opt2: "mejora su tasa y su duración de seguro",
        table_title: "Comparar mis simulaciones",
        table_desc:
          "Cada simulación se compara con su estimación de base (resaltada). Su asesor le ayudará a elegir la situación más adecuada.",
        table_desc_self:
          "Cada simulación se compara con su estimación de base (resaltada). Compare libremente las situaciones para encontrar la que más le convenga.",
        table_col_simulation: "Simulación",
        table_base_row: "Estimación de base",
        table_ref: "referencia",
        form_title_edit: "Modificar la simulación",
        form_title_new: "Nueva simulación",
        form_desc: "Elija lo que quiere probar. Podrá modificarlo todo más tarde.",
        form_create: "Crear la simulación",
        form_name: "Nombre de la simulación",
        form_name_placeholder: "Ej. Jubilación en junio de 2030 con compra",
        form_err_name: "Déle un nombre a su simulación (ej. «Jubilación en junio de 2030»).",
        form_err_params:
          "Elija al menos una situación, una fecha de jubilación o una compra de trimestres.",
        form_scenarios_legend: "¿Qué situaciones quiere comparar?",
        form_scenarios_hint: "Marque una o varias situaciones. Cada una dará una estimación.",
        form_dates_legend: "¿Probar una o varias fechas de jubilación concretas?",
        form_dates_hint:
          "Por ejemplo una fecha propuesta por su empresa o una fecha importante para usted.",
        form_dates_hint_max:
          "Por ejemplo una fecha propuesta por su empresa. Fecha máxima autorizada: {{date}}.",
        form_err_max_date:
          "La fecha de jubilación no puede superar el {{date}} en su empresa. Solicite una fecha específica a su asesor.",
        form_err_max_date_self:
          "La fecha de jubilación no puede superar el {{date}} en su empresa. Puede solicitar que se habilite una fecha específica.",
        limit_hint_date: "Su empresa limita las simulaciones a jubilaciones hasta el {{date}}.",
        limit_hint_tpn:
          "Su empresa limita las simulaciones a la jubilación con tasa plena natural.",
        limit_request_cta: "Solicitar una fecha específica",
        limit_request_title: "Solicitar una fecha de jubilación específica",
        limit_request_desc:
          "Su asesor de Aon recibe la solicitud y puede habilitar la introducción libre de fechas en su expediente.",
        limit_request_desc_self:
          "Su departamento de RRHH recibe la solicitud y puede habilitar la introducción libre de fechas en su expediente.",
        limit_request_sent_self: "Solicitud enviada a su departamento de RRHH.",
        limit_request_pending_self:
          "Solicitud enviada el {{date}}, pendiente de su departamento de RRHH.",
        limit_request_message: "Su mensaje (opcional)",
        limit_request_placeholder: "Ej.: mi empresa me propone una salida el 30/06/2032.",
        limit_request_send: "Enviar la solicitud",
        limit_request_sent: "Solicitud enviada a su asesor de Aon.",
        limit_request_pending: "Solicitud enviada el {{date}}, pendiente de su asesor.",
        form_remove_date: "Quitar esta fecha",
        form_add_date: "Añadir una fecha de jubilación",
        form_rachat_title: "Simular una compra de trimestres",
        form_rachat_desc:
          "La compra permite «recomprar» trimestres faltantes (años de estudios, periodos incompletos) para jubilarse antes o aumentar su pensión.",
        form_rachat_nb: "¿Cuántos trimestres comprar? (1 a 12)",
        form_rachat_type: "¿Qué tipo de compra?",
        form_opt1_title: "Mejorar mi tasa",
        form_opt1_desc: "Reduce la penalización: su pensión se calcula con una tasa mejor.",
        form_opt2_title: "Mejorar mi tasa y mi duración",
        form_opt2_desc:
          "También cuenta en la duración de seguro: efecto más fuerte, coste más alto.",
        preview_unavailable:
          "Coste no disponible (baremo CNAV no configurado para su situación). Su asesor lo precisará.",
        preview_cost_one: "Coste estimado ({{count}} trimestre)",
        preview_cost_other: "Coste estimado ({{count}} trimestres)",
        desc_scenarios_one: "{{count}} situación comparada",
        desc_scenarios_other: "{{count}} situaciones comparadas",
        desc_dates_one: "{{count}} fecha de jubilación probada",
        desc_dates_other: "{{count}} fechas de jubilación probadas",
        desc_rachat_one: "compra de {{count}} trimestre",
        desc_rachat_other: "compra de {{count}} trimestres",
        desc_none: "Sin parámetros (jubilación a tasa plena por defecto)",
      },
      breakdown: {
        composition: "Composición de su pensión (bruta)",
        etage_base: "Régimen de base",
        etage_compl: "Complementaria",
        etage_suppl: "Suplementaria",
        reversion_label: "Pensión de viudedad estimada (cónyuge)",
        reversion_hint: "Pensión que podría abonarse a su cónyuge.",
        baisse_label: "Caída de ingresos en la jubilación",
        baisse_hint: "Diferencia entre sus ingresos de fin de carrera y su pensión.",
        per_month: "{{amount}} / mes",
        per_month_minus: "− {{amount}} / mes",
        regimes_detail: "Detalle por caja de jubilación ({{n}})",
        caisse_fallback: "Caja",
        mini_points: "Puntos",
        mini_point_value: "Valor del punto",
        mini_trim: "Trimestres validados",
        mini_trim_cotises: "Trim. cotizados",
        mini_trim_reputes: "Trim. reputados cotizados",
        mini_ram: "Ingreso anual medio",
        mini_majoration: "Bonificación por hijos",
        regime_base: "Base",
        regime_compl: "Complementaria",
        regime_suppl: "Suplementaria",
        surcote: "Bonificación",
        decote: "Penalización",
        surcote_title: "Aumento por jubilarse después de la tasa plena",
        decote_title: "Reducción por jubilación anticipada",
        bubble_decote_base:
          "Reducción del régimen de base: 1,25 % por trimestre que falte, con un máximo de 20 trimestres (25 %), aquí {{n}} trimestres, es decir {{pct}} %.",
        bubble_decote_base_short:
          "Reducción del régimen de base: 1,25 % por trimestre que falte, con un máximo de 20 trimestres (25 %).",
        bubble_decote_agirc:
          "Coeficiente de anticipación Agirc-Arrco: minoración aplicada cuando se jubila antes de tener la tasa completa, según el número de trimestres que falten, aquí un coeficiente de {{coeff}}.",
        bubble_surcote:
          "Bonificación: 1,25 % por trimestre adicional más allá de la tasa completa y de la edad legal, aquí +{{pct}} %.",
      },
      progressive: {
        title: "Jubilación progresiva",
        desc: "Trabaje a tiempo parcial al final de su carrera mientras percibe una parte de su pensión. Elija una jornada de trabajo para visualizar sus ingresos.",
        ineligible:
          "No es elegible para la jubilación progresiva: {{trimestres}} trimestres validados en la fecha de entrada, cuando se requieren {{min}}.",
        non_estime:
          "Importe no estimado: el motor de cálculo no simula la jubilación progresiva antes de la edad legal. Debe confirmarse con su caja de jubilación.",
        trim_unknown: "un número insuficiente de",
        date_debut: "Entrada posible desde el",
        date_fin: "Jubilación definitiva estimada",
        quotite_label: "Jornada de trabajo a tiempo parcial",
        salaire_partiel: "Salario a tiempo parcial ({{pct}} %)",
        pension_base: "Pensión básica ({{pct}} %)",
        pension_compl: "Complementaria ({{pct}} %)",
        total: "Ingreso mensual total",
        note_net:
          "Importes netos estimados: el salario a tiempo parcial se aproxima a partir de su ingreso bruto (alrededor del 78 %).",
        detail_title: "Método de cálculo — complementaria Agirc-Arrco",
        detail_points: "Puntos adquiridos a la entrada",
        detail_vp: "Valor del punto",
        detail_coeff: "Coeficiente Agirc-Arrco",
        detail_minoration: "reducción del {{pct}} %",
        detail_majoration: "incremento del {{pct}} %",
        detail_taux_plein: "tasa plena",
        detail_formula:
          "Pensión complementaria a la entrada = puntos × valor del punto × coeficiente; la fracción abonada se prorratea por (100 % − jornada trabajada).",
        detail_unverified:
          "Se detectó una discrepancia entre este recálculo y el importe del motor de cálculo: se conserva el importe del motor.",
      },
      pdf: {
        title: "Su simulación en PDF",
        desc: "Descargue el resumen completo de su simulación de jubilación (situación, derechos, carrera, puntos de atención y parámetros).",
        download: "Descargar mi simulación",
        failed: "La generación del documento ha fallado.",
      },
      charts: {
        title: "Comparativa de sus escenarios",
        desc: "Pensión mensual (bruta y neta) por escenario, curva de la tasa de sustitución y referencia de sus ingresos actuales.",
        serie_brut: "Pensión bruta",
        serie_net: "Pensión neta",
        serie_taux: "Tasa de sustitución",
        axis_month: "€ / mes",
        axis_taux: "Tasa",
        current_income: "Ingresos actuales: {{amount}}",
        estimation: "Estimación",
        date_visee: "En la fecha deseada",
      },
      audit: {
        title: "Fiabilidad de su historial",
        desc: "Analizamos su carrera para detectar posibles omisiones o incoherencias antes del cálculo.",
        run: "Verificar mi carrera",
        rerun: "Relanzar la verificación",
        failed: "La verificación ha fallado.",
        hint: "Lance la verificación para detectar automáticamente los puntos a corregir (periodos faltantes, ingresos nulos, caídas inusuales…).",
        clean: "Ninguna anomalía detectada: su historial parece coherente.",
        points_one: "{{count}} punto a verificar. Su asesor puede ayudarle a corregirlo.",
        points_other: "{{count}} puntos a verificar. Su asesor puede ayudarle a corregirlos.",
        action_add: "Por añadir",
        action_modify: "Por modificar",
        occurrences_one: "{{count}} ocurrencia",
        occurrences_other: "{{count}} ocurrencias",
        fallback: "Punto a verificar",
        code_serviceMilitaire: "Servicio militar ausente",
        code_avpfSansEnfant: "Periodo AVPF sin hijo",
        code_indiceFonct: "Índice de fin de carrera faltante",
        code_revenuNul: "Ingreso nulo en un periodo",
        code_jeuneParent: "Diferencia de edad padre / hijo inusual",
        code_baisseRevenu: "Caída importante de ingresos",
        code_tauxActivite: "Tasa de actividad a verificar",
        code_periodeJour: "Periodo de un solo día",
        code_periodeSansInformation: "Periodo sin información",
        code_periodeAnnuelleSansInformation: "Año sin información",
        fiche_toggle: "Comprender y corregir",
        fiche_explication: "Explicación",
        fiche_recommandation: "Acción recomendada",
        fiche_pieces: "Documentos a reunir",
      },
      revenus: {
        title: "Evolución de sus ingresos",
        desc: "Reconstitución de sus ingresos profesionales, año por año, hasta su jubilación. Importes anuales expresados en euros.",
        run: "Proyectar mis ingresos",
        rerun: "Recalcular",
        failed: "El cálculo ha fallado.",
        hint: "Lance la proyección para visualizar la evolución de sus ingresos profesionales a lo largo de su carrera.",
        empty: "No se pudo proyectar ningún ingreso utilizable a partir de su historial.",
        serie_percu: "Ingresos anuales percibidos",
        serie_projete: "Ingresos anuales proyectados",
      },
      points: {
        title: "Sus puntos Agirc-Arrco",
        desc: "Puntos de jubilación complementaria adquiridos cada año, según su extracto de carrera.",
        points_unit: "puntos",
        drop_tooltip: "−{{pct}} % vs {{prev}} pts el año anterior",
        table_year: "Año",
        table_points: "Puntos adquiridos",
        table_diff: "Variación (puntos)",
        table_diff_pct: "Variación (%)",
        table_flag: "Constatación",
        table_drop: "Descenso marcado",
        table_expand: "Ver los {{count}} años anteriores",
        table_collapse: "Reducir la tabla",
        drop_legend:
          "Un descenso de puntos puede corresponder a un período de desempleo, de tiempo parcial o a un dato que falte en su extracto. Su asesor lo verifica con usted.",
      },
      rachatPanel: {
        unavailable_title: "Coste de la compra no disponible",
        unavailable_desc:
          "El baremo CNAV aún no está configurado para su situación (edad / tramo de ingresos). Su asesor Aon le indicará el coste exacto.",
        title: "Coste y rentabilidad de la compra",
        subtitle_one: "Estimación para {{count}} trimestre · opción «{{option}}»",
        subtitle_other: "Estimación para {{count}} trimestres · opción «{{option}}»",
        option_taux_duree: "Tasa + duración de seguro",
        option_taux_seul: "Solo tasa",
        cost: "Coste estimado",
        cost_hint: "{{amount}} / trimestre",
        gain: "Ganancia estimada",
        gain_value: "+{{amount}} / mes",
        gain_hint_year: "{{amount}} / año",
        gain_hint_base: "vs estimación de base",
        amort: "Amortizado en",
        amort_year: "{{years}} año",
        amort_years: "{{years}} años",
        amort_hint_yes: "luego ganancia neta",
        amort_hint_no: "ganancia no determinada",
        other_option: "Otra opción «{{option}}»:",
        tax_note_1: "Importe ",
        tax_note_strong: "deducible de su renta imponible",
        tax_note_2:
          ": el coste real después de impuestos es inferior (según su tramo marginal de imposición). Estimación indicativa basada en el baremo CNAV{{year}}; su asesor Aon afinará el cálculo.",
        c2_desc: "No necesita comprar trimestres: obtendrá la tasa plena a la edad legal.",
      },
      rachatTauxPlein: {
        option_taux_seul: "solo tasa",
        option_taux_duree: "tasa y duración",
        title: "Compra de trimestres para la tasa plena",
        subtitle_one:
          "{{count}} trimestre comprado para una jubilación a la edad legal (opción {{option}})",
        subtitle_other:
          "{{count}} trimestres comprados para una jubilación a la edad legal (opción {{option}})",
        plafond: "(límite legal de 12 trimestres alcanzado)",
        sans_rachat: "Sin compra",
        avec_rachat: "Con compra",
        per_month: "pensión neta / mes a la edad legal",
        cout: "Coste estimado",
        cout_hint: "opción {{option}}, baremo indicativo",
        roi: "Plazo de amortización",
        roi_years: "{{years}} años",
        gain_hint: "ganancia de {{amount}} / mes",
        taux_plein_ok:
          "La tasa plena se alcanza en la fecha de jubilación gracias a los trimestres comprados.",
        taux_plein_ko:
          "Los trimestres comprados le acercan a la tasa plena sin alcanzarla en esa fecha.",
        caution:
          "Los años realmente comprables (estudios, años incompletos) deben confirmarse con su caja de jubilación.",
        c2_title: "No hace falta comprar",
        c2_desc: "No necesita comprar trimestres: obtendrá la tasa plena a la edad legal.",
      },
    },
    placeholder: {
      coming_soon: "Esta funcionalidad estará disponible pronto.",
    },
  },
  admin: {
    referentiels: {
      kicker: "Administración",
      title: "Actualidad de los referenciales",
      description:
        "Fecha de última actualización de cada referencial interno (baremo de compra y PASS, catálogos, listas de control, bibliotecas), con alerta más allá del plazo esperado.",
      table_title: "Referenciales internos",
      ref_rachat_bareme: "Baremo de compra de trimestres (añada activa)",
      ref_document_types: "Tipos de documentos",
      ref_controle_checklist: "Lista de autocontrol N1 / N2",
      ref_bri_annexes: "Anexos BRI",
      ref_email_templates: "Plantillas de correo",
      ref_content_library: "Biblioteca de contenidos",
      ref_anomalie_types: "Biblioteca de anomalías",
      ref_points_attention: "Biblioteca de puntos de atención",
      ref_conventions_collectives: "Convenios colectivos (IDCC)",
      updated_on: "Última actualización: {{date}}",
      never_updated: "Nunca completado",
      badge_ok: "Al día",
      badge_stale: "A verificar ({{days}} d)",
      badge_empty: "Vacío",
      engine_note:
        "El motor de cálculo de jubilación lo opera su editor, que no expone información de versión utilizable: su fecha de actualización no se sigue aquí de forma deliberada.",
    },
    refprof: {
      kicker: "Administración",
      title: "Referencial de profesiones y regímenes",
      description:
        "Correspondencia entre las profesiones gestionadas por el motor de cálculo y sus regímenes de jubilación (base, complementario, suplementario). Se deduce de los cálculos del motor y luego puede corregirse manualmente: sus correcciones se conservan en cada regeneración.",
      actions_title: "Alimentación automática",
      refresh: "Actualizar la lista",
      generate: "Generar el referencial ({{count}} llamadas)",
      last_refresh: "Lista de profesiones actualizada el {{date}}",
      never_refreshed:
        "Lista de profesiones nunca actualizada: ejecute primero « Actualizar la lista ».",
      refreshed: "{{count}} profesiones obtenidas del motor.",
      generated: "Referencial generado para {{count}} profesiones de {{total}} en {{seconds}} s",
      failures: "profesiones sin resultado: {{codes}}",
      list_title: "Profesiones y regímenes",
      search: "Buscar una profesión…",
      empty:
        "Ninguna profesión: ejecute « Actualizar la lista » para cargar el referencial desde el motor.",
      sans_famille: "Sin familia",
      no_regime: "Ningún régimen registrado para esta profesión.",
      add_regime: "Añadir un régimen",
      new_code: "Código de caja",
      new_libelle: "Nombre",
      rename: "Renombrar",
      hide: "Ocultar",
      show: "Mostrar de nuevo",
      badge_auto: "auto",
      badge_manuel: "manual",
      badge_masque: "oculto",
      classif_base: "régimen de base",
      classif_complementario: "complementario",
      classif_supplementaire: "suplementario",
    },
    conv: {
      kicker: "Administración",
      title: "Convenios colectivos",
      description:
        "Referencial de convenios colectivos (códigos IDCC), cargado desde la lista oficial DILA y ampliable por importación Excel/CSV o entrada manual. Dato conservado para la previsión: no tiene efecto sobre el cálculo de la jubilación.",
      list_title: "Referencial",
      search_title: "Convenios",
      search: "Buscar por nombre o IDCC…",
      import: "Importar (Excel/CSV)",
      import_empty: "Ninguna línea válida en el archivo.",
      imported:
        "Importación terminada: {{added}} añadidos, {{modified}} modificados de {{total}} líneas.",
      duplicates: "{{count}} IDCC duplicados ignorados",
      add: "Añadir",
      new_idcc: "IDCC",
      new_libelle: "Nombre",
      rename: "Renombrar",
      activate: "Reactivar",
      deactivate: "Desactivar",
      active: "activo",
      inactive: "inactivo",
      source_dila: "DILA",
      source_import: "import",
      source_manuel: "manual",
      count: "{{total}} convenios, {{active}} activos",
      empty: "Ningún convenio coincide con la búsqueda.",
      col_idcc: "IDCC",
      col_label: "Nombre",
      col_status: "Estado",
      col_actions: "Acciones",
      sort_by: "Ordenar por {{column}}",
      unit: "convenios",
    },
    dashboard: {
      kicker: "Administración",
      title: "Consola admin Aon",
      description: "Vista general de la plataforma: clientes, operaciones, usuarios.",
      overview: "Vista general",
      quick_links: "Accesos rápidos",
      open: "Abrir",
      guided_start: "Inicio guiado",
      onboard_title: "Incorporar una nueva empresa",
      onboard_desc:
        "Un asistente paso a paso: empresa, campaña BRI y primeros empleados invitados. La forma más sencilla de configurar todo.",
      launch_wizard: "Lanzar el asistente",
      stat_groups: "Grupos de clientes",
      stat_societes: "Empresas",
      stat_operations: "Operaciones en curso",
      stat_dossiers: "Expedientes activos",
      hint_salaries_total: "{{count}} empleados en total",
      hint_operations_total: "{{count}} en total (todos los estados)",
      hint_dossiers_production: "{{count}} en producción",
      stat_urgents: "Expedientes urgentes en curso",
      hint_urgents: "Sin restituir, marcados prioritarios",
      stat_urgence_delai: "Plazo medio de restitución",
      stat_urgence_delai_suffix: "días laborables",
      hint_urgence_delai: "Sobre {{count}} expediente(s) restituido(s) en 90 días",
      link_tenants_title: "Grupos y empresas",
      link_tenants_desc: "Crear / editar clientes, gestionar la jerarquía.",
      link_operations_title: "Operaciones BRI",
      link_operations_desc: "Lanzar una nueva campaña, pilotar las existentes.",
      link_users_title: "Usuarios y roles",
      link_users_desc: "Invitar, asignar roles y ámbitos.",
      link_branding_title: "Marca",
      link_branding_desc: "Logos, colores y etiquetas por empresa.",
    },
    tenants: {
      kicker: "Administración",
      title: "Grupos, empresas y filiales",
      description:
        "Jerarquía de clientes: grupos → empresas → filiales (BU y sedes). Las operaciones BRI se gestionan por separado.",
      add_groupe: "Nuevo grupo",
      add_societe: "Nueva empresa",
      search_placeholder: "Buscar un grupo, empresa o SIREN…",
      empty_title: "Aún no hay clientes",
      empty_description: "Cree su primer grupo de clientes o empresa para empezar.",
      empty_action: "Crear un grupo",
      slug_label: "slug",
      inactive: "Inactivo",
      confidential_badge: "Confidencial",
      confidential_hint:
        "Los datos personales de los empleados de esta sociedad solo son visibles para los super-admins y los internos de Aon autorizados.",
      societe_button: "Empresa",
      emails_button: "Correos",
      emails_title: "Biblioteca de plantillas de correo del grupo",
      edit: "Editar",
      delete: "Eliminar",
      no_societes_in_group: "Ninguna empresa vinculada a este grupo.",
      independent_societes: "Empresas independientes",
      independent_description: "{{count}} empresa(s) sin grupo principal.",
      societes_count: "{{count}} empresa(s)",
      page: "Página {{page}} de {{total}}",
      previous: "Anterior",
      next: "Siguiente",
      drh_label: "DRH",
      group_delete_title: "¿Eliminar el grupo « {{name}} » ?",
      group_delete_description:
        "Las empresas vinculadas permanecerán pero se desvincularán del grupo.",
      group_delete_confirm: "Eliminar grupo",
      societe_delete_title: "¿Eliminar la empresa « {{name}} » ?",
      societe_delete_description:
        "Todas las operaciones y empleados asociados a esta empresa también se eliminarán.",
      irreversible: "Esta acción es irreversible.",
      societe_delete_confirm: "Eliminar definitivamente",
      logo_alt: "Logo {{name}}",
      subsidiaries: "Filiales",
      add_filiale: "Nueva filial",
      no_filiales: "Ninguna filial vinculada a esta empresa.",
      siren: "SIREN",
      siret: "SIRET",
      bu: "BU",
      sites_count: "{{count}} sede(s)",
      filiale_delete_title: "¿Eliminar la filial « {{name}} » ?",
      filiale_delete_description:
        "{{business_units_count}} BU · {{sites_count}} sede(s) también se eliminarán.",
      filiale_delete_confirm: "Eliminar definitivamente",
    },
    tenantForms: {
      cancel: "Cancelar",
      save: "Guardar",
      groupe: {
        new_title: "Nuevo grupo",
        edit_title: "Modificar el grupo « {{name}} »",
        new_description:
          "Un grupo es la entidad raíz de un cliente (p. ej. TotalEnergies, BNP Paribas).",
        edit_description: "Modificación de la información del grupo cliente.",
        create: "Crear el grupo",
        siren_prefill_label: "Pre-relleno por SIREN",
        siren_prefill_hint:
          "Introduzca el SIREN del grupo para recuperar automáticamente el nombre y la descripción.",
        siren_label: "SIREN",
        siren_hint: "9 cifras. Rellenado automáticamente por la búsqueda anterior.",
        siren_error: "El SIREN debe contener 9 cifras",
        nom_label: "Nombre del grupo",
        nom_error: "El nombre debe tener al menos 2 caracteres",
        slug_label: "Identificador URL (slug)",
        slug_error: "El slug solo puede contener letras minúsculas, números y guiones",
        slug_hint:
          "Se utiliza para las URL y las exportaciones. Editable pero mejor evitarlo una vez en producción.",
        description_label: "Descripción",
        description_placeholder: "Actividad, ámbito, contexto…",
        logo_label: "Logotipo del grupo",
        logo_hint:
          "El logotipo se mostrará en el encabezado del espacio cliente (formatos recomendados: SVG, PNG transparente).",
        logo_url_error: "URL no válida",
        active_label: "Grupo activo",
        active_description: "Desactívelo para ocultar este grupo sin eliminarlo.",
        bri_title: "Configuración BRI",
        bri_description: "Configuración del soporte BRI deseada por el cliente a nivel de grupo.",
        simulations_label: "Simulaciones deseadas",
        simulations_autres_label: "Otras simulaciones",
        simulations_autres_placeholder: "Ej. simulación de expatriación, jubilación anticipada…",
        simulations_autres_hint: "Simulaciones adicionales no listadas arriba.",
        simulation_temps_partiel: "Tiempo parcial",
        simulation_retraite_progressive: "Jubilación progresiva",
        simulation_rachat_trimestres: "Recompra de trimestres",
        simulation_cumul_emploi_retraite: "Acumulación empleo-jubilación",
        simulation_carriere_longue: "Carrera larga",
        annexes_label: "Anexos tipo del soporte",
        annexes_hint:
          "Fichas de la biblioteca que componen el soporte BRI validado por el cliente.",
        annexes_empty: "No hay ficha activa en la biblioteca. Créalas en « Anexos BRI ».",
        annexes_precision_label: "Precisiones sobre los anexos",
        annexes_precision_placeholder:
          "Anexos específicos, menciones particulares solicitadas por el cliente…",
        diffusion_label: "Autorización de difusión",
        diffusion_hint: "Define el intercambio de información BRI entre el empleado y la empresa.",
        diffusion_souhait_salarie_label: "Según el deseo del empleado",
        diffusion_souhait_salarie_description:
          "El empleado elige libremente la información compartida con la empresa.",
        diffusion_accord_partiel_label: "Acuerdo obligatorio — parcial",
        diffusion_accord_partiel_description:
          "Compartir obligatoriamente la fecha de tasa plena natural con la empresa.",
        diffusion_accord_total_label: "Acuerdo obligatorio — total",
        diffusion_accord_total_description:
          "Compartir obligatoriamente el soporte BRI completo con la empresa.",
      },
      societe: {
        new_title: "Nueva sociedad cliente",
        edit_title: "Modificar « {{name}} »",
        new_description:
          "Una sociedad es la entidad jurídica cliente (SIREN/SIRET). Tenant principal para las operaciones BRI.",
        edit_description: "Modificación de la información legal y de contacto.",
        create: "Crear la sociedad",
        siren_prefill_hint:
          "Introduzca el SIREN de la sociedad para pre-rellenar nombre, razón social, SIRET, código NAF y dirección de la sede.",
        section_identification: "Identificación",
        groupe_parent_label: "Grupo padre",
        option_no_groupe: "Ninguno (sociedad independiente)",
        nom_commercial_label: "Nombre comercial",
        nom_error: "El nombre debe tener al menos 2 caracteres",
        slug_label: "Slug",
        slug_error: "El slug solo puede contener letras minúsculas, números y guiones",
        raison_sociale_label: "Razón social",
        raison_sociale_placeholder: "TotalEnergies SA",
        siren_label: "SIREN",
        siren_error: "El SIREN debe contener 9 cifras",
        siret_label: "SIRET de la sede",
        siret_error: "El SIRET debe contener 14 cifras",
        code_naf_label: "Código NAF",
        section_adresse: "Dirección de la sede",
        adresse_label: "Calle",
        code_postal_label: "Código postal",
        ville_label: "Ciudad",
        pays_label: "País",
        section_contact_drh: "Contacto RRHH",
        drh_nom_label: "Nombre",
        drh_email_label: "Correo electrónico",
        email_error: "Correo electrónico no válido",
        drh_phone_label: "Teléfono",
        section_accords_seniors: "Acuerdos senior",
        accords_seniors_description:
          "Dispositivos senior aplicables (tiempo parcial senior, jubilación progresiva, ajustes de fin de carrera, indemnizaciones de salida…). Este contenido se transmite a la IA para personalizar el balance de jubilación de los empleados.",
        accord_branche_label: "Acuerdo de rama",
        accord_branche_placeholder:
          "Disposiciones del convenio colectivo / rama relativas a los seniors…",
        accord_entreprise_label: "Acuerdo de empresa",
        accord_entreprise_placeholder:
          "Disposiciones negociadas dentro de la empresa relativas a los seniors…",
        active_label: "Sociedad activa",
        active_description: "Desactívela para ocultar esta sociedad sin eliminarla.",
        confidential_label: "Sociedad confidencial",
        confidential_description:
          "Oculta los datos personales de los empleados a los internos de Aon no autorizados. La sociedad, sus operaciones y su configuración siguen visibles.",
        confidential_readonly:
          "Sociedad confidencial: solo un super-admin puede cambiar este ajuste.",
        confidential_access_title: "Accesos confidenciales",
        confidential_access_hint:
          "Internos de Aon autorizados a ver los datos personales de los empleados de esta sociedad (los super-admins siempre tienen acceso).",
        confidential_access_empty: "Ningún interno autorizado por el momento.",
        confidential_access_add_label: "Añadir un interno de Aon",
        confidential_access_add_placeholder: "Elegir un usuario interno…",
        confidential_access_add: "Autorizar",
        confidential_access_remove: "Retirar este acceso",
        confidential_access_readonly:
          "La lista de accesos confidenciales solo es visible para un super-admin.",
      },
      filiale: {
        new_title: "Nueva filial",
        edit_title: "Modificar la filial « {{name}} »",
        description_with_parent: "Vinculada a la sociedad {{societe}}.",
        description_without_parent:
          "Una filial es una entidad jurídica vinculada a una sociedad del grupo.",
        create: "Crear la filial",
        finish: "Finalizar",
        tab_identification: "Identificación",
        tab_parametrage: "Configuración",
        siren_mismatch_title: "SIREN distinto al de la sociedad matriz",
        siren_mismatch_message:
          "El SIRET proporcionado pertenece al SIREN {{siren}}, distinto del de la sociedad matriz ({{societe_siren}}).",
        siret_prefill_hint:
          "Introduzca el SIRET de la filial para pre-rellenar nombre y dirección.",
        section_identification: "Identificación",
        nom_label: "Nombre de la filial",
        nom_error: "El nombre debe tener al menos 2 caracteres",
        slug_label: "Slug",
        slug_error: "El slug solo puede contener letras minúsculas, números y guiones",
        siret_label: "SIRET",
        siret_hint: "14 cifras. Opcional — rellenado automáticamente por la búsqueda anterior.",
        siret_error: "El SIRET debe contener 14 cifras",
        section_adresse: "Dirección",
        adresse_label: "Dirección",
        code_postal_label: "Código postal",
        ville_label: "Ciudad",
        pays_label: "País",
        active_label: "Filial activa",
        active_description: "Desactívela para ocultar esta filial sin eliminarla.",
        info_create_parametrage:
          "Podrá añadir las Business Units y los sitios geográficos en la pestaña Configuración una vez creada la filial.",
        business_units_title: "Business Units",
        bu_empty: "No hay ninguna Business Unit por el momento.",
        bu_add_label: "Añadir una Business Unit",
        bu_add_button: "Añadir",
        bu_delete_confirm: "¿Eliminar la Business Unit « {{name}} » ?",
        bu_delete_confirm_description: "Los sitios y empleados vinculados se desvincularán.",
        bu_delete_button: "Eliminar",
        bu_edit_name_label: "Nombre",
        bu_edit_slug_hint: "Slug actual: {{slug}} (no editable)",
        bu_edit_active_label: "Business Unit activa",
        sites_title: "Sitios geográficos",
        sites_empty: "No hay ningún sitio por el momento.",
        site_add_title: "Añadir un sitio",
        site_nom_label: "Nombre del sitio",
        site_adresse_label: "Calle",
        site_cp_label: "Código postal",
        site_ville_label: "Ciudad",
        site_add_button: "Añadir el sitio",
        site_delete_confirm: "¿Eliminar el sitio « {{name}} » ?",
        site_delete_confirm_description: "Esta acción es irreversible.",
        site_delete_button: "Eliminar",
        site_edit_nom_label: "Nombre del sitio",
        site_edit_adresse_label: "Calle",
        site_edit_cp_label: "Código postal",
        site_edit_ville_label: "Ciudad",
        site_edit_active_label: "Sitio activo",
        site_edit_slug_hint: "Slug actual: {{slug}} (no editable)",
        site_no_address: "Sin dirección",
        inactive_badge: "Inactivo",
        edit_button_aria: "Modificar",
        delete_button_aria: "Eliminar",
      },
    },
    users: {
      kicker: "Administración",
      title: "Usuarios y accesos",
      description: "Roles funcionales y ámbitos de acceso por empresa y operación.",
      tab_active: "Usuarios",
      tab_invitations: "Invitaciones",
      invite: "Invitar a un usuario",
      edit_access: "Editar accesos",
      resend: "Reenviar",
      resend_title: "Reenviar el correo de invitación",
      revoke: "Revocar",
      revoke_edit: "Editar",
      resend_success: "Correo reenviado a {{recipient}}.",
      resend_error: "Error al enviar",
      revoke_success: "Invitación revocada.",
      revoke_confirm: "¿Revocar esta invitación?",
      no_users: "Sin usuarios",
      no_users_desc:
        "Invite a un usuario desde la pestaña Invitaciones: recibirá un correo de activación para unirse a la plataforma.",
      no_invitations: "Sin invitaciones pendientes",
      no_invitations_desc:
        "Todas las invitaciones han sido aceptadas o no se ha creado ninguna todavía.",
      search_placeholder: "Nombre, correo, rol…",
      last_login: "Último acceso",
      never_logged_in: "Nunca conectado",
      role: "Rol",
      scope: "Ámbito",
      invited_at: "Invitado el",
      invited_by: "Invitado por",
      invitation_sent: "Invitación enviada a {{recipient}}.",
      invitation_pending_count_one: "{{count}} invitación pendiente",
      invitation_pending_count_other: "{{count}} invitaciones pendientes",
      badge_disabled: "Desactivado",
      badge_expired: "Expirada",
      badge_expired_hint:
        "Invitación expirada: haz clic en Reenviar para prolongarla 30 días y reenviar el correo.",
      apply_error_label: "Error al activar la cuenta:",
      societies_count_one: "{{count}} empresa",
      societies_count_other: "{{count}} empresas",
      operations_count_one: "{{count}} operación",
      operations_count_other: "{{count}} operaciones",
      region_scope: "Región: {{region}}",
      close: "Cerrar",
      // InviteUserDrawer
      invite_drawer_title_new: "Invitar a un usuario",
      invite_drawer_title_edit: "Invitar a {{email}}",
      invite_drawer_desc_new:
        "El correo de activación se envía inmediatamente al destinatario. En el primer acceso, sus roles y ámbitos se aplicarán automáticamente.",
      invite_drawer_desc_edit:
        "Actualizar la invitación y reenviar un correo de activación al destinatario.",
      invite_info:
        "Se enviará inmediatamente al destinatario un correo de invitación con un enlace de activación tras la creación.",
      section_contact: "Datos de contacto",
      field_email: "Correo electrónico",
      field_email_placeholder: "nombre.apellido@empresa.com",
      field_prenom: "Nombre (opcional)",
      field_nom: "Apellidos (opcional)",
      field_note: "Nota interna (opcional)",
      field_note_placeholder: "Contexto, equipo, etc.",
      section_roles: "Roles a asignar",
      roles_required: "Seleccione al menos un rol para crear la invitación.",
      roles_rules:
        "Los empleados no se invitan aquí: cree una ficha de empleado. Una misma cuenta no puede combinar RRHH y equipo Aon.",
      roles_exclusive_hint: "Incompatible con los roles ya seleccionados (RRHH ↔ equipo Aon).",
      salarie_conflict_title: "Este correo pertenece a un empleado",
      salarie_conflict_desc:
        "La dirección {{email}} es la del empleado {{name}} (matrícula {{matricule}}). Un empleado no puede recibir una cuenta del equipo Aon: utilice otra dirección o retire primero este correo de su ficha. El acceso RRHH, en cambio, sí puede añadirse a esta dirección.",
      section_options: "Opciones",
      option_create_salarie_label: "Permitir la creación manual de una cuenta de empleado",
      option_create_salarie_desc:
        "Permite a este usuario crear cuentas de empleado por sí mismo dentro de su ámbito.",
      section_scope: "Ámbito de acceso",
      scope_hint:
        "Marcar un nivel concede acceso a todo lo que contiene: una empresa cubre sus filiales, UEN, centros y operaciones; solo una filial restringe el acceso a esa filial.",
      global_access_title: "Acceso global automático",
      global_access_desc:
        "El rol de Administrador Aon otorga automáticamente acceso a todos los grupos, empresas, filiales, UEN, centros y operaciones. No hay ámbito que marcar.",
      cancel: "Cancelar",
      submit_new: "Crear y enviar correo",
      submit_edit: "Actualizar y reenviar",
      // UserAccessDrawer
      access_drawer_title: "Accesos de {{name}}",
      btn_impersonate: "Ver como",
      impersonate_self: "No puede suplantarse a sí mismo.",
      impersonate_inactive: "Esta cuenta está desactivada.",
      impersonate_title: "Iniciar sesión como este usuario",
      impersonate_internal_disabled:
        "Suplantación imposible: esta cuenta tiene un rol interno de Aon.",
      impersonate_denied:
        "Suplantación denegada: este usuario pertenece a una sociedad confidencial o a un perímetro protegido.",
      mfa_enabled: "2FA activada",
      mfa_disabled: "2FA no activada",
      mfa_section: "Doble autenticación",
      mfa_reset_title: "Restablecer la doble autenticación",
      mfa_reset_disabled: "No hay 2FA que restablecer.",
      mfa_reset_self: "No puede restablecer su propia 2FA aquí.",
      mfa_reset_button: "Restablecer la doble autenticación",
      mfa_reset_hint:
        "Elimina el factor TOTP y los códigos de recuperación de la cuenta. El usuario deberá inscribir una nueva aplicación en su próxima conexión.",
      mfa_reset_confirm_title: "¿Restablecer la 2FA de {{name}}?",
      mfa_reset_confirm_desc:
        "Su aplicación de autenticación y sus códigos de recuperación serán eliminados. Deberá inscribir una nueva aplicación en su próxima conexión. La acción queda registrada en el journal de auditoría.",
      mfa_reset_confirm_button: "Restablecer",
      btn_deactivate: "Desactivar",
      btn_reactivate: "Reactivar",
      btn_delete: "Eliminar",
      delete_self_disabled: "No puede eliminar su propia cuenta.",
      delete_admin_disabled: "Retire primero el rol admin_aon antes de eliminar esta cuenta.",
      super_admin_readonly:
        "Cuenta super-admin: solo un super-admin puede modificar sus roles, su estado o eliminarla.",
      super_admin_only_hint: "El rol super_admin solo puede otorgarlo o revocarlo un super-admin.",
      delete_title_default: "Eliminar cuenta definitivamente",
      save: "Guardar",
      section_functional_roles: "Roles funcionales",
      delete_confirm_title: "¿Eliminar a {{name}}?",
      delete_confirm_desc:
        "Esta acción es irreversible. La cuenta se eliminará definitivamente junto con sus roles y ámbitos.",
      delete_confirm_note:
        "El historial (expedientes, documentos, auditoría) se conserva, pero el autor quedará anonimizado.",
      delete_confirm_button: "Eliminar definitivamente",
      // ScopeSelector
      scope_groups: "Grupos",
      scope_companies: "Empresas",
      scope_subsidiaries: "Filiales",
      scope_business_units: "Unidades de Negocio",
      scope_sites: "Centros",
      scope_operations: "Operaciones",
      scope_empty_groups: "Sin grupos.",
      scope_empty_companies: "Sin empresas. Cree una desde la pestaña Tenants.",
      scope_empty_subsidiaries: "Sin filiales.",
      scope_empty_bus: "Sin UEN.",
      scope_empty_sites: "Sin centros.",
      scope_empty_operations: "Sin operaciones. Cree una desde la pestaña Operaciones.",
      scope_no_results: "Sin resultados.",
      scope_selected_one: "{{count}} seleccionado",
      scope_selected_other: "{{count}} seleccionados",
      scope_search: "Buscar…",
    },
    operations: {
      kicker: "Administración",
      title: "Operaciones BRI",
      description: "Todas las campañas (borrador, planificadas, en curso, cerradas).",
      add: "Nueva operación",
      edit: "Editar operación",
      no_operations: "Ninguna operación creada.",
      search_placeholder: "Buscar una operación…",
      year: "Año",
      societe: "Empresa",
      status: "Estado",
      dossiers_count: "Expedientes",
      start_date: "Fecha de inicio",
      end_date: "Fecha de fin",
      active: "Activa",
      closed: "Cerrada",
      draft: "Borrador",
      filter_search: "Buscar",
      filter_placeholder: "Nombre, slug, empresa…",
      filter_all_societes: "Todas",
      filter_all_status: "Todos",
      empty_title_default: "Ninguna operación creada",
      empty_title_filtered: "Ningún resultado para estos filtros",
      empty_desc_default: "Cree su primera operación BRI para empezar.",
      empty_desc_filtered: "Ajuste sus filtros o cree una nueva operación.",
      empty_action: "Crear una operación",
      count: "{{count}} operación(es)",
      group_label: "Grupo",
      date_from: "del {{date}}",
      date_to: "al {{date}}",
      edit_aria: "Editar",
      delete_aria: "Eliminar",
      delete_title: '¿Eliminar la operación "{{name}}"?',
      delete_desc: "Todos los expedientes asociados a esta operación también se eliminarán.",
      delete_irreversible: "Esta acción es irreversible.",
      delete_confirm: "Eliminar definitivamente",
      form: {
        title_new: "Nueva operación BRI",
        title_edit: 'Editar la operación "{{name}}"',
        description_new:
          "Una operación es una campaña BRI vinculada a un grupo, una empresa o una filial.",
        description_edit: "Modificación de los parámetros de la campaña.",
        cancel: "Cancelar",
        save: "Guardar",
        create: "Crear la operación",
        scope_section: "Perímetro",
        management_section: "Gestión",
        documents_section: "Documentos solicitados (según el recorrido)",
        documents_hint:
          "Los documentos base (vida laboral, Agirc-Arrco, nómina) siempre se solicitan. Active aquí los documentos propios de este recorrido, como el informe de pensión complementaria.",
        no_configurable_types: "Ningún tipo de documento configurable.",
        required_checkbox: "Obligatorio",
        attachment_level: "Nivel de vinculación",
        client_group: "Grupo cliente",
        client_societe: "Empresa cliente",
        filiale: "Filial",
        operation_name: "Nombre de la operación",
        slug: "Slug",
        campaign_year: "Año de campaña",
        start_date: "Fecha de inicio",
        end_date: "Fecha de fin",
        status: "Estado",
        chef_projet: "Jefe de proyecto Aon",
        chef_projet_hint:
          "Interlocutor Aon único del responsable de RRHH para esta operación: sostiene la mensajería RRHH ↔ jefe de proyecto.",
        search_chef_projet: "Buscar un jefe de proyecto…",
        bri_type_default: "Tipo de BRI",
        bri_type_hint:
          "Se aplica a todos los expedientes de la operación. En BRI flash, el empleado debe indicar sus preferencias antes de acceder a su BRI.",
        salary_band: "Categoría salarial",
        salary_band_placeholder: "Seleccionar una categoría",
        salary_band_hint:
          "Los empleados de una operación de categoría única la heredan; en una operación mixta, la categoría se indica empleado por empleado.",
        formation_required_label: "Formación obligatoria antes del recorrido",
        formation_required_hint:
          "Si está activado, el empleado debe haber asistido a una formación para acceder a su recorrido de jubilación. Si está desactivado, accede directamente al recorrido digital.",
        parcours_section: "Recorrido de simulación",
        parcours_hint:
          "Define lo que el empleado puede simular por su cuenta. Un asesor de Aon puede desbloquear un expediente concreto desde su ficha.",
        parcours_type_label: "Tipo de recorrido del empleado",
        parcours_type_digital: "100% digital",
        parcours_type_digital_humain: "Digital y humano",
        parcours_type_vip: "VIP",
        parcours_type_digital_hint:
          "Empleado autónomo, lejos de la jubilación: simulaciones dentro del rango de edad definido, asistente de IA y mensajería. Sin citas, sin línea telefónica y sin gestión por la producción de Aon.",
        parcours_type_digital_humain_hint:
          "El empleado completa su recorrido, Aon lo tramita, se concierta una cita y el expediente se devuelve (compra de trimestres, jubilación progresiva, informe de anomalías).",
        parcours_type_vip_hint:
          "Recorrido digital y humano, con preguntas sobre los proyectos posteriores, el análisis comparado de escenarios y el arbitraje / ROI del Tramo C.",
        parcours_capabilities_title: "Lo que este recorrido abre al empleado",
        parcours_capabilities_locked:
          "El tipo de recorrido determina los servicios incluidos. La jubilación progresiva y el escenario de desempleo se configuran a continuación.",
        progressive_enabled_label: "Activar la jubilación progresiva",
        progressive_enabled_hint:
          "Disponible en todos los tipos de recorrido. Activa el cálculo y su presentación en los resultados y el próximo BRI. Los expedientes ya calculados deben recalcularse; los importes no estimados siguen requiriendo la revisión del consultor.",
        progressive_disabled_hint:
          "La jubilación progresiva está desactivada para esta operación. Un administrador puede activarla en los ajustes de la operación.",
        parcours_capability_aonProduction: "Gestión por la producción de Aon",
        parcours_capability_appointments: "Reserva de citas",
        parcours_capability_hotline: "Línea telefónica",
        parcours_capability_aiAssistant: "Asistente de IA",
        parcours_capability_messaging: "Mensajería",
        parcours_capability_anomaliesBank: "Informe de anomalías de carrera",
        parcours_capability_rachatRestitution: "Devolución de la compra de trimestres",
        parcours_capability_retraiteProgressive: "Jubilación progresiva",
        parcours_capability_scenarioComparison: "Análisis comparado de escenarios",
        parcours_capability_vipQuestions: "Preguntas complementarias VIP",
        parcours_capability_tranchecArbitrage: "Arbitraje y ROI del Tramo C",
        parcours_capability_chomageScenario: "Escenario de desempleo",
        chomage_scenario_label: "Ofrecer el escenario de desempleo",
        chomage_scenario_hint:
          "Incluido siempre en el recorrido VIP. En los demás recorridos, RRHH también puede solicitarlo expediente por expediente.",
        rachat_enabled_label: "Permitir la simulación con compra de trimestres",
        rachat_enabled_hint:
          "Si se desactiva, la opción de compra no aparece en las simulaciones del empleado.",
        max_age_policy_label: "Fecha de jubilación máxima simulable",
        max_age_policy_hint:
          "Límite superior. Las jubilaciones anteriores y la tasa plena natural siguen siempre disponibles.",
        max_age_tpn: "Tasa plena natural (sin fecha libre)",
        max_age_65: "Hasta los 65 años",
        max_age_67: "Hasta los 67 años",
        max_age_libre: "Libre (sin límite)",
        simulations_max_label: "Simulaciones máx. por empleado (12 meses)",
        simulations_max_placeholder: "Ilimitado",
        simulations_max_hint:
          "Cálculos lanzados por el empleado en 12 meses móviles. Vacío = ilimitado. El equipo de Aon no se descuenta.",
        rdv_duration_label: "Duración de una cita de restitución",
        rdv_duration_option: "{{minutes}} minutos",
        rdv_duration_hint:
          "Duración vendida al cliente. Las franjas abiertas para esta operación la siguen y un empleado no puede reservar más tiempo.",
        dates_imposees_label: "Fechas de salida fijadas por la empresa",
        dates_imposees_hint:
          "Hasta 6 fechas simuladas para todos los empleados de la operación, además de sus propios escenarios. Aparecen en la síntesis del BRI como «fecha fijada por la empresa».",
        dates_imposees_add: "Añadir una fecha",
        dates_imposees_remove: "Quitar",
        bri_selection_section: "Simulaciones presentadas en el BRI por defecto",
        bri_selection_hint:
          "Alcance cliente: escenarios presentados en el BRI de los expedientes de esta operación, en este orden. Todo marcado o todo desmarcado = todas las simulaciones; el consultor puede afinar expediente por expediente.",
        bri_selection_progressive: "Jubilación progresiva: cuantías presentadas",
        annexes_section: "Fichas anexas del BRI",
        annexes_hint:
          "Fichas de la biblioteca añadidas al final del BRI para los expedientes de esta operación. Por defecto se aplica la selección del grupo cliente.",
        annexes_mode_inherit: "Heredar del grupo cliente",
        annexes_mode_custom: "Selección propia de la operación",
        annexes_empty: "Ninguna ficha anexa activa en la biblioteca.",
        population_cible: "Población objetivo",
        description: "Descripción (visible para el cliente)",
        notes_internes: "Notas internas (solo Aon)",
        placeholder_operation_name: "BRI Senior 2026",
        placeholder_slug: "bri-senior-2026",
        placeholder_population: "Ej.: Seniors 58+, directivos, BU Francia…",
        placeholder_description: "Objetivos, población objetivo, contexto…",
        placeholder_notes: "Compromisos, restricciones, particularidades…",
        attachment_group: "Grupo (todas las empresas)",
        attachment_societe: "Empresa",
        attachment_filiale: "Filial",
        bri_type_flash: "Flash",
        bri_type_standard: "Standard",
        bri_type_vip: "VIP / Directivos",
        search_group: "Buscar un grupo…",
        search_societe: "Buscar una empresa…",
        search_filiale: "Buscar una filial…",
        errors: {
          name_required: "El nombre es obligatorio",
          slug_format: "Slug: letras minúsculas, dígitos, guiones",
          group_required: "El grupo es obligatorio",
          societe_required: "La empresa es obligatoria",
          filiale_required: "La filial es obligatoria",
          salary_band_required: "La categoría salarial es obligatoria",
        },
      },
    },
    aiCosts: {
      kicker: "Administración",
      title: "Costes IA (OpenAI)",
      description:
        "Seguimiento preciso del consumo de OpenAI: coste por solicitud, modelo, funcionalidad y usuario.",
      period_days: "{{n}} días",
      kpi_cost: "Coste total",
      kpi_requests: "Solicitudes",
      kpi_avg: "Coste medio / solicitud",
      kpi_cache: "Tokens en caché",
      chart_title: "Coste por día",
      chart_desc: "Total {{usd}} $ en el periodo, convertido a la tasa configurada por modelo.",
      chart_cost: "Coste (EUR)",
      by_model: "Por modelo",
      by_feature: "Por funcionalidad",
      by_user: "Principales usuarios",
      pricing_title: "Tarifas por modelo",
      pricing_desc:
        "Precios de OpenAI (USD / 1M tokens) usados para valorar cada solicitud. Actualizar si OpenAI cambia sus tarifas.",
      col_model: "Modelo",
      edit_pricing: "Editar tarifas: {{model}}",
      field_rate: "Tasa de conversión USD a EUR",
    },
    usageStats: {
      kicker: "Administración",
      title: "Estadísticas de uso",
      description:
        "Volumen de llamadas a la API de cálculo de pensiones (cálculos e importaciones RIS), con unidad de tiempo ajustable.",
      period_days: "{{n}} días",
      unit_label: "Unidad",
      unit_day: "Día",
      unit_week: "Semana",
      unit_month: "Mes",
      kpi_harvest_calls: "Llamadas API",
      kpi_harvest_calls_hint: "{{calc}} cálculos · {{ris}} importaciones RIS",
      kpi_success: "Tasa de éxito",
      kpi_duration: "Duración media",
      kpi_failures: "Fallos",
      harvest_chart_title: "Llamadas en el tiempo",
      harvest_chart_desc:
        "Cálculos exitosos / fallidos, importaciones RIS y duración media de un cálculo por periodo.",
      harvest_ok: "Cálculos exitosos",
      harvest_ko: "Cálculos fallidos",
      harvest_ris: "Importaciones RIS",
      harvest_duration: "Duración media",
      harvest_mix_title: "Desglose de llamadas",
      harvest_mix_desc: "Origen de los cálculos en el periodo.",
      harvest_parcours: "Recorrido (estimación)",
      harvest_simulations: "Simulaciones a demanda",
    },
    settings: {
      kicker: "Administración",
      title: "Configuración",
      description: "Ajustes globales de la plataforma, aplicados a todos los espacios.",
      parcours_title: "Configuración del recorrido de simulación",
      parcours_desc: "Estos ajustes se definen ahora operación por operación.",
      parcours_item_max_age:
        "Fecha de jubilación máxima simulable (tasa plena natural, 65 o 67 años).",
      parcours_item_rachat: "Simulación con o sin compra de trimestres.",
      parcours_item_formation: "Formación obligatoria o no antes de acceder al recorrido.",
      parcours_item_quota: "Número de simulaciones autorizadas por empleado en 12 meses móviles.",
      parcours_hint:
        "Abra una operación y luego la sección «Recorrido de simulación» del formulario. Un asesor de Aon puede además desbloquear un expediente concreto desde su ficha.",
      parcours_cta: "Ir a las operaciones",
      urgence_title: "Expedientes urgentes",
      urgence_desc:
        "Marcado automático según la proximidad de la salida, y plazo objetivo de tratamiento.",
      urgence_auto_mois_label: "Marcado automático (meses antes de la salida)",
      urgence_auto_mois_hint:
        "Un expediente no restituido pasa a ser urgente cuando la fecha de salida prevista o la fecha de salida conocida está dentro de este número de meses (1 a 24).",
      urgence_delai_label: "Plazo objetivo de tratamiento (días laborables)",
      urgence_delai_hint:
        "Superado ese plazo, se envía una alerta de «plazo superado» al jefe de proyecto y al consultor (1 a 60, de lunes a viernes).",
      saved: "Configuración guardada.",
      bri_legal_title: "Texto jurídico del BRI",
      bri_legal_desc:
        "Mención impresa al pie de las páginas de resultados del BRI (síntesis, regímenes, hipótesis). Debe validarla el departamento jurídico de Aon; se aplica de inmediato a los próximos documentos generados.",
      bri_legal_lang_fr: "Francés",
      bri_legal_lang_en: "Inglés",
      bri_legal_lang_es: "Español",
      bri_legal_hint:
        "Deje un campo vacío para usar el texto por defecto (en gris). Dos o tres líneas como máximo: más allá, el texto se trunca en el PDF.",
      bri_legal_save: "Guardar el texto jurídico",
      calc_title: "Hipótesis de cálculo",
      calc_desc: "Derivas de proyección aplicadas por el motor de cálculo.",
      calc_pass_label: "Deriva anual del PASS (%)",
      calc_salaires_label: "Revalorización anual del salario por defecto (%)",
      calc_salaires_help: "Valor propuesto al empleado, que puede ajustarlo en su recorrido.",
      calc_point_service:
        "Valor de servicio del punto: 0 % (valor vigente en la fecha del cálculo)",
      calc_point_achat: "Valor de compra del punto: según el motor de cálculo",
      calc_hint:
        "Estos ajustes se aplican a los próximos cálculos: los expedientes ya calculados no se recalculan.",
      calc_save: "Guardar las hipótesis",
      drh_reporting_title: "Reporting RRHH",
      drh_reporting_desc:
        "Ajustes del reporting agregado y anonimizado disponible para los contactos de RRHH.",
      drh_seuil_label: "Umbral de anonimato (número mínimo de empleados)",
      drh_seuil_help:
        "Por debajo de este número, los efectivos se ocultan en el reporting de RRHH.",
      drh_reporting_save: "Guardar el umbral",
      bri_calc_title: "Cálculos del BRI",
      bri_calc_desc:
        "Tasas de cotizaciones mostradas en el documento BRI y umbral de la mención « pensión pequeña ». Actualizar cada 1 de enero.",
      bri_calc_charges_label: "Cargas sociales sobre el salario (%)",
      bri_calc_charges_help:
        "Mostrada en el BRI y aplicada a la estimación del salario neto a tiempo parcial (jubilación progresiva).",
      bri_calc_suppl_label: "Cotizaciones sobre la jubilación suplementaria (%)",
      bri_calc_source_label: "Fuente de las tasas",
      bri_calc_date_label: "Tasas en vigor a fecha de",
      bri_calc_seuil_label: "Umbral de pensión pequeña (€ bruto / mes)",
      bri_calc_seuil_help: "Por debajo de este importe, el BRI menciona el posible pago único.",
      bri_calc_hint:
        "Las tasas de cotizaciones de las pensiones básica y complementaria no se ajustan aquí: el motor las recalcula a partir de los importes brutos y netos de cada expediente.",
      bri_calc_save: "Guardar los ajustes del BRI",
      legal_privacy_title: "Compromiso de confidencialidad de Aon",
      legal_privacy_desc:
        "Texto presentado al empleado en una ventana bloqueante en su primera conexión, y luego en cada nueva versión que exija una nueva aceptación.",
      legal_ia_conditions_title: "Condiciones de uso de la IA",
      legal_ia_conditions_desc:
        "Texto de la sección «Inteligencia artificial» de la página de Confidencialidad (pública).",
      legal_ia_mention_title: "Mención corta de IA",
      legal_ia_mention_desc:
        "Frase mostrada bajo el análisis Noa y el asistente, con un enlace «Más información» hacia la página de Confidencialidad.",
      legal_version: "Versión {{version}}",
      legal_published_at: "Publicada el {{date}} por {{author}}",
      legal_lang_fr: "Francés",
      legal_lang_en: "Inglés",
      legal_lang_es: "Español",
      legal_minor_fix: "Corrección menor: no volver a pedir la aceptación a los empleados",
      legal_publish: "Publicar la versión {{version}}",
      legal_publish_confirm_title: "¿Publicar la versión {{version}}?",
      legal_publish_confirm_desc:
        "Los empleados deberán releer este texto y aceptarlo de nuevo en su próxima conexión para acceder a su espacio.",
      legal_versions: "Versiones anteriores",
      legal_reaccept_yes: "Nueva aceptación requerida",
      legal_reaccept_no: "Corrección menor",
      nav_sections: "Secciones de parámetros",
      last_modified: "Modificado el {{date}} a las {{time}} por {{author}}",
      section_parcours: "Recorrido del empleado",
      section_calculs: "Cálculos",
      section_bri: "BRI",
      section_textes_legaux: "Consentimientos y textos legales",
      section_ia: "Inteligencia artificial",
      section_reporting_drh: "Reporting RRHH",
      section_securite: "Seguridad",
      mfa_title: "Doble autenticación",
      mfa_desc: "Poblaciones para las que la doble autenticación (aplicación TOTP) es obligatoria.",
      mfa_aon_label: "Internos Aon",
      mfa_aon_desc: "Administradores, jefes de proyecto y consultores Aon.",
      mfa_drh_label: "RRHH",
      mfa_drh_desc: "Usuarios del lado cliente con el rol RRHH.",
      mfa_salarie_label: "Asalariados",
      mfa_salarie_desc: "Desactivada por defecto: pueden activarla desde su perfil.",
      mfa_warning:
        "Al activar una población, todos sus usuarios deberán inscribir una aplicación de autenticación en la próxima página cargada. Avíseles antes de activarla.",
      mfa_save: "Guardar los ajustes de seguridad",
      bri_taux_title: "Tasas de cotizaciones sociales",
      bri_taux_desc:
        "Tasas mostradas en el documento BRI para las cotizaciones sobre el salario y la jubilación suplementaria.",
      bri_taux_save: "Guardar las tasas",
      bri_petite_pension_title: "Mención de pensiones muy pequeñas",
      bri_petite_pension_desc:
        "Umbral por debajo del cual el BRI señala el posible pago único, según las reglas de la caja.",
      bri_petite_pension_save: "Guardar el umbral",
      noa_facts_title: "¿Lo sabía?",
      noa_facts_desc:
        "Frases mostradas mientras se genera el análisis de Noa. Cualquier cambio es visible de inmediato para todos los usuarios.",
      noa_facts_hint:
        "Solo las frases activas se muestran, en el orden indicado. Las traducciones vacías vuelven al francés.",
      noa_facts_empty: "Sin frases: el bloque no se muestra durante el análisis.",
      noa_facts_add: "Añadir una frase",
      noa_facts_edit: "Modificar",
      noa_facts_delete: "Eliminar",
      noa_facts_move_up: "Subir",
      noa_facts_move_down: "Bajar",
      noa_facts_translations: "Traducciones (EN, ES)",
      noa_facts_active: "Visible durante el análisis",
      noa_facts_fr_label: "Francés (obligatorio)",
      noa_facts_en_label: "Inglés",
      noa_facts_es_label: "Español",
      noa_facts_edit_title: "Modificar la frase",
      noa_facts_new_title: "Nueva frase",
      noa_facts_save: "Guardar la frase",
      noa_facts_delete_title: "¿Eliminar esta frase?",
      noa_facts_delete_desc:
        "Ya no se mostrará durante la generación de los análisis. Esta acción es definitiva.",
    },
    audit: {
      kicker: "Administración",
      title: "Registro de auditoría",
      description:
        "Trazabilidad de accesos y acciones sobre expedientes, empleados y permisos (RGPD).",
      search_placeholder: "Acción, email, entidad…",
      export: "Exportar (CSV)",
      exporting: "Exportando…",
      no_events: "Ningún evento",
      empty_title: "Sin eventos de auditoría por ahora",
      empty_description:
        "Las acciones sensibles (creación, modificación, eliminación en expedientes, empleados y permisos) se registrarán aquí cuando ocurran.",
      no_events_description: "Ningún evento coincide con estos filtros.",
      category: "Categoría",
      category_auth: "Autenticación",
      category_read: "Consulta",
      category_write: "Escritura",
      category_export: "Exportación",
      category_delete: "Eliminación",
      category_system: "Sistema",
      category_help_auth: "Conexiones y desconexiones a la plataforma.",
      category_help_read: "Consultas de información (solo lectura).",
      category_help_write: "Creación y modificación de información.",
      category_help_export: "Descargas y exportaciones de datos (ej. archivos CSV).",
      category_help_delete: "Eliminación de información.",
      category_help_system: "Acciones técnicas automáticas de la plataforma.",
      outcome: "Resultado",
      outcome_success: "Éxito",
      outcome_failure: "Fallo",
      outcome_denied: "Denegado",
      actor: "Actor",
      entity: "Entidad",
      action: "Acción",
      timestamp: "Fecha y hora",
      from: "Desde",
      to: "Hasta",
      events: "eventos",
      help_title: "¿Para qué sirve esta página?",
      help_description:
        "Este registro lista, de forma legible, quién hizo qué y cuándo en la plataforma: conexiones, creaciones, modificaciones, eliminaciones y exportaciones. Haga clic en una fila para ver los detalles. No se almacenan aquí datos personales sensibles.",
      show_legend: "Entender las categorías",
      hide_legend: "Ocultar leyenda",
      no_detail: "Ningún detalle disponible.",
      status_change: "Cambio de estado:",
      affected_fields: "Campos afectados ({{count}})",
      tech_ref: "Referencia técnica",
      collapse: "Contraer",
      expand: "Expandir",
      system: "Sistema",
      action_login: "Se conectó a la plataforma",
      action_logout: "Se desconectó",
      action_auth_generic: "Acción de autenticación",
      action_mfa_codes_generated: "Regeneró sus códigos de recuperación (2FA)",
      action_mfa_recovery_used: "Se reconectó con un código de recuperación (2FA)",
      action_mfa_recovery_failed: "Código de recuperación 2FA rechazado",
      action_mfa_reset: "Restableció la doble autenticación de un usuario",
      action_export: "Exportó datos",
      action_read: "Consultó {{entity}}",
      action_create: "Creó {{entity}}",
      action_update: "Modificó {{entity}}",
      action_delete: "Eliminó {{entity}}",
      entity_dossier_indef: "un expediente",
      entity_dossier_def: "el expediente",
      entity_salarie_indef: "un empleado",
      entity_salarie_def: "el empleado",
      entity_bri_indef: "una evaluación jubilación",
      entity_bri_def: "la evaluación jubilación",
      entity_document_indef: "un documento",
      entity_document_def: "el documento",
      entity_user_role_indef: "un rol de usuario",
      entity_user_role_def: "el rol de usuario",
      entity_user_scope_indef: "un ámbito de acceso",
      entity_user_scope_def: "el ámbito de acceso",
      entity_operation_indef: "una operación",
      entity_operation_def: "la operación",
      entity_societe_indef: "una sociedad",
      entity_societe_def: "la sociedad",
      entity_groupe_indef: "un grupo",
      entity_groupe_def: "el grupo",
      entity_settings_indef: "un parámetro",
      entity_settings_def: "el parámetro",
      entity_noa_fact_indef: "una frase « ¿Lo sabía? »",
      entity_noa_fact_def: "la frase « ¿Lo sabía? »",
      value_empty: "vacío",
      field_actif: "Activo",
      field_position: "Posición",
      field_assigned_consultant: "Consultor asignado",
      field_assigned_chef_projet: "Jefe de proyecto asignado",
      field_assigned_reviewer: "Revisor asignado",
      field_assigned_restitution_consultant: "Consultor de restitución asignado",
      field_prenom: "Nombre",
      field_email_pro: "Email profesional",
      field_email_correspondance: "Email de correspondencia",
      field_email_perso: "Email personal",
      field_date_naissance: "Fecha de nacimiento",
      field_civilite: "Civildad",
      field_code_postal: "Código postal",
      field_adresse: "Dirección",
      field_ville: "Ciudad",
      field_salaire_annuel_declare: "Salario anual declarado",
      field_salaire_annuel_confirme: "Salario anual confirmado",
      field_nombre_enfants: "Número de hijos",
      field_role: "Rol",
      field_scope_type: "Tipo de ámbito",
      field_scope_id: "Ámbito concernido",
      field_nom_commercial: "Nombre comercial",
      field_raison_sociale: "Razón social",
      field_siren: "SIREN",
      field_bri_type: "Tipo de evaluación",
      field_is_active: "Activo",
      gdpr_notice:
        "Registro RGPD: solo se conservan las columnas modificadas, nunca los valores de negocio. Acceso restringido a la administración de Aon.",
    },
    pappers: {
      label_default: "Autocompletar por SIREN/SIRET",
      aria_label: "Búsqueda de empresa por SIREN/SIRET",
      field_siren: "SIREN (9 dígitos)",
      field_siret: "SIRET (14 dígitos)",
      search: "Buscar",
      success: "Datos obtenidos: {{name}}",
      hint_siren:
        "Introduzca el SIREN de la empresa para rellenar automáticamente el nombre, razón social, SIRET, código NAF y domicilio social.",
      hint_siret:
        "Introduzca el SIRET (14 dígitos) de la filial para recuperar su nombre y verificar que está vinculada a la empresa matriz.",
    },
    branding: {
      kicker: "Administración",
      title: "Branding por tenant",
      description:
        "Cobranding Aon x Empresa. Heredado por cascada: Operación > Sitio > BU > Filial > Empresa > Grupo > Aon.",
      search_placeholder: "Nombre, slug…",
      overrides_count_one: "override de branding activo en la plataforma.",
      overrides_count_other: "overrides de branding activos en la plataforma.",
      entities_count_one: "{{count}} entidad",
      entities_count_other: "{{count}} entidades",
      tabs: {
        societes: "Empresas",
        groupes: "Grupos",
        operations: "Operaciones",
      },
      empty: {
        societes_title: "Ninguna empresa",
        societes_hint: "Cree una empresa desde la pestaña Clientes para poder editar su branding.",
        groupes_title: "Ningún grupo",
        groupes_hint: "Cree un grupo desde la pestaña Clientes para poder editar su branding.",
        operations_title: "Ninguna operación",
        operations_hint:
          "Cree una operación desde la pestaña Operaciones para poder editar su branding.",
      },
      status: {
        active: "Branding activo",
        inherit: "Hereda",
      },
      actions: {
        configure: "Configurar",
        edit: "Editar",
        details: "Detalles",
        delete: "Eliminar",
        delete_aria: "Eliminar el branding",
      },
      delete_confirm: {
        title: "¿Eliminar este branding?",
        description: "El ámbito volverá a los valores heredados del elemento padre.",
      },
      scope_labels: {
        groupe: "Grupo",
        societe: "Empresa",
        filiale: "Filial",
        business_unit: "Business Unit",
        site: "Sitio",
        operation: "Operación",
      },
      fields: {
        product_name: "Nombre del producto",
        product_tagline: "Tagline",
        font_sans: "Font sans",
        font_display: "Font display",
        footer_legal: "Footer legal",
        brand: "Brand",
        brand_foreground: "Texto sobre brand",
        brand_hover: "Brand hover",
        brand_muted: "Brand muted",
        accent: "Accent",
        accent_foreground: "Texto sobre accent",
      },
      drawer: {
        title: "Branding · {{scope}}",
        description: "Nivel {{level}}. Los valores vacíos heredarán del elemento padre.",
        identity_title: "Identidad del producto",
        identity_name_label: "Nombre del producto mostrado",
        identity_name_placeholder: "ej. BRI TotalEnergies",
        identity_tagline_label: "Tagline / subtítulo",
        identity_tagline_placeholder: "El BRI personalizado Aon x {Empresa}",
        colors_title: "Colores",
        preview_title: "Vista previa",
        preview_primary: "Botón principal",
        preview_secondary: "Botón secundario",
        preview_session: "Previsualizar en mi sesión",
        preview_restore: "Restaurar el branding actual",
        logos_title: "Logos y favicon",
        logo_light_label: "Logo (fondo claro)",
        logo_light_hint: "Mostrado en la barra lateral y en el encabezado · PNG, JPG, WEBP o SVG",
        logo_dark_label: "Logo (fondo oscuro)",
        logo_dark_hint: "Variante clara para fondos oscuros (opcional)",
        favicon_label: "Favicon",
        favicon_hint: "Icono de la pestaña del navegador · PNG, SVG o ICO",
        typography_title: "Tipografía",
        font_sans_label: "Font sans-serif (CSS stack)",
        font_sans_placeholder: '"Inter", system-ui, sans-serif',
        font_display_label: "Font display (CSS stack)",
        font_display_placeholder: '"Helvetica Now Display", "Helvetica Neue", sans-serif',
        legal_title: "Menciones legales (footer PDF)",
        footer_label: "Texto del footer",
        footer_placeholder: "Menciones específicas (sede, ORIAS, etc.)",
        color_format_error: "Formato esperado: #RRGGBB o triplete HSL (ej. 354 100% 46%)",
        hsl_detected: "Triplete HSL detectado",
        cancel: "Cancelar",
        save: "Guardar",
      },
    },
    email_templates: {
      kicker: "Administración",
      title: "Plantillas de correo",
      description: "Gestione las plantillas de correo enviadas por la plataforma.",
      add: "Nueva plantilla",
      edit: "Editar plantilla",
      kind: "Tipo",
      subject: "Asunto",
      body: "Cuerpo",
      preview: "Vista previa",
      no_templates: "Ninguna plantilla configurada.",
      variables: "Variables disponibles",
    },
    onboarding: {
      kicker: "Administración · Alta de empresa",
      title: "Incorporar una nueva empresa",
      description:
        "4 pasos guiados: crear la empresa (y su grupo), su estructura interna (BU, centros), su campaña BRI y sus opciones, y luego invitar a los primeros empleados. Todo viene pre-rellenado al máximo; podrá ajustarlo todo después.",
      step_company: "Empresa",
      step_structure: "BU y centros",
      error_create_group: "Error al crear el grupo.",
      error_create_structure: "Error al crear las BU / centros.",
      field_group_new: "O crear un nuevo grupo",
      field_group_new_placeholder: "Nombre del grupo (ej. Grupo Bouygues)",
      field_group_new_hint: "Opcional: el grupo se creará y la empresa quedará vinculada a él.",
      structure_section_title: "Estructura interna (opcional)",
      structure_section_desc:
        "Declare las business units y los centros geográficos de {{company}}: sirven para vincular a los empleados y delimitar los accesos de RRHH.",
      bu_title: "Business units",
      bu_hint: "Direcciones, divisiones o BU usadas para segmentar la población.",
      bu_add: "Añadir una BU",
      bu_name_placeholder: "Ej. Dirección Industrial",
      sites_title: "Centros geográficos",
      sites_hint: "Establecimientos o centros físicos de adscripción de los empleados.",
      site_add: "Añadir un centro",
      site_name_placeholder: "Ej. Sede — La Défense",
      site_ville_placeholder: "Ciudad",
      structure_field_name: "Nombre",
      structure_field_ville: "Ciudad",
      structure_created: "Creado",
      structure_remove: "Quitar la línea",
      structure_skip_hint:
        "Este paso es opcional: puede continuar sin BU ni centros y añadirlos más tarde desde la ficha del cliente.",
      options_section_title: "Opciones del recorrido",
      step_operation: "Operación BRI",
      step_employees: "Empleados",
      step_summary: "Listo",
      back: "Volver",
      continue: "Continuar",
      finish_without_employee: "Finalizar sin empleado",
      create_employees: "Crear {{count}} empleado",
      create_employees_plural: "Crear {{count}} empleados",
      onboard_another: "Incorporar otra empresa",
      see_operations: "Ver operaciones",
      company_section_title: "La empresa cliente",
      company_section_desc:
        "Introduzca el SIREN para rellenar automáticamente, o escriba el nombre manualmente.",
      pappers_hint:
        "Rellena el nombre, la razón social, el SIRET, el código NAF y el domicilio social.",
      field_company_name: "Nombre de la empresa",
      field_slug: "Identificador",
      field_group: "Asociar a un grupo (opcional)",
      field_group_placeholder: "Sin grupo",
      field_group_search: "Buscar un grupo…",
      field_siren: "SIREN",
      field_raison_sociale: "Razón social",
      field_adresse: "Dirección",
      field_code_postal: "Código postal",
      field_ville: "Ciudad",
      drh_section_title: "Contacto RR.HH. (opcional)",
      field_drh_nom: "Nombre del contacto",
      field_drh_email: "Email",
      field_drh_tel: "Teléfono",
      operation_section_title: "La campaña BRI",
      operation_section_desc:
        "Una operación es la campaña de balances de jubilación asociada a {{company}}.",
      operation_section_desc_default: "la empresa",
      field_operation_name: "Nombre de la operación",
      field_operation_year: "Año",
      field_bri_type: "Tipo de BRI",
      bri_type_hint:
        "Se aplica a todos los expedientes de la operación. En BRI flash, el empleado debe indicar sus preferencias antes de acceder a su BRI.",
      field_salary_band: "Categoría salarial",
      salary_band_placeholder: "Seleccionar una categoría",
      salary_band_hint:
        "Los empleados de una operación de categoría única la heredan; en una operación mixta, la categoría se indica empleado por empleado.",
      field_status: "Estado",
      field_population: "Población objetivo (opcional)",
      population_placeholder: "Ej.: Mayores de 58 años, directivos…",
      bri_type_flash: "Flash",
      bri_type_standard: "Estándar",
      bri_type_vip: "VIP / Directivos",
      status_draft: "Borrador",
      status_planned: "Planificada",
      status_ongoing: "En curso",
      employees_section_title: "Los primeros empleados",
      employees_section_desc:
        "Agregue algunos empleados vinculados a {{operation}}. Podrá importar más en bloque desde la pantalla de Empleados.",
      field_firstname: "Nombre",
      field_lastname: "Apellido",
      field_email: "Email",
      email_placeholder: "nombre.apellido@empresa.com",
      add_employee: "Agregar un empleado",
      remove_employee: "Quitar este empleado",
      send_invitation_label: "Enviar la invitación por email",
      send_invitation_desc:
        "Cada empleado con un email recibirá un enlace seguro para acceder a su proceso de jubilación.",
      done_title: "¡Empresa incorporada!",
      done_desc: "{{company}} y su campaña {{operation}} han sido creadas.",
      done_tile_company: "Empresa",
      done_tile_operation: "Operación",
      done_tile_employee: "Empleado",
      done_tile_employees: "Empleados",
      done_invited_one: "{{count}} invitado",
      done_invited_plural: "{{count}} invitados",
      done_link_intro: "Encuentre la empresa en",
      done_link_clients: "Clientes",
      done_link_and: "y la campaña en",
      done_link_operations: "Operaciones",
      error_company_name: "El nombre de la empresa es obligatorio.",
      error_slug_format:
        "El identificador (slug) debe contener solo letras minúsculas, dígitos y guiones.",
      error_company_missing: "Por favor, cree primero la empresa.",
      error_operation_name: "El nombre de la operación es obligatorio.",
      error_operation_salary_band: "Elige una categoría salarial para la operación.",
      error_email_required:
        "Se requiere un email para invitar a {{name}}. Desactive las invitaciones o proporcione el email.",
      error_create_company: "Error al crear la empresa.",
      error_create_operation: "Error al crear la operación.",
      error_create_employee: "Error al crear un empleado.",
      error_company_incomplete: "Falta la empresa.",
    },
    formations: {
      kicker: "Administración",
      title: "Formaciones",
      description: "Gestione las sesiones de formación y la asistencia.",
    },
    document_types: {
      kicker: "Administración",
      title: "Tipos de documentos",
      description:
        "Catálogo de documentos solicitables en un expediente. Los tipos \u00abbase\u00bb se ofrecen a cada empleado; los demás se activan por recorrido en la ficha de operación.",
      new_type: "Nuevo tipo",
      catalogue: "Catálogo",
      empty: "No hay tipos de documentos.",
      badge_core: "Base",
      badge_required: "Obligatorio",
      badge_inactive: "Inactivo",
      aria_edit: "Editar",
      aria_delete: "Eliminar",
      core_no_delete: "El tipo base no se puede eliminar",
      dialog_title_new: "Nuevo tipo de documento",
      dialog_title_edit: "Editar tipo de documento",
      field_label: "Etiqueta",
      field_label_placeholder: "Ej. Extracto de pensión complementaria",
      field_slug: "Identificador (slug)",
      field_slug_hint:
        "No modificable: referenciado por los recorridos y los documentos aportados.",
      field_kind: "Categoría de almacenamiento",
      field_description: "Descripción (ayuda para el depósito)",
      field_description_placeholder:
        "Explique al empleado qué documento aportar y dónde encontrarlo.",
      field_position: "Posición",
      translations_title: "Traducciones (EN / ES)",
      translations_hint:
        "Opcional: etiqueta y descripción mostradas a los empleados según su idioma. En su defecto se usa el francés.",
      field_label_en: "Etiqueta (inglés)",
      field_label_es: "Etiqueta (español)",
      field_description_en: "Descripción (inglés)",
      field_description_es: "Descripción (español)",
      check_core: "Base (siempre propuesto en cada recorrido)",
      check_required: "Obligatorio por defecto",
      check_multiple: "Varios archivos permitidos",
      check_active: "Activo",
      delete_title: "Eliminar tipo de documento",
      delete_description:
        "\u00bfEliminar \u00ab{{label}}\u00bb? Los recorridos que lo solicitan ya no lo ofrecerán. Los documentos ya aportados no se eliminan.",
      kind_ris: "Extracto de carrera (RIS)",
      kind_agirc_arrco: "Extracto Agirc-Arrco",
      kind_bulletin_salaire: "Nómina",
      kind_justificatif_retraite_supp: "Pensión complementaria (PER, art. 83/39)",
      kind_justificatif_carriere: "Justificante de carrera",
      kind_justificatif_penibilite: "Justificante de penosidad",
      kind_justificatif_handicap: "Justificante de discapacidad",
      kind_autre: "Otro",
    },
    controle_qualite: {
      kicker: "Administración",
      title: "Ficha de autocontrol",
      description:
        "Cuadrícula de revisión a dos niveles (N1 producción / N2 jefe de proyecto) a completar antes de la generación del BRI. Los puntos requeridos bloquean la validación del nivel.",
      info: "Estos puntos de control aparecen en la ficha del expediente (área de producción) como casillas de verificación. Un punto marcado como requerido impide la validación del nivel hasta que se marque.",
      level_n1_label: "N1 — Producción",
      level_n2_label: "N2 — Jefe de proyecto",
      level_n1_description:
        "Revisión cruzada (peer to peer) realizada por un colega de producción.",
      level_n2_description: "Control final del jefe de proyecto antes de la entrega.",
      add: "Añadir",
      empty: "No hay puntos de control para este nivel.",
      badge_required: "Requerido",
      badge_optional: "Opcional",
      badge_inactive: "Inactivo",
      dialog_title_new: "Nuevo punto de control",
      dialog_title_edit: "Editar punto de control",
      field_level: "Nivel",
      field_position: "Posición",
      field_label: "Etiqueta",
      field_label_placeholder: "Ej. RIS importado y carrera verificada",
      field_description: "Descripción (ayuda para la revisión)",
      field_description_placeholder: "Especifique qué debe verificar el revisor.",
      check_required: "Punto requerido (bloquea la validación)",
      check_active: "Activo",
      cancel: "Cancelar",
      save: "Guardar",
      delete_title: "Eliminar punto de control",
      delete_description:
        "¿Eliminar «{{label}}»? Las respuestas ya registradas en los expedientes también se eliminarán.",
      delete_confirm: "Eliminar",
    },
    annexes_bri: {
      kicker: "Administración",
      title: "Anexos BRI",
      description:
        "Biblioteca de fichas de anexos (glosario, regímenes especiales, fiscalidad...) insertables en los soportes BRI y seleccionables como anexos predeterminados a nivel de grupo cliente.",
      new_annexe: "Nueva ficha",
      stat_total: "Fichas",
      stat_actives: "Activas",
      stat_avec_fichier: "Con archivo",
      search_placeholder: "Buscar por título, tema, etiqueta...",
      filter_all: "Todos los temas",
      empty_title: "No hay fichas",
      empty_filtered: "Sin resultados para estos filtros.",
      empty_description: "Cree su primera ficha de anexo para enriquecer la biblioteca.",
      create_first: "Crear una ficha",
      badge_inactive: "Inactiva",
      action_open_file: "Abrir archivo",
      action_deactivate: "Desactivar",
      action_activate: "Activar",
      action_edit: "Editar",
      action_delete: "Eliminar",
      delete_title: "Eliminar esta ficha",
      delete_description: '"{{titre}}" será eliminada definitivamente.',
      delete_body:
        "La ficha desaparecerá de la biblioteca y de las selecciones de anexos predeterminados de los grupos.",
      delete_confirm: "Eliminar",
      drawer_title_new: "Nueva ficha de anexo",
      drawer_title_edit: "Editar ficha de anexo",
      drawer_description:
        "Ficha reutilizable insertada en los soportes BRI (glosario, regímenes, fiscalidad...).",
      field_titre: "Título",
      field_slug: "Slug",
      field_slug_hint: "Identificador único.",
      field_thematique: "Temática",
      field_description: "Descripción",
      field_description_hint: "Resumen del contenido de la ficha.",
      field_file: "Archivo de la ficha",
      field_file_hint_replace:
        "Ya hay un archivo asociado. Seleccione uno nuevo para reemplazarlo.",
      field_file_hint_new: "PDF o imagen (máx. 200 MB). Opcional - se puede añadir más tarde.",
      file_replace: "Reemplazar archivo...",
      file_choose: "Elegir archivo...",
      field_cover: "Imagen de vista previa",
      field_cover_hint: "Opcional. PNG, JPG, WEBP o SVG · máx. 5 MB.",
      field_tags: "Etiquetas",
      field_tags_hint: "Separadas por comas.",
      switch_active_label: "Ficha activa",
      switch_active_description: "Desactive para retirarla de la selección sin eliminarla.",
      cancel: "Cancelar",
      save: "Guardar",
      create: "Crear ficha",
      thematique_lexique: "Glosario",
      thematique_regimes_speciaux: "Regímenes especiales",
      thematique_fiscalite: "Fiscalidad",
      thematique_cas_particuliers: "Casos especiales",
      thematique_infographie: "Infografía",
      thematique_autre: "Otro",
    },
    rachat: {
      kicker: "Referencial",
      title: "Baremo de rescate de trimestres",
      description:
        "Baremo CNAV del pago voluntario para la jubilación (VPLR / dispositivo Fillon), versionado por añada. El coste de un trimestre depende de la edad, el tramo de ingresos (indexado al PASS) y la opción. Este baremo alimenta la estimación de coste y rentabilidad en el recorrido de jubilación.",
      new_millesime: "Nueva añada",
      info_stable:
        "El baremo de costes es estable en el tiempo (sin cambios desde hace ~11 años); solo los umbrales de ingresos cambian cada año (indexados al PASS). Actualice el PASS / los umbrales en la añada e importe la cuadrícula de costes oficial (circular CNAV) a continuación.",
      empty_title: "Ninguna añada",
      empty_description: "Cree una primera añada (año + PASS + umbrales de tramos) para empezar.",
      active_badge: "Activa",
      activate: "Activar",
      pass: "PASS",
      tranche_label: "Tramo {{n}} / {{m}}",
      edit: "Editar",
      delete_millesime_title: "¿Eliminar la añada {{annee}}?",
      delete_millesime_description:
        "Todas las celdas del baremo de esta añada se eliminarán definitivamente.",
      delete_confirm: "Eliminar",
      cancel: "Cancelar",
      millesime_dialog_new: "Nueva añada",
      millesime_dialog_edit: "Añada {{annee}}",
      millesime_dialog_description:
        "PASS y umbrales de tramos de ingresos (tramo 1 < umbral1 ≤ tramo 2 ≤ umbral2 < tramo 3).",
      field_annee: "Año",
      field_pass: "PASS (€)",
      field_seuil1: "Umbral tramo 1 (€)",
      field_seuil2: "Umbral tramo 2 (€)",
      field_libelle: "Etiqueta",
      field_source: "Fuente",
      libelle_placeholder: "Baremo CNAV 2025",
      source_placeholder: "CNAV — Circular 2025-01",
      save: "Guardar",
      create: "Crear",
      error_annee: "Año inválido.",
      error_pass_seuils: "El PASS y los umbrales deben ser cantidades positivas.",
      error_seuil_order: "El umbral del tramo 1 debe ser menor o igual al umbral del tramo 2.",
      bareme_title: "Baremo {{annee}}",
      bareme_description: "Coste por trimestre según edad, tramo de ingresos y opción.",
      cells_filled_one: "{{count}} celda rellena",
      cells_filled_other: "{{count}} celdas rellenas",
      cells_total: " / {{total}}",
      import: "Importar",
      export_csv: "Exportar CSV",
      col_age: "Edad",
      col_tranche: "Tramo {{n}}",
      age_years: "{{age}} años",
      option_taux_seul: "Solo tasa",
      option_taux_duree: "Tasa + duración",
      test_title: "Probar el coste (añada activa)",
      test_field_age: "Edad",
      test_field_revenu: "Ingresos anuales (€)",
      test_tranche: "Tramo",
      test_taux_seul: "Solo tasa",
      test_taux_duree: "Tasa + duración",
      test_per_trim: "{{value}} / trim.",
      test_no_active: "Ninguna añada activa.",
      test_not_found: "Baremo no relleno para esta celda (edad / tramo).",
      test_active_mismatch: "Nota: la prueba usa la añada activa ({{active}}), no {{current}}.",
      cell_dialog_title: "Coste por trimestre",
      cell_dialog_context: "{{age}} años · Tramo {{tranche}} · {{option}}",
      cell_field_percent: "Porcentaje de los ingresos (%)",
      cell_field_euro: "Coste por trimestre (€)",
      cell_tranche2_hint:
        "Tramo 2 (ingresos entre el 75 % y el 100 % del PASS): el coste es un porcentaje aplicado a los ingresos medios.",
      import_dialog_title: "Importar el baremo {{annee}}",
      import_dialog_description:
        "Formato CSV: una línea por celda — edad;tramo;opción;coste. Opción = taux_seul o taux_duree (o OPTION_1 / OPTION_2).",
      import_example_title: "Ejemplo",
      import_tranche2_hint:
        "Para el tramo 2 (ingresos entre el 75 % y el 100 % del PASS), el valor es un porcentaje de los ingresos (ej. 10.73), no una cantidad en €.",
      import_field_csv: "Datos CSV",
      import_placeholder: "Pegue aquí el baremo oficial (edad;tramo;opción;coste)…",
      import_replace:
        "Reemplazar completamente el baremo de esta añada (si no, fusión / actualización)",
      import_errors_more: "… y {{count}} más.",
      import_button: "Importar",
      import_button_count: "Importar ({{count}})",
      import_error_empty: "No hay celdas válidas para importar.",
    },
    rgpd: {
      kicker: "Administración",
      title: "Solicitudes RGPD",
      description:
        "Seguimiento de solicitudes de ejercicio de derechos, conservación de datos y reversibilidad, conforme al RGPD.",
      tab_requests: "Solicitudes",
      tab_retention: "Conservación y reversibilidad",
      requests: {
        export_csv: "Exportar (CSV)",
        stat_pending: "Por tratar",
        stat_in_review: "En curso",
        stat_fulfilled: "Resueltas",
        stat_overdue: "Vencidas",
        search_label: "Búsqueda",
        search_placeholder: "Email del solicitante, motivo…",
        kind_label: "Tipo de derecho",
        status_label: "Estado",
        reset: "Restablecer",
        empty_title_filtered: "Ninguna solicitud",
        empty_title: "Ninguna solicitud RGPD",
        empty_desc_filtered: "Ninguna solicitud coincide con estos filtros.",
        empty_desc:
          "Las solicitudes de ejercicio de derechos presentadas por empleados o sus representantes aparecerán aquí para su tratamiento.",
        table_received: "Recibida",
        table_requester: "Solicitante",
        table_kind: "Tipo de derecho",
        table_status: "Estado",
        table_due: "Plazo",
        table_actions: "Acciones",
        aria_expand: "Desplegar",
        aria_collapse: "Plegar",
        detail_reason: "Motivo de la solicitud",
        detail_salarie: "Empleado afectado",
        detail_not_linked: "No vinculado",
        detail_created: "Creada el",
        detail_due: "Plazo legal",
        detail_handled_by: "Tratada por",
        detail_handled_at: "Tratada el",
        detail_fulfilled_at: "Resuelta el",
        detail_rejected_at: "Rechazada el",
        detail_rejection_reason: "Motivo del rechazo",
        salarie_label: "Empleado: {{name}}",
        action_generate_export: "Generar exportación",
        action_download: "Descargar",
        action_take_in_charge: "Asumir",
        action_fulfill: "Resolver",
        action_reject: "Rechazar",
        action_reopen: "Reabrir",
        footer_note:
          "Conforme al RGPD, las solicitudes deben tratarse en un plazo de un mes (plazo mostrado). El derecho al olvido está limitado por las obligaciones legales de conservación de datos.",
        reject_dialog_title: "Rechazar la solicitud",
        reject_dialog_desc:
          "Indique el motivo del rechazo (se comunicará al solicitante). Se puede deshacer reabriendo la solicitud.",
        reject_dialog_reason_label: "Motivo del rechazo",
        reject_dialog_reason_placeholder:
          "Ej.: solicitud fuera de ámbito, obligación legal de conservación…",
        reject_dialog_confirm: "Rechazar",
        kind_export: "Derecho de acceso / portabilidad",
        kind_effacement: "Derecho al olvido",
        kind_rectification: "Derecho de rectificación",
        kind_opposition: "Derecho de oposición",
        kind_limitation: "Limitación del tratamiento",
        status_pending: "Por tratar",
        status_in_review: "En curso",
        status_fulfilled: "Resuelta",
        status_rejected: "Rechazada",
        csv_header_created_at: "created_at",
        csv_header_requester_email: "requester_email",
        csv_header_salarie: "empleado",
        csv_header_kind: "kind",
        csv_header_status: "status",
        csv_header_due_at: "due_at",
        csv_header_reason: "reason",
        csv_header_handled_by: "handled_by",
        csv_header_rejection_reason: "rejection_reason",
        csv_filename: "rgpd_{{date}}.csv",
      },
      retention: {
        title: "Conservación de datos",
        description:
          "Plazos de conservación por categoría de datos (RGPD — limitación de la conservación).",
        add: "Añadir",
        empty: "Ninguna política definida.",
        edit_aria: "Editar",
        delete_aria: "Eliminar",
        dialog_new: "Nueva política de conservación",
        dialog_edit: "Editar política",
        field_label: "Etiqueta",
        field_label_placeholder: "Ej.: Dossiers retraite",
        field_category: "Categoría (clave)",
        field_category_placeholder: "Ej.: dossier_actif",
        field_months: "Plazo de conservación (meses)",
        field_basis: "Base legal",
        field_basis_placeholder: "Ej.: Obligación legal",
        field_description: "Descripción",
        active_label: "Política activa",
        months_none: "Sin conservación",
        months_year_one: "{{count}} año",
        months_year_other: "{{count}} años",
        months_months_one: "{{count}} mes",
        months_months_other: "{{count}} meses",
        delete_title: "Eliminar política",
        delete_desc: "¿Eliminar la política « {{label}} »? Esta acción es definitiva.",
        delete_confirm: "Eliminar",
        reversibility_title: "Reversibilidad de dossiers",
        reversibility_desc:
          "Restitución de los datos de una sociedad (exportación completa de empleados y dossiers, CDC §17d). El archivo se genera en formato JSON en un almacenamiento seguro.",
        export: "Exportar",
        no_societes: "Ninguna sociedad.",
        export_failed: "Error al exportar",
      },
    },
    salaries: {
      kicker: "Administración",
      title: "Empleados",
      description: "Gestión completa de fichas de empleados.",
      add: "Nuevo empleado",
      import: "Importar empleados",
      search_placeholder: "Buscar un empleado…",
      no_salaries: "Ningún empleado encontrado.",
      matricule: "Matrícula",
      nom: "Apellido",
      prenom: "Nombre",
      email: "Correo electrónico",
      societe: "Empresa",
      operation: "Operación",
      status: "Estado",
      vip: "VIP",
      send_invitation: "Enviar invitación",
      delete_confirm: "¿Eliminar este empleado?",
      parcours: "Recorrido de jubilación",
      detail: "Ficha de empleado",
    },
    roadmap: {
      kicker: "Administración",
      title: "Hoja de ruta",
      description: "Seguimiento de funcionalidades y progreso del proyecto.",
    },
    controle: {
      kicker: "Administración",
      title: "Ficha de autocontrol",
      description:
        "Lista de verificación de calidad para validar un expediente antes de producción.",
    },
    content_library: {
      views_title: "Consultas de la ficha",
      views_label_one: "{{count}} vista · última: {{last}}",
      views_label_other: "{{count}} vistas · última: {{last}}",
      views_none: "Sin vistas",
      kicker: "Administración",
      title: "Biblioteca de contenidos",
      description:
        "Fichas, vídeos, artículos y enlaces publicados en modo lectura en los espacios de empleado, RRHH y Aon según su segmentación.",
      new_button: "Nuevo contenido",
      stat_total: "Contenidos",
      stat_published: "Publicados",
      stat_featured: "Destacados",
      search_placeholder: "Buscar por título, tema, etiqueta…",
      filter_all_types: "Todos los tipos",
      empty_title: "Sin contenido",
      empty_filtered: "Sin resultados para estos filtros.",
      empty_none: "Cree su primer contenido para alimentar los espacios.",
      empty_create: "Crear contenido",
      row_unpublish: "Despublicar",
      row_publish: "Publicar",
      row_edit: "Editar",
      row_delete: "Eliminar",
      row_draft: "Borrador",
      row_featured: "Destacado",
      delete_title: "Eliminar este contenido",
      delete_description: "«{{title}}» se eliminará definitivamente.",
      delete_confirm: "Eliminar",
      delete_body: "El contenido desaparecerá inmediatamente de los espacios que lo muestran.",
      drawer_title_create: "Nuevo contenido",
      drawer_title_edit: "Editar contenido",
      drawer_description:
        "Ficha, vídeo, artículo o enlace — visible en modo lectura en los espacios segmentados.",
      drawer_cancel: "Cancelar",
      drawer_save: "Guardar",
      drawer_create: "Crear contenido",
      drawer_error_unknown: "Error desconocido",
      tab_edit: "Edición",
      tab_preview: "Vista previa",
      field_title: "Título",
      field_slug: "Slug",
      field_slug_hint: "Identificador único (URL).",
      field_duration: "Duración (min)",
      field_duration_hint: "Lectura / visualización estimada.",
      field_kind: "Tipo",
      field_category: "Categoría",
      field_audiences: "Visible en los espacios",
      field_audiences_hint: "Al menos un espacio.",
      field_summary: "Resumen",
      field_summary_hint: "Una frase mostrada en la tarjeta.",
      field_body: "Contenido (markdown)",
      field_body_hint: "## Títulos, **negrita**, listas (-), citas (>), [enlaces](url).",
      field_url_video: "URL del vídeo",
      field_url_video_hint: "YouTube o Vimeo (embed automático).",
      field_url_link: "URL del enlace",
      field_url_link_hint: "Enlace externo (servicio público, socio…).",
      field_file: "Archivo",
      field_file_optional: "Archivo de vídeo (opcional)",
      field_file_hint_doc: "PDF, Word, Excel o PowerPoint (máx. 200 MB).",
      field_file_hint_video: "Si no hay URL de YouTube/Vimeo, suba un mp4.",
      field_file_existing: "Ya hay un archivo asociado. Seleccione uno nuevo para reemplazarlo.",
      field_file_replace: "Reemplazar archivo…",
      field_file_choose: "Elegir archivo…",
      field_cover: "Imagen de portada",
      field_cover_hint: "Opcional. PNG, JPG, WEBP o SVG · máx. 5 MB.",
      field_tags: "Etiquetas",
      field_tags_hint: "Separadas por comas.",
      switch_featured: "Destacado",
      switch_featured_desc: "Mostrar en primer lugar en la biblioteca.",
      switch_published: "Publicado",
      switch_published_desc: "Desmarque para ocultar el recurso en los espacios.",
      preview_hint: "Vista previa de la tarjeta tal como aparecerá en los espacios segmentados.",
    },
    emailTemplates: {
      kicker: "Administración",
      title: "Plantillas de email",
      description:
        "Emails realmente enviados por la plataforma: invitaciones, conexión por enlace mágico (OTP), restablecimiento de contraseña y seguimientos de expediente.",
      new_button: "Nueva plantilla",
      search_placeholder: "Buscar una plantilla, una palabra en el asunto…",
      all_kinds: "Todos los tipos",
      count_label: "{{count}} plantilla",
      count_label_plural: "{{count}} plantillas",
      empty_title: "Ninguna plantilla",
      empty_filtered: "Ningún resultado para estos filtros.",
      empty_create_first: "Cree su primera plantilla para iniciar las comunicaciones automáticas.",
      empty_create_button: "Crear una plantilla",
      edit_tooltip: "Modificar",
      delete_tooltip: "Eliminar",
      delete_title: "Eliminar esta plantilla",
      delete_confirm: "Eliminar",
      delete_description: "« {{slug}} » se eliminará definitivamente.",
      delete_history_note:
        "Si esta plantilla está referenciada en envíos anteriores, el historial se conservará pero la plantilla ya no será utilizable.",
      badge_system: "Sistema",
      badge_inactive: "Inactivo",
      kinds: {
        invitation: "Invitación (sistema)",
        otp_login: "Conexión OTP (sistema)",
        password_reset: "Restablecimiento de contraseña (sistema)",
        relance: "Seguimiento de expediente",
        evaluation_invitation: "Invitación a la evaluación del servicio",
        evaluation_relance: "Recordatorio de evaluación del servicio",
      },
      variables: {
        prenom: "Nombre del destinatario",
        nom: "Apellido del destinatario",
        magic_link: "Enlace mágico (invitación / OTP)",
        reset_link: "Enlace de restablecimiento de contraseña",
        roles_label: "Roles asignados (invitación de usuario)",
        inviter_name: "Nombre del invitador (invitación de usuario)",
        societe: "Nombre de la empresa (seguimiento)",
        lien_dossier: "URL al espacio del salariado (seguimiento)",
        consultant_nom: "Nombre del consultor (seguimiento)",
      },
      drawer: {
        new_title: "Nueva plantilla de email",
        edit_title: "Modificar la plantilla",
        description:
          "Emails del sistema enviados automáticamente por la plataforma (invitación, conexión OTP, restablecimiento de contraseña)",
        cancel: "Cancelar",
        save: "Guardar",
        create: "Crear la plantilla",
        tab_edit: "Editor",
        tab_preview: "Vista previa",
        field_slug: "Slug",
        field_kind: "Tipo",
        field_langue: "Idioma",
        field_langue_fr: "Français",
        field_langue_en: "English",
        field_scope: "Ámbito",
        scope_system: "Sistema",
        scope_operation: "Operación",
        scope_operation_disabled_title: "Enlace a una operación próximamente",
        field_subject: "Asunto",
        field_subject_placeholder: "Hola {{prenom}}, su BRI está disponible",
        field_body_html: "Cuerpo HTML",
        field_body_html_hint:
          "Puede utilizar HTML simple. Haga clic en una variable para insertarla.",
        field_body_html_placeholder: "<p>Hola {{prenom}},</p>\n<p>Su BRI…</p>",
        variables_available: "Variables disponibles",
        variables_hint: "Haga clic para insertar en el cuerpo.",
        field_body_text: "Versión de texto (fallback)",
        field_body_text_hint: "Opcional. Si está vacío, se generará automáticamente al enviar.",
        preview_subject_label: "Asunto",
        preview_rendered_label: "Vista previa renderizada (variables reemplazadas)",
        preview_empty: "(vacío)",
        preview_disclaimer: "Vista previa basada en datos ficticios ({{count}} variables).",
      },
    },
    messageTracking: {
      kicker: "Administración",
      title: "Seguimiento de mensajes",
      description:
        "Todas las conversaciones en espera de respuesta, ordenadas por antigüedad. Ya se envía un email de notificación por cada mensaje: esta pantalla garantiza que ningún intercambio quede pendiente.",
      badge_critical_one: "{{count}} conversación sin respuesta desde hace más de 48 h",
      badge_critical_other: "{{count}} conversaciones sin respuesta desde hace más de 48 h",
      stat_total: "Conversaciones activas",
      stat_aon: "Respuesta pendiente de Aon",
      stat_client: "En espera del cliente",
      filter_aon: "A tratar por Aon ({{count}})",
      filter_client: "En espera del cliente ({{count}})",
      filter_all: "Todas ({{count}})",
      empty_title: "Nada pendiente",
      empty_description:
        "Todas las conversaciones de este filtro han recibido una respuesta. Buen trabajo.",
      list_title_one: "{{count}} conversación",
      list_title_other: "{{count}} conversaciones",
      channel_salarie_production: "Empleado ↔ Producción",
      channel_drh_chefprojet: "RRHH ↔ Jefe de proyecto",
      awaiting_aon: "El equipo Aon debe responder",
      awaiting_client: "En espera del cliente",
      no_subject: "Conversación sin asunto",
      waiting_less_than_hour: "menos de una hora",
      waiting_hours: "{{count}} h",
      waiting_days_one: "{{count}} día",
      waiting_days_other: "{{count}} días",
      waiting_since: "Sin respuesta desde hace {{when}}",
      open: "Abrir",
    },
  },
  aon: {
    anomalies: {
      kicker: "Equipo Aon",
      title: "Biblioteca de anomalías",
      description:
        "Fichas reutilizables de anomalías de carrera: explicación para el empleado, acción recomendada y documentos a solicitar. Emparejadas automáticamente con las anomalías detectadas por la auditoría de carrera.",
      ia_hint:
        "Las fichas activas alimentan el análisis Noa como base de conocimientos: la IA reutiliza las formulaciones validadas aquí en lugar de improvisar.",
      new_fiche: "Nueva ficha",
      catalogue: "Fichas",
      empty: "Ninguna ficha de anomalía.",
      badge_inactive: "Inactiva",
      aria_edit: "Editar",
      aria_delete: "Eliminar",
      dialog_title_new: "Nueva ficha de anomalía",
      dialog_title_edit: "Editar la ficha de anomalía",
      field_label: "Etiqueta",
      field_label_placeholder: "Ej.: Caída de ingresos sin explicación",
      field_code: "Código",
      field_code_hint:
        "Use el código del motor de auditoría (baisseRevenu, revenuNul…) para el emparejamiento automático; libre en otro caso.",
      field_position: "Posición",
      field_explication: "Explicación para el empleado",
      field_explication_placeholder:
        "Explique la anomalía en lenguaje claro, tal como se presentará al empleado.",
      field_recommandation: "Acción recomendada",
      field_recommandation_placeholder: "Pasos validados a seguir para corregir la anomalía.",
      field_pieces: "Documentos a solicitar",
      field_pieces_placeholder: "Justificantes a solicitar al empleado (nóminas, certificados…).",
      translations_title: "Traducciones (EN / ES)",
      translations_hint:
        "Opcional: contenidos mostrados según el idioma del empleado. En su defecto se usa el francés.",
      field_label_tr: "Etiqueta traducida",
      field_explication_tr: "Explicación traducida",
      field_recommandation_tr: "Recomendación traducida",
      field_pieces_tr: "Documentos traducidos",
      check_active: "Ficha activa (propuesta a los consultores y al análisis de IA)",
      delete_title: "Eliminar la ficha",
      delete_description:
        "¿Eliminar «{{label}}»? La ficha ya no se propondrá ni será utilizada por el análisis de IA.",
      frequency_title: "Anomalías más frecuentes",
      frequency_hint:
        "Vista consolidada de todos los expedientes: anomalías detectadas por la auditoría de carrera y anomalías declaradas por los consultores.",
      frequency_count_one: "{{count}} expediente",
      frequency_count_other: "{{count}} expedientes",
    },
    alertes: {
      title: "Alertas automáticas y puntos Agirc-Arrco",
      description:
        "Señales calculadas a partir del relevé, los ingresos y el perfil: calificarlas y, si procede, añadirlas al registro de anomalías y vigilancia.",
      points_title: "Puntos Agirc-Arrco por año",
      points_drops: "{{count}} caída(s)",
      points_empty: "Ninguna serie de puntos en el último relevé importado.",
      points_unit: "puntos",
      drop_tooltip: "−{{pct}} % vs {{prev}} pts el año anterior",
      table_year: "Año",
      table_points: "Puntos adquiridos",
      table_diff: "Variación (puntos)",
      table_diff_pct: "Variación (%)",
      table_flag: "Señal",
      table_drop: "Descenso",
      table_expand: "Ver los {{count}} años anteriores",
      table_collapse: "Reducir la tabla",
      list_title: "Alertas",
      empty: "Ninguna alerta automática en este expediente.",
      tracked: "En el registro",
      add_to_registre: "Añadir al registro",
      niveau_info: "Info",
      niveau_important: "Importante",
      niveau_critique: "Crítico",
      code_service_militaire_absent: "Servicio militar declarado pero ausente del relevé",
      msg_service_militaire_absent:
        "El empleado declara un servicio militar; ninguna período militar figura en el RIS. Solicitar el certificado de servicios y la regularización.",
      code_service_militaire_dates: "Fechas del servicio militar divergentes",
      msg_service_militaire_dates:
        "Declarado: {{declare}} — relevé: {{ris}}. Verificar el período retenido por la caja.",
      code_baisse_revenu: "Bajada de ingresos de al menos un 30 %",
      msg_baisse_revenu:
        "{{count}} año(s) presentan un ingreso al menos un 30 % inferior al año anterior. Calificar la causa (desempleo, tiempo parcial, enfermedad…) y verificar los trimestres asimilados.",
      code_revenu_nul: "Año(s) sin ingresos en mitad de la carrera",
      msg_revenu_nul:
        "{{count}} año(s) sin ningún ingreso declarado con la carrera en curso. Trimestres y puntos del período a controlar.",
      code_baisse_points: "Caída de puntos Agirc-Arrco",
      code_points_salaire: "Puntos y salario: diferencia a verificar",
      msg_points_salaire:
        "En {{annee}}, el extracto muestra {{points}} puntos frente a una referencia de {{attendu}} puntos calculada sobre el salario declarado y las tasas anuales estándar. Compruebe la base, los límites prorrateados, las tasas del empleador y los períodos especiales. Este control no demuestra derechos ausentes.",
      msg_baisse_points:
        "{{count}} año(s) con al menos la mitad de puntos que el año anterior (ej. {{exemple}}). Verificar la declaración del empleador y el régimen de cotización.",
      code_points_sans_trimestre: "Puntos complementarios sin trimestre de base",
      msg_points_sans_trimestre:
        "{{count}} año(s) acreditan puntos Agirc-Arrco sin ningún trimestre validado en el régimen de base: existe actividad asalariada, la CNAV debe regularizarse.",
      code_trimestres_sans_points: "Trimestres validados sin puntos complementarios",
      msg_trimestres_sans_points:
        "{{count}} año(s) validan 4 trimestres sin ningún punto Agirc-Arrco mientras los años vecinos sí los tienen. Verificar la afiliación complementaria del empleador.",
      code_creux_carriere: "Años sin información en el relevé",
      msg_creux_carriere:
        "{{count}} año(s) sin ningún período entre el inicio y el fin de la carrera conocida. Preguntar al empleado qué hacía en esas fechas (estudios, extranjero, actividad no declarada…).",
      code_arret_maladie: "Baja por enfermedad / invalidez a controlar",
      msg_arret_maladie:
        "{{count}} período(s) de enfermedad detectado(s) (o baja larga declarada). Verificar que los trimestres asimilados y los puntos gratuitos se han acreditado.",
      code_chomage: "Períodos de desempleo a controlar",
      msg_chomage:
        "{{count}} período(s) de desempleo en el relevé. Verificar los trimestres asimilados (indemnizado o no) y los puntos Agirc-Arrco atribuidos.",
      code_expatriation: "Carrera en el extranjero",
      msg_expatriation:
        "{{count}} período(s) de expatriación o expatriación sin CFE declarada. Verificar los convenios bilaterales, los períodos a validar y el plazo de obtención de los relevés extranjeros.",
      code_temps_partiel_recent: "Bajada reciente: ¿tiempo parcial?",
      msg_temps_partiel_recent:
        "{{count}} año(s) desde 2023 por debajo del nivel de 2022 (ingresos no topados). Preguntar al empleado si trabaja a tiempo parcial, desde cuándo, y su nivel de cotización.",
      code_carriere_longue_potentielle: "Carrera larga potencial no declarada",
      msg_carriere_longue_potentielle:
        "Inicio de actividad a los {{age}} años: el dispositivo de carrera larga puede permitir una jubilación anticipada. A instruir (trimestres cotizados antes de los 16, 18, 20 o 21 años).",
      code_majoration_enfants: "Bonificación de trimestres por hijos",
      msg_majoration_enfants:
        "{{count}} hijo(s) declarado(s): verificar que los trimestres de bonificación (maternidad / educación, adopción, hijo discapacitado) figuran en el relevé.",
      code_trimestres_manquants_faibles: "Tasa plena al alcance",
      msg_trimestres_manquants_faibles:
        "Solo faltan {{count}} trimestre(s) para la tasa plena: unos meses de actividad o una compra específica bastan.",
      code_taux_plein_atteint: "Tasa plena ya alcanzada",
      msg_taux_plein_atteint:
        "La fecha de tasa plena natural ({{date}}) ha pasado: el empleado puede jubilarse cuando lo desee; verificar la sobrecotización.",
      code_age_legal_proche: "Edad legal en menos de un año, expediente incompleto",
      msg_age_legal_proche:
        "El empleado tiene {{age}} años y su expediente no está completo: la restitución debe planificarse rápidamente para dejar tiempo a los trámites.",
      code_depart_anticipe_dispositif: "Dispositivo de jubilación anticipada a instruir",
      msg_depart_anticipe_dispositif:
        "Exposición declarada ({{dispositif}}): verificar los derechos abiertos (puntos C2P, prestación amianto) y su impacto en la fecha de salida.",
    },
    droits: {
      title: "Derechos recuperados",
      description:
        "Trimestres comprados o ganados, puntos Agirc-Arrco recuperados: lo que el análisis permitió obtener, con el seguimiento de la regularización. Agregado en el reporting RRHH.",
      total_trimestres: "Trimestres obtenidos",
      total_points: "Puntos Agirc-Arrco obtenidos",
      empty: "Ningún derecho recuperado registrado.",
      statut_label: "Estado",
      statut_identifie: "Identificado",
      statut_demande: "Solicitado",
      statut_obtenu: "Obtenido",
      nature_trimestres_rachetes: "Trimestres comprados",
      nature_trimestres_gagnes: "Trimestres ganados",
      nature_points_agirc_arrco: "Puntos Agirc-Arrco",
      nature_autre: "Otro derecho",
      field_nature: "Naturaleza",
      field_quantite: "Cantidad",
      field_annee: "Año",
      field_comment: "Comentario",
      field_comment_placeholder: "Ej.: período 2004 regularizado ante la CNAV",
      field_motif: "Motivo",
      motif_service_national: "Servicio nacional",
      motif_activite_salariee: "Actividad asalariada",
      motif_chomage: "Desempleo",
      motif_enfant_handicape: "Hijo con discapacidad",
      motif_maternite: "Maternidad",
      motif_autre: "Otro",
      motif_non_renseigne: "No indicado",
      field_gain: "Ganancia anual estimada (€/año)",
      total_gain: "Ganancia anual estimada (obtenida)",
      gain_format: "{{value}} €/año",
      proposals_title: "Propuestas derivadas de las alertas",
      proposal_use: "Usar",
      proposal_comment_prefix: "Propuesta: ",
      completion_a_confirmer: "Por confirmar",
      completion_saisis: "Confirmado: derechos registrados",
      completion_aucun: "Confirmado: ningún derecho recuperado",
      completion_at: "Confirmado el {{date}} por {{auteur}}",
      confirm_saisis: "Confirmar los derechos registrados",
      confirm_aucun: "Ningún derecho recuperado",
      completion_cancel: "Anular la confirmación",
      completion_hint:
        "Se requiere confirmación antes de cerrar el expediente: indique si se registraron derechos o confirme que no se recuperó ninguno.",
      qty_trimestres: "{{count}} trimestre(s)",
      qty_points: "{{value}} puntos",
    },
    surcotisation: {
      title: "Cotización adicional del empleador",
      description:
        "Cuando la empresa ha cotizado por encima del tipo normal para este asalariado durante un periodo (por ejemplo una aportación complementaria), indique aquí los tipos realmente aplicados: se transmiten al motor de cálculo sobre ese periodo y aumentan la pensión complementaria. Se menciona en el BRI.",
      empty: "Ninguna cotización adicional registrada en este expediente.",
      add: "Añadir una cotización adicional",
      field_period: "Periodo de carrera",
      field_period_placeholder: "Elegir un periodo",
      period_hint:
        "Los años pasados ya figuran en el extracto de puntos Agirc-Arrco: lo que el empleador ha pagado ya está contado. La cotización adicional se aplica al periodo en curso, hasta la jubilación.",
      no_effect: "Sin efecto en el cálculo (periodo pasado)",
      field_caisse: "Caja",
      field_taux_ta: "Tipo tramo A (%)",
      field_taux_tb: "Tipo tramo B (%)",
      field_taux_tc: "Tipo tramo C (%)",
      field_taux_activite: "Tipo de actividad (%)",
      field_type_taux: "Tipo de cotización (opcional)",
      type_taux_contractuel: "Tipos contractuales (baremo convencional)",
      type_taux_appele: "Tipos llamados (realmente aplicados, cotización adicional incluida)",
      type_taux_hint:
        "Tipo contractual (recomendado): tipo que genera puntos. Tipo llamado: tipo realmente aplicado, que incluye el coeficiente de llamada; el motor deduce menos puntos.",
      field_comment: "Comentario",
      field_comment_placeholder:
        "Ej.: cotización adicional del empleador en el tramo B de 2010 a 2015",
      rates_hint:
        "Tipos en porcentaje del salario del tramo. Baremo contractual orientativo de un cuadro: tramo A 6,2 %, tramos B y C 17 % (listas del motor: A de 6,2 a 8 %, B de 17 a 20 %).",
      caisse_AGIRC_ARRCO: "Agirc-Arrco",
      caisse_ARRCO: "Arrco",
      caisse_AGIRC: "Agirc (tramo B)",
      caisse_AGIRCTC: "Agirc (tramo C)",
      caisse_MSA_RCO: "Complementaria MSA",
      delete_confirm:
        "¿Eliminar esta cotización adicional? El próximo cálculo ya no la tendrá en cuenta.",
    },
    vigilance: {
      title: "Anomalías y puntos de vigilancia",
      description:
        "Registro único de las anomalías del expediente, sea cual sea su origen (auditoría automática, entrada del consultor): ciclo de vida, comentario y selección de lo que va al BRI.",
      empty:
        "Ninguna anomalía detectada ni declarada. Ejecute la auditoría de carrera desde el recorrido para alimentar este registro.",
      source_audit: "Auditoría automática",
      source_consultant: "Consultor",
      statut_label: "Estado",
      statut_a_traiter: "Por tratar",
      statut_en_cours: "En curso",
      statut_ecartee: "Descartada",
      statut_resolue: "Resuelta",
      include_bri: "Incluir en el BRI",
      comment_placeholder: "Comentario (quién, qué, por qué)…",
      field_titre: "Nueva anomalía (entrada libre)",
      field_titre_placeholder: "Ej.: Salario 2012 no declarado por el empleador X",
      field_comment: "Comentario",
      field_comment_placeholder: "Detalles opcionales…",
      bri_hint:
        "La página «Puntos de atención» del BRI recoge las anomalías marcadas «Incluir en el BRI»; una anomalía descartada o resuelta desaparece automáticamente.",
    },
    points_attention: {
      title: "Puntos de atención",
      description:
        "Puntos señalados a la atención del empleado por el consultor: título, texto, nivel de importancia y orden de visualización. Solo se añade una página dedicada al BRI si se seleccionan puntos.",
      empty: "Ningún punto de atención seleccionado: el BRI no incluirá una página dedicada.",
      preview_show: "Vista previa",
      preview_hide: "Ocultar vista previa",
      preview_title_a: "Sus puntos",
      preview_title_b: " de atención",
      field_model: "Reutilizar un modelo de la biblioteca",
      model_none: "— Entrada libre —",
      field_niveau: "Nivel de importancia",
      niveau_info: "A tener en cuenta",
      niveau_important: "Importante",
      niveau_critique: "Prioritario",
      field_titre: "Título",
      field_titre_placeholder: "Ej.: Regularizar el año 2015 ante la CNAV",
      field_texte: "Texto",
      field_texte_placeholder:
        "Redacte el punto tal como aparecerá en el BRI entregado al empleado.",
      add: "Añadir al expediente",
      save_model: "Guardar como modelo",
      saved_model: "Modelo guardado",
      move_up: "Subir",
      move_down: "Bajar",
      bri_hint:
        "La página «Puntos de atención» del BRI recoge estos puntos en el orden anterior, respetando la plantilla del documento (logotipo, encabezado, colores).",
    },
    trimestres: {
      title: "Trimestres faltantes y recuperados",
      description:
        "Trimestres faltantes para la tasa plena según el último cálculo, y trimestres recuperables identificados por el consultor (incluidos en el BRI).",
      missing_label: "Trimestres faltantes (tasa plena)",
      missing_no_calc: "Ningún cálculo disponible: lance un cálculo desde el recorrido.",
      recovered_label: "Trimestres recuperables registrados",
      empty: "Ningún trimestre recuperable registrado para este expediente.",
      field_motif: "Motivo",
      field_nb: "Número",
      field_comment: "Comentario",
      field_comment_placeholder: "Referencia RIS, período afectado…",
      motif_periode_salariee: "Período asalariado no declarado",
      motif_periode_chomage: "Período de desempleo",
      motif_enfant_handicap: "Hijo con discapacidad",
      motif_etranger: "Período en el extranjero",
      motif_service_national: "Servicio nacional",
      motif_autre: "Otro motivo",
      bri_hint: "Estos trimestres se incluyen en la página «Puntos de atención» del BRI generado.",
    },
    vip: {
      answers_title: "Preguntas complementarias VIP",
      answers_desc: "Proyectos declarados por el empleado en su recorrido.",
      answers_empty: "Cuestionario sin completar",
      answers_empty_desc:
        "El empleado aún no ha respondido a las preguntas complementarias de su recorrido.",
    },
    tranche_c: {
      title: "Arbitraje y ROI del Tramo C",
      desc: "Cálculo determinista: coste de las cotizaciones, renta generada y punto de equilibrio.",
      computed_at: "Calculado el {{date}}",
      salaire: "Base del Tramo C (€/año)",
      taux: "Tipo de cotización (%)",
      annees: "Años de cotización",
      points: "Puntos adquiridos estimados",
      valeur_point: "Valor del punto",
      esperance: "Duración de percepción (años)",
      out_cout: "Coste total",
      out_rente: "Renta anual",
      out_roi_annees: "Punto de equilibrio",
      out_ratio: "Ratio renta / coste",
      years: "{{value}} años",
      verdict_favorable: "Arbitraje favorable: la renta percibida supera claramente el coste.",
      verdict_neutre: "Arbitraje equilibrado: la renta compensa aproximadamente el coste.",
      verdict_defavorable:
        "Arbitraje desfavorable: el coste no se amortiza en el plazo considerado.",
      verdict_inconnu: "Complete los parámetros para obtener un arbitraje.",
      rachat_title: "Comparación con una compra de trimestres",
      rachat_unit_hint: "Baremo vigente: unos {{cost}} por trimestre (opción solo tasa).",
      rachat_no_bareme: "No hay baremo de compra utilizable para este expediente.",
      rachat_cout: "Coste total de la compra (€)",
      rachat_gain: "Ganancia mensual neta (€)",
      rachat_roi: "Punto de equilibrio de la compra",
      commentaire: "Comentario del consultor",
      commentaire_placeholder: "Hipótesis adoptadas, puntos de atención…",
      note: "Estos importes son estimaciones basadas en los parámetros introducidos. Alimentan la síntesis redactada por Noa, que no recalcula nada.",
      save: "Guardar el arbitraje",
      saved: "Arbitraje guardado.",
      save_failed: "No se ha podido guardar.",
    },
    scenario_comparison: {
      title: "Análisis comparado de escenarios",
      desc: "Diferencias de pensión neta mensual respecto al escenario de referencia ({{reference}}).",
      empty: "No hay suficientes escenarios calculados",
      empty_desc: "Ejecute un cálculo con al menos dos escenarios para obtener la comparación.",
      col_scenario: "Escenario",
      col_date: "Jubilación",
      col_age: "Edad",
      col_trimestres: "Trimestres",
      col_net: "Pensión neta",
      col_delta: "Diferencia",
      age_value: "{{age}} años",
      reference: "Referencia",
      delta_hint:
        "Diferencia entre esta simulación y la estimación de referencia, en pensión neta mensual (referencia {{ref}}, simulación {{sim}}).",
    },
    dashboard: {
      kicker_pilot: "Pilotaje Aon",
      kicker_production: "Producción Aon",
      greeting: "Hola {{name}}",
      desc_pilot: "Pilotaje de operaciones BRI y del equipo de producción.",
      desc_production: "Vista general de su cartera de expedientes BRI.",
      my_portfolio: "Mi cartera",
      stat_my_dossiers: "Mis expedientes",
      stat_accessible: "De {{count}} accesibles",
      stat_to_complete: "Por completar",
      stat_to_complete_hint: "En espera del empleado o de mí",
      stat_to_validate: "Por validar (N1)",
      stat_to_validate_hint: "Control de calidad antes del cálculo",
      stat_to_restitute: "Por entregar",
      stat_to_restitute_hint: "BRI listo, esperando cita con empleado",
      immediate_actions: "Expedientes con acción inmediata",
      view_all_dossiers: "Ver todos mis expedientes",
      up_to_date: "Está al día",
      restitution_badge: "Restitución",
      no_action_needed: "Ningún expediente requiere acción inmediata de su parte.",
      quick_links: "Accesos rápidos",
      link_dossiers: "Todos mis expedientes",
      link_dossiers_desc: "Lista filtrable de los expedientes que gestiono.",
      link_agenda: "Mi agenda",
      link_agenda_desc: "Mis citas de entrega próximas.",
      link_library: "Biblioteca",
      link_library_desc: "Modelos BRI, cartas, materiales de formación.",
    },
    chef_projet: {
      kicker: "Pilotaje jefe de proyecto",
      title: "Seguimiento de operación",
      stat_to_dispatch: "Por asignar",
      stat_to_dispatch_hint: "Expedientes sin consultor",
      stat_n2: "Control N2",
      stat_n2_hint: "N1 validado en espera",
      stat_avg_time: "Tiempo medio de producción",
      stat_avg_time_hint: "Días entre inicio y entrega",
      stat_completion: "Tasa de completar",
      stat_completion_hint: "Expedientes completados / total",
      to_assign_title: "Expedientes por asignar",
      to_assign_empty: "Todos los expedientes están asignados",
      to_assign_empty_desc: "Ningún expediente espera ser asignado a un consultor.",
      n2_title: "Control N2",
      n2_empty: "Ningún expediente en espera de control N2",
      n2_empty_desc: "Todos los controles de calidad están al día.",
      workload_title: "Carga del equipo",
      workload_empty: "Ningún consultor activo",
      workload_empty_desc: "Ningún consultor tiene expedientes asignados en este momento.",
      workload_dossiers: "expedientes activos",
      workload_desc: "Expedientes activos por consultor — ajuste la distribución si es necesario.",
      view_all: "Ver todo",
    },
    dossiers: {
      kicker: "Producción Aon",
      title: "Mis expedientes",
      description: "Lista filtrable de todos sus expedientes BRI.",
      search_placeholder: "Buscar un expediente…",
      no_dossiers: "Ningún expediente encontrado.",
      filter_status: "Estado",
      filter_operation: "Operación",
      filter_societe: "Empresa",
      take_over: "Tomar a cargo",
      reassign: "Reasignar",
      assign_self: "Asignarme",
      assign_other: "Asignar a un consultor…",
    },
    equipe: {
      kicker: "Espacio Aon",
      title: "Mi equipo",
      description: "Consultores y jefes de proyecto de su ámbito.",
      invite: "Invitar a un consultor",
      success_prefix: "Invitación enviada a",
      success_suffix: "La persona recibirá un email para activar su cuenta.",
      close: "Cerrar",
      button_invite: "Invitar a un consultor",
      stat_active: "Consultores activos",
      stat_active_dossiers: "Expedientes activos",
      stat_avg_time: "Tiempo medio por expediente",
      stat_avg_time_hint_with_count: "sobre {{count}} expediente(s) entregado(s)",
      stat_avg_time_hint_none: "ningún expediente entregado medible",
      stat_invitations: "Invitaciones pendientes",
      section_consultants: "Consultores de producción",
      consultants_description:
        "Carga actual, estado de los controles y tiempo medio de producción por consultor (envío del expediente → BRI entregado). La insignia N1 señala los expedientes en espera de autocontrol.",
      empty_title: "Ningún consultor",
      empty_desc: "Invite consultores de producción para empezar su equipo.",
      empty_action: "Invitar",
      section_invitations: "Invitaciones pendientes",
      invitations_desc: "Estas personas aún no han activado su cuenta.",
      revoke_title: "Revocar esta invitación",
      revoke_desc: "La invitación enviada a {{email}} será cancelada.",
      revoke_confirm: "Revocar",
      revoke_footer:
        "La persona ya no podrá crear su cuenta con este enlace. Podrá enviar uno nuevo más tarde.",
      expired: "Caducada",
      invited_at: "Invitado {{date}}",
      n1_label: "N1: {{count}}",
      n2_label: "N2: {{count}}",
      relecture_label: "{{count}} en revisión",
      restitution_label: "{{count}} en restitución",
      active_suffix: "activos",
      delivered_suffix: "entregados",
      avg_time_suffix: "d / expediente",
      avg_time_title: "Tiempo medio de producción (envío → BRI entregado)",
    },
    revue: {
      kicker: "Producción Aon",
      title: "Revisión de calidad",
      description:
        "Revisión de expedientes en dos niveles: N1 (revisión cruzada peer to peer por producción) y N2 (validación final del jefe de proyecto). Valide el N2 directamente desde la cola para desbloquear la generación del BRI.",
      stat_to_dispatch: "A asignar",
      stat_to_dispatch_hint: "Expedientes sin consultor",
      stat_n1: "Pendientes N1",
      stat_n1_hint: "Revisión cruzada de producción",
      stat_n2: "A revisar N2",
      stat_n2_hint: "N1 validado, a la espera de usted",
      stat_avg_time: "Tiempo medio de producción",
      stat_avg_time_value: "{{days}} d",
      stat_avg_time_hint_with_count: "Sobre {{count}} expedientes entregados",
      stat_avg_time_hint_none: "Ningún expediente entregado",
      to_dispatch_title: "A asignar",
      to_dispatch_desc: "Expedientes enviados sin consultor asignado.",
      to_dispatch_empty_title: "Todo asignado",
      to_dispatch_empty_desc: "Ningún expediente a la espera de asignación.",
      n1_title: "Pendientes: Nivel 1 (revisión cruzada)",
      n1_desc:
        "Revisión peer to peer: a realizar por un colega de producción, no por el consultor responsable.",
      n1_empty_title: "Nada pendiente",
      n1_empty_desc: "Ningún expediente a la espera de control N1.",
      n2_title: "A revisar: Nivel 2",
      n2_desc: "N1 validado por producción, a la espera de su control final.",
      n2_empty_title: "Al día",
      n2_empty_desc: "Ningún expediente a la espera de control N2.",
      validated_title: "Validados N2 (revisión terminada)",
      validated_desc: "Expedientes ya controlados, ocultos de las colas. Se muestran bajo demanda.",
      validated_empty_title: "Ningún expediente validado",
      validated_empty_desc: "Aún no se ha validado ningún control N2.",
      submitted_label: "Enviado",
      n1_ok_label: "N1 ok",
      validated_label: "Validado",
      select_all: "Seleccionar todo",
      deselect_all: "Deseleccionar todo",
      action_assign: "Asignar",
      validate_n2: "Validar N2",
      validate_n2_error: "Error, inténtelo de nuevo",
      consultant_label: "Consultor de producción",
      reviewer_label: "Consultor de revisión",
      restitution_consultant_label: "Consultor de restitución",
      restitution_same_as_production: "Igual que el consultor de producción",
      chef_projet_label: "Jefe de proyecto",
      keep_unchanged: "— No cambiar —",
      empty_consultants: "Ningún consultor activo",
      empty_chefs: "Ningún jefe de proyecto activo",
      clear_selection: "Borrar",
      assign: "Asignar",
      bulk_assign: "Asignar selección",
      bulk_assign_desc_one: "Se asignará {{count}} expediente.",
      bulk_assign_desc_other: "Se asignarán {{count}} expedientes.",
      confirm_assign: "Confirmar asignación",
      selected_count_one: "{{count}} expediente seleccionado",
      selected_count_other: "{{count}} expedientes seleccionados",
      dossier_count_one: "{{count}} expediente",
      dossier_count_other: "{{count}} expedientes",
      role_admin: "Admin",
      role_chef_projet: "Jefe de proyecto",
      consultant_assigned: "Consultor: {{name}}",
      unassigned: "Sin asignar",
      badge_autonome: "Recorrido autónomo",
      select_dossier_aria: "Seleccionar expediente de {{name}}",
      open_dossier_title: "Abrir expediente",
      pagination_unit: "expedientes",
      export_excel: "Exportar (Excel)",
      sheet_consultants: "Consultores",
      times_title: "Tiempo de producción por consultor",
      times_desc: "Días entre el envío del expediente y la cita de restitución, por consultor.",
      times_empty_title: "Sin mediciones disponibles",
      times_empty_desc:
        "Ningún expediente enviado con una cita de restitución planificada por el momento.",
      times_col_consultant: "Consultor",
      times_col_dossiers: "Expedientes",
      times_col_mesures: "Medidos",
      times_col_avg: "Tiempo medio",
      times_col_min: "Mín",
      times_col_max: "Máx",
      export_col_salarie: "Empleado",
      export_col_matricule: "Matrícula",
      export_col_operation: "Operación",
      export_col_statut: "Estado",
      export_col_consultant: "Consultor",
      export_col_soumis: "Enviado el",
      export_col_n1_at: "N1 validado el",
      export_col_n1_par: "N1 validado por",
      export_col_n2_at: "N2 validado el",
      export_col_n2_par: "N2 validado por",
      export_col_rdv: "Cita de restitución",
      export_col_days: "Tiempo de producción (días)",
    },
    relances: {
      kicker: "Espacio Aon",
      title: "Seguimientos",
      description: "Seguimiento de recordatorios por correo y teléfono a los empleados.",
      channel_email: "Correo",
      channel_phone: "Teléfono",
      outcome_repondu: "Respondido",
      outcome_pas_de_reponse: "Sin respuesta",
      outcome_message_laisse: "Mensaje dejado",
      outcome_a_rappeler: "Volver a llamar",
      outcome_refus: "Rechazo",
      outcome_injoignable: "Ilocalizable",
      next_relance: "Próximo seguimiento",
      auto_settings: "Seguimientos automáticos",
      auto_enabled: "Activar seguimientos automáticos",
      first_after: "Primer seguimiento después de",
      followup_interval: "Intervalo entre seguimientos",
      max_relances: "Número máximo de seguimientos",
      target_statuses: "Estados objetivo",
      template: "Plantilla de correo",
      dry_run: "Vista previa (simulación)",
      run_now: "Lanzar ahora",
      last_run: "Última ejecución",
      auto_badge: "Auto",
    },
    calendrier: {
      kicker: "Espacio Aon",
      title: "Mi agenda",
      description: "Citas de entrega y disponibilidades.",
      no_appointments: "Ninguna cita planificada.",
      add_availability: "Añadir disponibilidades",
    },
    agenda: {
      kicker: "Pilotaje Aon",
      title: "Agenda y citas",
      description: "Gestione sus franjas horarias abiertas y sus citas de devolución de BRI.",
      add_slot: "Añadir una franja",
      stat_open: "Franjas abiertas",
      stat_booked: "Franjas reservadas",
      stat_upcoming: "Citas próximas",
      appointments_title: "Mis próximas citas",
      no_appointment_title: "Ninguna cita programada",
      no_appointment_desc:
        "Abra franjas horarias para que los empleados puedan concertar una cita con usted.",
      slots_title: "Mis franjas horarias",
      scope_upcoming: "Próximas",
      scope_past: "Pasadas",
      slots_count: "{{count}} franjas",
      pagination_page: "Página {{page}} de {{total}}",
      pagination_previous: "Anterior",
      pagination_next: "Siguiente",
      empty_past_title: "Ninguna franja pasada",
      empty_upcoming_title: "Ninguna franja abierta",
      empty_past_desc: "Sus franjas pasadas aparecerán aquí.",
      empty_upcoming_desc:
        "Añada franjas horarias para que su agenda sea visible para los empleados.",
      cancel_title: "Cancelar esta cita",
      cancel_desc: "Cita con {{name}} del {{date}}.",
      cancel_confirm: "Cancelar cita",
      cancel_footer:
        "La franja asociada vuelve a estar disponible. El empleado y el consultor reciben la anulación en su agenda.",
      action_done: "Realizada",
      action_no_show: "Ausente",
      action_cancel: "Cancelar",
      meeting_link: "Enlace de la reunión",
      slot_reserved: "Reservada",
      slot_open: "Libre",
      delete_slot_tooltip: "Cancele primero la cita para liberar esta franja",
      delete_slot_action: "Eliminar",
      detail_title: "Detalle de la franja",
      detail_start: "Inicio",
      detail_end: "Fin",
      detail_duration: "Duración",
      detail_channel: "Canal",
      detail_status: "Estado",
      detail_created: "Creada el",
      appointment_section: "Cita asociada",
      unknown_company: "Empresa desconocida",
      detail_matricule: "Número de empleado",
      detail_email: "Email",
      detail_video_link: "Enlace de videoconferencia",
      join_meeting: "Unirse",
      detail_phone: "Teléfono",
      notes_consultant: "Notas del consultor",
      open_dossier: "Abrir expediente",
      missing_appointment: "Franja marcada como reservada, pero no se encontró ninguna cita.",
      unknown_employee: "Empleado desconocido",
      channel_teams: "Videoconferencia (Teams)",
      channel_teams_short: "Vídeo",
      channel_telephone: "Teléfono",
      channel_presentiel: "Presencial",
      channel_default: "{{channel}}",
      status_propose: "Propuesta",
      status_planifie: "Programada",
      status_realise: "Realizada",
      status_annule: "Cancelada",
      status_no_show: "Ausente",
      duration_min: "{{minutes}} min",
      duration_h: "{{hours}} h",
      duration_h_min: "{{hours}} h {{minutes}} min",
      format_range_separator: " · ",
      format_range_arrow: " → ",
      cal: {
        title: "Calendario",
        title_for: "Calendario de {{name}}",
        title_team: "Calendario del equipo",
        view_week: "Semana",
        view_month: "Mes",
        previous: "Periodo anterior",
        next: "Periodo siguiente",
        today: "Hoy",
        more: "+{{count}}",
      },
      feed: {
        title: "Suscripción al calendario: {{name}}",
        you: "usted",
        team: "el equipo",
        desc: "Reciba las citas en Outlook o su aplicación de calendario, en solo lectura. El enlace contiene un token secreto revocable.",
        active_since: "Enlace activo desde el {{date}}",
        last_sync: "última sincronización el {{date}}",
        never_synced: "nunca sincronizado",
        create: "Crear el enlace de suscripción",
        regenerate: "Regenerar el enlace",
        revoke: "Revocar",
        shown_once: "Copie este enlace ahora: no se mostrará de nuevo.",
        share_warning:
          "Este enlace da acceso a los nombres de los empleados y a los horarios de las citas: no lo comparta.",
        copy: "Copiar",
        copied: "Copiado",
        subscribe_outlook: "Suscribirse en Outlook",
        open_calendar_app: "Abrir en la aplicación de calendario",
        refresh_hint: "Outlook actualiza las suscripciones a su propio ritmo (hasta unas horas).",
        hide_link: "Ocultar el enlace",
        regen_title: "Regenerar el enlace de suscripción",
        regen_desc: "El enlace anterior dejará de funcionar inmediatamente.",
        revoke_title: "Revocar el enlace de suscripción",
        revoke_desc: "El enlace dejará de funcionar inmediatamente. Esta acción es definitiva.",
        cal_name: "NOA: calendario de {{name}}",
      },
      tabs_label: "Vista de la agenda",
      tab_mine: "Mi agenda",
      tab_team: "Todas las agendas",
      team: {
        stat_open: "Franjas libres (30 d)",
        stat_booked: "Franjas reservadas (30 d)",
        stat_upcoming: "Citas próximas (30 d)",
        consultants_title: "Agendas de los consultores",
        consultants_desc:
          "En los próximos 30 días. Seleccione un consultor para ver sus franjas y filtrar sus citas.",
        no_consultant_title: "Ningún consultor",
        no_consultant_desc: "Todavía no hay ninguna cuenta de consultor activa en el equipo.",
        all_consultants: "Todo el equipo",
        all_consultants_meta: "{{count}} consultores",
        next_at: "Próxima cita: {{date}}",
        no_upcoming: "Ninguna cita próxima",
        col_open: "Libres",
        col_booked: "Reservadas",
        col_upcoming: "Citas",
        slots_title: "Franjas de {{name}}",
        no_slot_title: "Ninguna franja próxima",
        no_slot_desc: "Este consultor no ha abierto franjas para las próximas semanas.",
        appointments_title: "Citas próximas — todo el equipo",
        appointments_title_for: "Citas próximas — {{name}}",
        appointments_desc:
          "Anular una cita libera la franja y notifica al empleado y al consultor (anulación de calendario).",
        no_appointment_title: "Ninguna cita programada",
        no_appointment_desc: "Las citas planificadas por el equipo aparecerán aquí.",
        with_consultant: "con {{name}}",
        cancel_action: "Anular",
        cancel_title: "Anular esta cita",
        cancel_desc: "Cita de {{name}} con {{consultant}}, el {{date}}.",
        cancel_confirm: "Anular la cita",
        cancel_reason_label: "Motivo (enviado al empleado y al consultor)",
        cancel_reason_placeholder: "Ej.: consultor no disponible, le propondremos una nueva fecha.",
        cancel_footer:
          "La franja vuelve a estar disponible. Ambas partes reciben un correo con la anulación del evento para su agenda.",
      },
      drawer: {
        title: "Añadir una franja",
        description: "Abra su agenda para que los empleados puedan concertar una cita.",
        single_tab: "Una franja",
        bulk_tab: "Generación masiva",
        date_label: "Fecha",
        start_time_label: "Hora inicio",
        end_time_label: "Hora fin",
        modality_label: "Modalidad",
        cancel_button: "Cancelar",
        create_slot_button: "Crear franja",
        from_date_label: "Desde",
        to_date_label: "Hasta",
        weekdays_label: "Días de la semana",
        slots_per_day_label: "Franjas por día",
        add_time_slot: "Añadir una franja horaria",
        bulk_preview: "Se creará{{plural}} <strong>{{count}}</strong> franja{{plural}}",
        bulk_preview_dates: " (del {{start}} al {{end}})",
        bulk_generate_button: "Generar {{count}} franja{{plural}}",
        error_invalid_datetime: "Fecha u hora no válida.",
        error_end_after_start: "La hora de fin debe ser posterior a la hora de inicio.",
        error_future: "La franja debe ser en el futuro.",
        error_no_slots: "No se generará ninguna franja con estos parámetros.",
        error_too_many_slots: "Demasiadas franjas para generar ({{count}}). Limítelas a 200.",
        operation_label: "Operación",
        operation_all: "Todas las operaciones",
        operation_hint_all:
          "Franja abierta a todos sus expedientes. Elija una operación para reservarla a sus empleados y aplicar su duración de cita.",
        operation_hint_selected:
          "Franja reservada a los empleados de esta operación — duración de cita: {{minutes}} min.",
        end_time_locked:
          "Hora de fin calculada: duración de {{minutes}} min fijada por la operación.",
        ranges_per_day_label: "Franjas horarias por día",
        ranges_hint: "Cada franja se divide en citas de {{minutes}} min.",
        error_unknown: "Error desconocido",
      },
    },
    pilotage: {
      kicker: "Pilotaje Aon",
      title: "Pilotaje de la operación",
      description:
        "Resumen de la actividad de producción: expedientes en curso, control de calidad en dos niveles, seguimiento de reclamaciones y carga del equipo.",
      section_summary: "Resumen",
      stat_active: "Expedientes activos",
      stat_active_hint: "{{count}} expedientes entregados",
      stat_to_complete: "Por completar",
      stat_to_complete_hint: "A la espera del empleado o de la producción",
      stat_to_relance: "A reclamar",
      stat_to_relance_hint: "{{count}} nunca reclamados",
      stat_avg_time: "Tiempo medio de producción",
      stat_avg_time_hint_with_count: "Sobre {{count}} expedientes entregados",
      stat_avg_time_hint_none: "Ningún expediente entregado",
      stat_avg_time_suffix: "d",
      section_review: "Control y revisión",
      section_sorties: "Salidas y rechazos de contacto",
      stat_sorties: "Cuentas cerradas",
      stat_sorties_hint: "Fecha y motivo de salida registrados",
      stat_sorties_retraite: "Jubilaciones",
      stat_sorties_retraite_hint: "Voluntarias y por iniciativa del empleador",
      stat_refus_contact: "Rechazos de contacto",
      stat_refus_contact_hint: "Excluidos de los recordatorios manuales y automáticos",
      review_link: "Abrir revisión de calidad",
      queue_to_assign: "A asignar",
      queue_to_assign_desc: "Expedientes enviados sin consultor asignado.",
      queue_n1: "En espera N1",
      queue_n1_desc: "Autocontrol por la producción.",
      queue_n2: "A controlar N2",
      queue_n2_desc: "N1 validado, control final del jefe de proyecto.",
      section_relances: "Seguimiento de reclamaciones",
      relances_desc: "Últimas reclamaciones realizadas por el equipo de producción.",
      relances_manage: "Gestionar",
      relance_to_relance: "A reclamar",
      relance_this_month: "Este mes",
      relance_never: "Nunca reclamados",
      relances_empty_title: "Ninguna reclamación reciente",
      relances_empty_desc: "Las reclamaciones registradas aparecerán aquí.",
      relance_default_note: "Reclamación registrada",
      section_workload: "Carga del equipo",
      workload_desc: "{{occupied}}/{{total}} consultores ocupados",
      workload_team: "Equipo",
      workload_empty_title: "Ningún consultor",
      workload_empty_desc: "Invite consultores de producción para empezar.",
      workload_n2: "N2: {{count}}",
      time_since_today: "hoy",
      time_since_days: "hace {{count}} d",
      time_since_weeks: "hace {{count}} sem",
      time_since_months: "hace {{count}} meses",
    },
    library: {
      kicker: "Recursos Aon",
      title: "Biblioteca",
      subtitle:
        "Métodos de producción, referencias técnicas y materiales pedagógicos para los equipos Aon.",
    },
  },
  shareLevel: {
    none: "Compartir: ninguno",
    date_only: "Compartir: fecha de jubilación completa",
    full: "Compartir: BRI completo",
  },
  drh: {
    partage: {
      kicker: "Espacio RRHH · Expediente",
      title: "Expediente de jubilación",
      description: "Lo que el empleado ha elegido compartir con su empresa.",
      back: "Volver a la lista de empleados",
      error_title: "Expediente no disponible",
      error_desc: "Este expediente no existe o está fuera de su perímetro.",
      status_label: "Estado del expediente",
      submitted: "Enviado el {{date}}",
      restituted: "Entregado el {{date}}",
      none_title: "El empleado no ha autorizado compartir sus resultados.",
      none_body:
        "Solo puede ver el estado de su expediente. El empleado puede cambiar su elección en cualquier momento desde su espacio.",
      taux_plein_label: "Jubilación a tasa completa",
      age_at: "A los {{age}}",
      age_years: "{{count}} año",
      age_years_other: "{{count}} años",
      age_months: "{{count}} meses",
      synthese_label: "Resumen de resultados",
      kv_premiere_date: "Primera fecha de jubilación posible",
      kv_age_premiere_date: "Edad en la primera fecha",
      kv_pension_brute: "Pensión mensual bruta",
      kv_pension_nette: "Pensión mensual neta",
      kv_trimestres: "Trimestres validados",
      trimestres_value: "{{valides}} validados, {{manquants}} faltantes",
      kv_points: "Puntos Agirc-Arrco",
      bris_label: "BRI difundidos al empleado",
      bris_empty: "Aún no se ha difundido ningún BRI.",
      bri_name: "Balance de jubilación individual, versión {{version}}",
      bri_released: "Difundido el {{date}}",
      bri_download: "Descargar",
      help: "El nivel de compartición lo elige el empleado, dentro de los límites fijados por su grupo. Solo el equipo de Aon ve el contenido completo del expediente.",
    },
    dashboard: {
      kicker: "Espacio RRHH · Pilotaje",
      title: "Panel de control RRHH",
      description: "Pilotaje de la campaña BRI para su perímetro.",
      scope_badge: "Solo ve los datos de su perímetro.",
      stat_salaries: "Empleados cubiertos",
      stat_salaries_hint: "{{count}} con expediente",
      stat_dossiers: "Expedientes activos",
      stat_dossiers_hint: "{{count}} entregados",
      stat_completion: "Tasa de finalización",
      stat_restitutions: "Próximas entregas",
      stat_restitutions_hint: "{{count}} en los próximos 30 días",
      stat_urgents: "Expedientes urgentes",
      stat_urgents_hint: "Marcados prioritarios en su perímetro",
      badge_urgent: "Urgente",
      distribution_title: "Distribución de expedientes",
      distribution_over: "De {{count}} expedientes",
      funnel_completion: "Finalización",
      funnel_production: "Producción",
      funnel_restitution: "Entrega",
      funnel_delivered: "Entregados",
      contacts_title: "Mis contactos Aon",
      contacts_desc:
        "Jefes de proyecto Aon a cargo de sus operaciones. Haga clic para iniciar o retomar una conversación.",
      contact_role: "Jefe de proyecto",
      contact_chat: "Conversar",
      upcoming_title: "Próximas entregas",
      upcoming_desc: "Próximas citas de su perímetro",
      upcoming_empty_title: "Ninguna entrega planificada",
      upcoming_empty_desc: "Las citas de entrega aparecerán aquí en cuanto se reserven.",
      unknown_salarie: "(empleado desconocido)",
      with: "con {{name}}",
      recent_title: "Actividad reciente",
      see_all: "Ver todo",
      recent_empty_title: "Ningún expediente",
      recent_empty_desc: "Aún no se ha creado ningún expediente en su perímetro.",
    },
    reporting: {
      kicker: "Espacio RRHH · Pilotaje",
      title: "Informes",
      description:
        "Estadísticas agregadas de su ámbito — anticipe las jubilaciones y pilote su campaña de balances de jubilación de un vistazo.",
      anonymized_badge: "Datos anonimizados · plantilla < {{k}} ocultos",
      all_societes: "Todas mis empresas",
      export: "Exportar",
      no_data_title: "Sin datos para este ámbito",
      no_data_desc:
        "Las estadísticas aparecerán cuando los empleados y expedientes estén vinculados a su ámbito.",
      cohort_too_small_title: "Plantilla demasiado pequeña para informes anonimizados",
      cohort_too_small_desc:
        "Su ámbito tiene menos de {{k}} empleados: las estadísticas detalladas están ocultas para evitar la reidentificación.",
      participation: "Participación",
      eligible: "Elegibles",
      started: "Iniciados",
      completed: "Completados",
      delivered: "Entregados",
      participation_rate: "Tasa de participación",
      completion_rate: "Tasa de completar",
      delivery_rate: "Tasa de entrega",
      distribution_title: "Distribución de estados",
      departure_title: "Distribución de edades de jubilación",
      ventilation_title: "Desglose",
      axis_bu: "Unidad de Negocio",
      axis_category: "Categoría",
      axis_salary_band: "Tramo salarial",
      axis_region: "Región",
      axis_operation: "Operación",
      filter_operation: "Operación",
      filter_region: "Región",
      rachat_tous: "Recompra: todas",
      rachat_sans: "Sin recompra",
      rachat_avec: "Con recompra",
      pas_label: "Agrupación",
      pas_annee: "Año",
      pas_trimestre: "Trimestre",
      annee_reference: "Año de referencia",
      comparaison_masked: "comparación N / N-1 oculta (efectivo bajo el umbral)",
      comparaison_resume: "N: {{x}} · N-1: {{y}} · diferencia {{ecart}}",
      comparaison_chart_desc: "Comparación N y N-1 por trimestre",
      adhesion_title: "Adhesión a las formaciones por BU",
      adhesion_desc:
        "Empleados activos, inscritos y asistentes a al menos una formación, y rechazos de adhesión por Unidad de Negocio (efectivos ocultos bajo el umbral de anonimato).",
      adhesion_empty: "Ninguna Unidad de Negocio en este perímetro.",
      adhesion_col_presents: "Presentes",
      adhesion_col_inscrits: "Inscritos",
      adhesion_col_taux: "Tasa de adhesión",
      adhesion_col_formation_presents: "Asistieron a la formación",
      adhesion_col_refus: "Rechazos de adhesión",
      adhesion_taux_masked: "oculto",
      kpi_refus_adhesion: "Empleados presentes que rechazan adherirse",
      kpi_refus_adhesion_hint: "rechazaron ser contactados",
      category_cadre: "Mando",
      category_oetam: "OETAM",
      category_dirigeant: "Directivo",
      category_none: "No indicado",
      salary_sub_80k: "< 80 k€",
      salary_80k_120k: "80 – 120 k€",
      salary_above_120k: "> 120 k€",
      filter_bu: "Unidad de Negocio",
      filter_department: "Departamento",
      filter_category: "Categoría",
      filter_salary: "Tramo salarial",
      filter_formation: "Formación",
      formation_all: "Formación: todas",
      formation_registered: "Inscritos en formación",
      formation_present: "Asistentes a formación",
      active_filters: "{{count}} filtro(s) activo(s)",
      reset_filters: "Restablecer filtros",
      satisfaction_title: "Satisfacción",
      satisfaction_avg: "Nota media",
      satisfaction_respondents: "Encuestados",
      formations_title: "Formaciones",
      formations_sessions: "Sesiones",
      formations_registered: "Inscritos",
      formations_present: "Asistentes",
      cost_title: "Estimaciones financieras",
      badge_prefix: "Datos anonimizados · plantilla",
      badge_suffix: "ocultos",
      filter_status: "Estado del expediente",
      reset_filters_count: "Restablecer ({{count}})",
      salary_none: "No especificado",
      kpi_covered: "Empleados cubiertos",
      kpi_covered_hint: "{{count}} espacio(s) activado(s)",
      kpi_activation_rate: "Tasa de activación",
      kpi_activation_hint: "{{count}} consentimiento(s) recogido(s)",
      kpi_delivered: "Balances entregados",
      kpi_delivered_hint: "de {{count}} expediente(s)",
      kpi_formation_presence: "Asistencia a formación",
      kpi_formation_presence_hint: "{{count}} inscrito(s)",
      info_activated_label: "Espacio activado",
      info_activated_body_1: ": un empleado cuenta como «espacio activado» en cuanto se ha ",
      info_activated_strong: "conectado al menos una vez",
      info_activated_body_2:
        " a su espacio personal (mediante el enlace de invitación o su contraseña). Una cuenta invitada pero nunca usada no se cuenta. La tasa de activación relaciona estas conexiones con el total de empleados cubiertos por su perímetro.",
      funnel_title: "Avance de los expedientes",
      funnel_desc: "Distribución por estado sobre {{count}} expediente(s)",
      funnel_empty: "Ningún expediente en este perímetro.",
      chart_depart_title: "Edad de la primera fecha de salida posible",
      chart_depart_desc: "Distribución de las edades de salida más tempranas de los balances.",
      chart_taux_plein_title: "Edad de tasa completa natural",
      chart_taux_plein_desc: "Distribución de las edades para alcanzar la tasa completa.",
      chart_tpn_annee_title: "Fechas de tasa completa natural por año",
      chart_tpn_annee_desc:
        "Número de empleados que alcanzan su tasa completa natural (TPN) cada año civil.",
      chart_departs_annee_title: "Primeras fechas de salida posibles por año",
      chart_departs_annee_desc:
        "Número de empleados que pueden jubilarse cada año, sin compra (estimación de base) y con compra de trimestres ({{count}} expedientes con simulación de compra), y entre ellos las carreras largas.",
      departs_serie_sans_rachat: "Sin compra",
      departs_serie_avec_rachat: "Con compra",
      departs_serie_carriere_longue: "Carreras largas",
      sorties_title: "Salidas de la plantilla",
      sorties_desc:
        "Cuentas cerradas (fecha y motivo de salida registrados por el equipo) y empleados que rechazaron ser contactados.",
      sorties_total: "Cuentas cerradas",
      sorties_retraite: "Jubilaciones",
      sorties_retraite_hint: "Voluntarias y por iniciativa del empleador",
      refus_contact: "Rechazos de contacto",
      refus_contact_hint: "Empleados excluidos de los recordatorios",
      sorties_par_motif: "Por motivo",
      sorties_par_annee: "Por año de salida",
      sorties_motif_non_renseigne: "Motivo no indicado",
      sorties_empty: "Ninguna salida registrada.",
      droits_title: "Derechos recuperados gracias al acompañamiento",
      droits_desc:
        "Volúmenes obtenidos registrados por los consultores en los expedientes de su perímetro (ocultos por debajo de {{k}} expedientes).",
      droits_dossiers: "Expedientes afectados",
      droits_trim_rachetes: "Trimestres comprados",
      droits_trim_gagnes: "Trimestres ganados",
      droits_points: "Puntos Agirc-Arrco recuperados",
      droits_en_cours: "+ {{count}} en curso de regularización",
      droits_gain_total: "Ganancia anual de pensión estimada (obtenida)",
      droits_gain_en_cours: "+ {{value}} €/año en curso",
      droits_gain_en_cours_label: "Ganancia anual de pensión estimada (en curso)",
      droits_par_motif: "Desglose por motivo",
      droits_motif_col: "Motivo",
      droits_col_trimestres: "Trimestres",
      droits_col_points: "Puntos",
      droits_col_gain: "Ganancia (€/año)",
      retraite_title: "Indicadores de jubilación",
      retraite_desc: "Carreras largas, rescates y derechos de los últimos balances.",
      kpi_carriere_longue: "Carreras largas",
      kpi_rachats: "Rescates previstos",
      kpi_rachats_hint: "expedientes con un coste de rescate estimado",
      kpi_cout_rachat: "Coste medio de rescate",
      kpi_trim_rachetes: "Trimestres rescatados",
      kpi_trim_rachetes_hint: "volumen total previsto",
      kpi_points: "Puntos Agirc-Arrco (prom.)",
      kpi_points_hint: "de {{count}} expediente(s)",
      kpi_points_none: "no informado por el motor",
      kpi_trim_manquants: "Trimestres faltantes (prom.)",
      kpi_trim_manquants_hint: "derechos por completar",
      kpi_trim_valides: "Trimestres validados (prom.)",
      kpi_trim_valides_hint: "de {{count}} balance(s)",
      kpi_points_total: "Puntos Agirc-Arrco (total)",
      segment_title: "Participación por segmento",
      segment_desc: "Empleados cubiertos y espacios activados por {{axis}}.",
      geo_title: "Distribución geográfica",
      geo_desc:
        "Empleados cubiertos por departamento (plantilla oculta bajo el umbral de anonimato).",
      appetences_title: "Preferencias expresadas",
      appetences_desc: "Deseos de los empleados recogidos al final de su balance.",
      satisfaction_section_title: "Satisfacción de los empleados",
      satisfaction_section_desc:
        "Evaluaciones del servicio enviadas tras la entrega del balance (pliego §16).",
      fc_title: "Seguimiento de los formados: conexión y finalización",
      fc_desc:
        "Entre los empleados formados: ¿quién se conectó? ¿cuyo expediente está completo? (pliego §8b)",
      sessions_title: "Sesiones de formación",
      sessions_desc: "Inscripciones y asistencia por sesión en su perímetro.",
      fc_empty: "Ningún empleado formado en este perímetro (o plantilla oculta por anonimato).",
      fc_formes: "Empleados formados",
      fc_connectes: "… que se conectaron",
      fc_bilan: "… cuyo expediente resultó en un balance",
      fc_non_connectes: "Formados pero nunca conectados",
      fc_non_connectes_desc: "Por contactar (correo / teléfono).",
      fc_incomplets: "Conectados, expediente sin completar",
      fc_incomplets_desc: "Por acompañar para finalizar el expediente.",
      sat_masked:
        "Menos de {{k}} evaluaciones en este perímetro: resultados ocultos para preservar el anonimato.",
      sat_empty: "Ninguna evaluación enviada en este perímetro por el momento.",
      sat_avg: "Nota media",
      sat_out_of_5: "/ 5",
      sat_avg_hint: "{{count}} evaluación(es)",
      sat_nps: "NPS",
      sat_nps_hint: "de {{count}} recomendación(es)",
      sat_nps_insufficient: "recomendaciones insuficientes (< {{k}})",
      sat_evaluations: "Evaluaciones",
      sat_evaluations_hint: "opiniones recibidas",
      formations_empty: "Ninguna sesión de formación en este perímetro.",
      col_session: "Sesión",
      col_date: "Fecha",
      col_channel: "Canal",
      col_registered: "Inscritos",
      col_present: "Asistentes",
      col_rate: "Tasa",
      chart_empty_bilan: "Ningún dato de balance disponible.",
      chart_empty_segment: "Ningún segmento disponible.",
      masked_note: "Algunas plantillas están ocultas (por debajo del umbral de anonimato).",
      drill_hint:
        "Haga clic en una barra para mostrar el detalle agregado de la población correspondiente (nunca una lista nominativa).",
      drill_desc: "Población del segmento ({{axis}}) — solo efectivos agregados",
      drill_salaries: "Empleados cubiertos",
      drill_actives: "Espacios activados",
      drill_delivered: "Informes entregados",
      drill_funnel: "Distribución de los expedientes",
      drill_anonymity_note:
        "Este panel solo muestra efectivos agregados: los valores por debajo del umbral de anonimato ({{k}}) están ocultos y no se accede a ningún dato nominativo.",
      status_history_title: "Evolución de la distribución de los expedientes",
      status_history_desc:
        "Distribución semanal de los expedientes por estado, reconstituida desde el historial de cambios de estado. Cada punto respeta el umbral de anonimato.",
      status_history_loading: "Cargando el historial…",
      status_history_error:
        "No se ha podido cargar el historial. Inténtelo de nuevo en unos instantes.",
      status_history_retry: "Reintentar",
      status_history_empty: "Aún no hay suficiente historial para trazar la evolución.",
      csv_status_history: "Evolución de los estados (semana)",
      map_loading: "Cargando el mapa…",
      legend_salaries: "Empleados",
      legend_actives: "Espacios activados",
      tt_years: "años",
      tt_salaries: "empleado(s)",
      tt_actives: "espacio(s) activado(s)",
      tt_bilans: "balance(s) entregado(s)",
      tt_no_data: "Sin datos",
      app_plus_tot: "Salir lo antes posible",
      app_plus_tard: "Salir lo más tarde posible",
      app_progressive: "Jubilación progresiva / tiempo parcial",
      app_rupture: "Ruptura convencional",
      app_rachat: "Rescate de trimestres",
      app_cumul: "Compatibilidad empleo-jubilación",
      csv_indicator: "Indicador",
      csv_value: "Valor",
      csv_covered: "Empleados cubiertos",
      csv_actives: "Espacios activados",
      csv_consents: "Consentimientos recogidos",
      csv_formes: "Empleados formados",
      csv_sortants: "Salientes",
      csv_dossiers_total: "Expedientes (total)",
      csv_carriere_longue: "Carreras largas",
      csv_rachats: "Rescates previstos",
      csv_trim_rachetes: "Trimestres rescatados (volumen)",
      csv_cout_rachat: "Coste medio de rescate (€)",
      csv_points: "Puntos Agirc-Arrco (media)",
      csv_points_total: "Puntos Agirc-Arrco (total)",
      csv_trim_manquants: "Trimestres faltantes (media)",
      csv_trim_valides: "Trimestres validados (media)",
      csv_trim_valides_total: "Trimestres validados (total)",
      csv_tpn_annee: "Tasa completa natural por año",
      csv_departs_annee: "Primeras fechas de salida por año",
      csv_sorties_total: "Salidas — cuentas cerradas",
      csv_sorties_retraite: "Salidas — jubilaciones",
      csv_refus_contact: "Rechazos de contacto",
      csv_sorties_motif: "Salidas por motivo",
      csv_sorties_annee: "Salidas por año",
      csv_formation_inscrits: "Formación — inscritos",
      csv_formation_presents: "Formación — asistentes",
      csv_sat_evaluations: "Satisfacción — evaluaciones",
      csv_sat_note: "Satisfacción — nota media /5",
      csv_sat_nps: "Satisfacción — NPS",
      csv_funnel_title: "Avance de los expedientes",
      csv_number: "Número",
      csv_appetences: "Preferencias",
      csv_ventilation: "Distribución — {{axis}}",
      csv_bilans: "Balances entregados",
      csv_sessions: "Sesiones de formación",
    },
    synthese: {
      kicker: "Espacio RRHH · Pilotaje",
      title: "Síntesis de la misión",
      description:
        "Visión consolidada de la misión: efectivos, salidas realizadas y previstas, deseos de los empleados, derechos recuperados y satisfacción.",
      badge: "Efectivos inferiores a {{k}} ocultos",
      export: "Exportar",
      export_title: "Exportar la síntesis",
      export_desc: "Elija las vistas que desea incluir en el archivo.",
      exporting: "Exportando…",
      all_societes: "Todas mis empresas",
      select_societe: "Elegir una empresa",
      select_societe_title: "Seleccione una empresa",
      select_societe_desc:
        "La síntesis de la misión se muestra empresa por empresa: elíjala en el selector de la parte superior.",
      sec_mission: "Síntesis de la misión",
      sec_departs_realises: "Salidas realizadas",
      sec_departs_envisages: "Salidas previstas",
      sec_appetences: "Deseos de los empleados",
      sec_droits: "Derechos recuperados",
      sec_satisfaction: "Satisfacción",
      sec_roi: "Retorno de la inversión",
      sec_nominatif: "Detalle nominativo",
      m_presents: "Empleados presentes",
      m_sortis: "Empleados salidos",
      m_en_cours: "Expedientes en curso",
      m_prestations: "Prestaciones realizadas",
      m_taux: "Tasa de realización",
      m_anomalies: "Anomalías resueltas",
      m_rachats: "Recompras simuladas",
      m_refus: "Negativas de participación",
      dep_realises_annee: "Salidas realizadas por año",
      dep_realises_motif: "Salidas realizadas por motivo",
      departs_envisages_desc:
        "Fechas procedentes de los cálculos (estimación de base): primera fecha posible, tasa completa y edad de anulación de la penalización.",
      dep_au_plus_tot: "Lo antes posible",
      dep_taux_plein: "Tasa completa",
      dep_annulation: "Anulación de la penalización (67 años)",
      appetences_note: "Deseos expresados por los empleados.",
      droits_note:
        "Derechos recuperados registrados por los consultores ; la ganancia es la suma de las estimaciones.",
      roi_note:
        "Los importes de transacciones e indemnizaciones de salida no se reproducen deliberadamente.",
      nominatif_aide:
        "Solo aparecen los empleados que autorizaron la compartición, con el nivel de información que eligieron.",
      nominatif_date_title: "Autorización: solo fecha de tasa completa",
      nominatif_full_title: "Autorización: BRI completo",
      nominatif_voir: "Ver el expediente",
      sat_note: "Nota media",
      sat_nps: "NPS",
      sat_evaluations: "Evaluaciones",
      roi_accompagnes: "Empleados acompañados",
      roi_taux: "Tasa de realización",
      roi_droits: "Derechos recuperados (trimestres / puntos)",
      roi_rachats: "Recompras simuladas",
      roi_satisfaction: "Satisfacción media",
      roi_gain: "Ganancia anual de pensión estimada acumulada",
      d_dossiers: "Expedientes afectados",
      d_trim_rachetes: "Trimestres recomprados",
      d_trim_gagnes: "Trimestres ganados",
      d_points: "Puntos Agirc-Arrco",
      d_trim_en_cours: "Trimestres en curso",
      d_points_en_cours: "Puntos en curso",
      d_gain: "Ganancia anual estimada (obtenida)",
      d_gain_en_cours: "Ganancia anual estimada (en curso)",
      d_par_motif: "Desglose por motivo",
      col_indicateur: "Indicador",
      col_valeur: "Valor",
      col_annee: "Año",
      col_departs: "Salidas",
      col_motif: "Motivo",
      col_souhait: "Deseo",
      col_salaries: "Empleados",
      col_nom: "Apellido",
      col_prenom: "Nombre",
      col_matricule: "Matrícula",
      col_bu: "Business Unit",
      col_operation: "Operación",
      col_statut: "Estado del expediente",
      col_date_taux_plein: "Salida a tasa completa",
      col_age_taux_plein: "Edad a tasa completa",
      col_premiere_date: "Primera fecha de salida",
      col_age_premiere_date: "Edad",
      col_pension: "Pensión bruta mensual",
      sheet_perimetre: "Ámbito",
      perimetre_date: "Fecha",
      perimetre_societe: "Empresa",
      perimetre_filtres: "Filtros",
      perimetre_filtres_aucun: "Ninguno",
      perimetre_seuil: "Efectivos inferiores a {{k}} ocultos",
      pdf_aucune_donnee: "Ningún dato disponible para esta vista.",
      pdf_tendance: "{{n}} salidas en {{annee}} frente a {{nPrec}} en {{anneePrec}}{{delta}}",
      footer_note:
        "Los efectivos inferiores al umbral de anonimato ({{k}}) están ocultos. El detalle nominativo solo lista a los empleados que autorizaron la compartición de sus resultados.",
    },
    formations: {
      kicker: "Espacio RRHH · Pilotaje",
      title: "Formaciones",
      description: "Seguimiento de sesiones de formación sobre jubilación de su ámbito.",
      no_formations: "Ninguna sesión de formación.",
      search_placeholder: "Buscar una formación…",
      export: "Exportar",
      channel_presentiel: "Presencial",
      channel_visio: "Videollamada",
      channel_mixte: "Mixto",
      stat_sessions: "Sesiones",
      stat_registered: "Inscritos",
      stat_present: "Asistentes",
      stat_absent: "Ausentes",
      stat_upcoming: "Próximas",
      filter_period: "Periodo",
      filter_channel: "Canal",
      period_all: "Todas las sesiones",
      period_upcoming: "Próximas",
      period_past: "Pasadas",
      page_description:
        "Siga las sesiones de formación sobre jubilación de su perímetro: planificación, inscripciones y asistencia.",
      badge_aggregated: "Efectivos agregados · sin datos nominativos",
      all_societes: "Todas mis empresas",
      empty_title: "Ninguna sesión de formación",
      empty_desc: "Las sesiones de formación sobre jubilación de su perímetro aparecerán aquí.",
      kpi_sessions: "Sesiones",
      kpi_upcoming: "Próximas",
      kpi_registrations: "Inscripciones",
      kpi_presence_rate: "Tasa de asistencia",
      kpi_presence_hint: "Sesiones pasadas",
      channel_all: "Canal: todos",
      reset: "Restablecer",
      filtered_empty_title: "Ninguna sesión para estos filtros",
      filtered_empty_desc: "Ajuste el periodo o el canal para mostrar más sesiones.",
      col_session: "Sesión",
      col_date: "Fecha",
      col_channel: "Canal",
      col_registered: "Inscritos",
      col_present: "Asistentes",
      col_rate: "Tasa",
      col_eval: "Eval.",
      badge_upcoming: "Próxima",
      badge_past: "Pasada",
      footer_note:
        "De acuerdo con la confidencialidad, solo se muestran los efectivos agregados por sesión.",
      csv_session: "Sesión",
      csv_societe: "Empresa",
      csv_operation: "Operación",
      csv_date: "Fecha",
      csv_channel: "Canal",
      csv_lieu: "Lugar",
      csv_capacity: "Capacidad",
      csv_registered: "Inscritos",
      csv_present: "Asistentes",
      csv_absent: "Ausentes",
      csv_rate: "Tasa de asistencia (%)",
      csv_eval: "Evaluación media",
      csv_status: "Estado",
    },
    library: {
      kicker: "Recursos RRHH",
      title: "Biblioteca RRHH",
      subtitle:
        "Materiales de dirección, fichas pedagógicas y puntos de referencia para acompañar sus campañas de jubilación.",
    },
    salaries: {
      kicker: "Espacio RRHH",
      title: "Empleados",
      description: "Consulte las fichas de sus empleados y siga su recorrido.",
    },
    operations: {
      kicker: "Espacio RRHH · Pilotaje",
      title: "Operaciones",
      description: "Seguimiento de las campañas BRI en su perímetro.",
      empty_desc: "Ninguna operación está vinculada a su perímetro por el momento.",
      back_all: "Todas las operaciones",
      dossiers_title: "Expedientes de la operación",
      dossiers_subtitle:
        "Seguimiento en modo lectura de los Balances de Jubilación de sus empleados.",
      search_placeholder: "Buscar por nombre, apellido, matrícula…",
      all_steps: "Todas las etapas",
      dossiers_count_one: "{{count}} expediente",
      dossiers_count_many: "{{count}} expedientes",
      no_dossier_title: "Ningún expediente",
      no_dossier_filters: "Ningún resultado para estos filtros.",
      no_dossier_desc: "Ningún expediente es visible aún en su perímetro.",
      societe_none: "Empresa no especificada",
      with: "con",
      updated: "Act. {{date}}",
    },
    messages: {
      kicker: "Espacio RRHH",
      title: "Mensajes",
      description: "Sus intercambios con los jefes de proyecto Aon de sus operaciones.",
      new_conversation: "Nueva conversación",
      search_placeholder: "Buscar…",
      no_results: "Ningún resultado",
      no_conversations: "Ninguna conversación",
      no_conversations_desc:
        "Inicie un intercambio con un jefe de proyecto Aon mediante «Nueva conversación».",
      back_conversations: "Conversaciones",
      select_conversation: "Seleccione una conversación",
      dialog_title: "Nueva conversación",
      dialog_desc: "Seleccione un jefe de proyecto Aon para iniciar (o reabrir) un intercambio.",
      no_contacts_title: "Ningún contacto Aon",
      no_contacts_desc: "Ningún jefe de proyecto está vinculado a sus operaciones por el momento.",
      no_name: "(sin nombre)",
      contact_role: "Jefe de proyecto",
      opening: "Abriendo…",
      unknown_error: "Error desconocido",
      no_subject: "(sin asunto)",
      participants_summary: "{{count}} participantes · RRHH ↔ Jefe de proyecto",
      nobody: "(nadie)",
      rel_min: "hace {{count}} min",
      rel_hour: "hace {{count}} h",
      rel_day: "hace {{count}} d",
    },
  },
  operations_list: {
    title: "Operaciones",
    subtitle: "Gestión de campañas BRI para clientes.",
    search_placeholder: "Buscar una operación, una empresa…",
    filter_active: "Activas",
    filter_draft: "Borradores",
    filter_closed: "Cerradas",
    filter_all: "Todas",
    stat_operations: "Operaciones",
    stat_salaries: "Empleados cubiertos",
    stat_dossiers_active: "Expedientes activos",
    stat_bri_delivered: "BRI entregados",
    empty_title: "Ninguna operación",
    empty_filtered: "Ajuste sus filtros para ver otras operaciones.",
    empty_default: "Ninguna operación está vinculada a usted por el momento.",
    page_of: "Página {{page}} de {{total}} · {{count}} operaciones",
    prev: "Anterior",
    next: "Siguiente",
    tile_salaries: "Empleados",
    tile_dossiers: "Expedientes",
    tile_active: "Activos",
    tile_delivered: "Entregados",
    completion_rate: "Tasa de finalización",
    rdv_upcoming: "{{count}} citas próximas (30d)",
    status_brouillon: "Borrador",
    status_planifiee: "Planificada",
    status_en_cours: "En curso",
    status_cloturee: "Cerrada",
    status_archivee: "Archivada",
  },
  formations: {
    title: "Formaciones",
    add: "Nueva sesión",
    edit: "Editar sesión",
    delete: "Eliminar sesión",
    delete_confirm: "¿Eliminar esta sesión de formación?",
    operation: "Operación",
    titre: "Título",
    description: "Descripción",
    starts_at: "Fecha de inicio",
    ends_at: "Fecha de fin",
    channel: "Canal",
    lieu: "Lugar",
    capacity: "Capacidad máx.",
    formateur: "Formador",
    participants: "Participantes",
    add_participant: "Añadir un participante",
    remove_participant: "Quitar",
    presence: "Asistencia",
    present: "Presente",
    absent: "Ausente",
    not_recorded: "No registrado",
    no_participants: "Ningún participante inscrito.",
    search_salarie: "Buscar un empleado…",
  },
  salaries: {
    form: {
      title_create: "Nuevo empleado",
      title_edit: "Editar {{prenom}} {{nom}}",
      description_create:
        "Creación manual de una ficha. Para importación masiva, use Importar un archivo.",
      description_edit: "Modificación de la ficha del empleado.",
      cancel: "Cancelar",
      save: "Guardar",
      create: "Crear empleado",
      errors: {
        required: "Campo obligatorio",
        invalidEmail: "Correo inválido",
        dateFormat: "Fecha AAAA-MM-DD",
      },
      duplicate: {
        title: "Correo ya utilizado",
        description:
          "La dirección <code>{{email}}</code> ya está vinculada a <strong>{{prenom}} {{nom}}</strong>.",
        matricule: "matrícula {{matricule}}",
        hint: "Vaya a la ficha de ese empleado para modificarla, o utilice otro correo.",
        close: "Cerrar esta advertencia",
      },
      staff_conflict: {
        title: "Este correo pertenece a una cuenta del equipo Aon",
        description_profile:
          "La dirección <code>{{email}}</code> es la de <strong>{{name}}</strong> ({{roles}}). Un miembro del equipo Aon no puede crearse como empleado. Un usuario RRHH, en cambio, puede tener su propia ficha de empleado.",
        description_invitation:
          "La dirección <code>{{email}}</code> tiene una invitación pendiente para una cuenta {{roles}}. Un miembro del equipo Aon no puede crearse como empleado.",
        unknown_name: "un usuario",
        hint: "Utilice la dirección personal del empleado o revoque primero el acceso Aon de esa persona.",
      },
      sections: {
        company: "Vinculación empresa",
        identity: "Identidad",
        contact: "Contacto",
        employment: "Empleo",
        access: "Acceso a la plataforma",
      },
      fields: {
        societe: "Empresa",
        operation: "Operación",
        filiale: "Filial",
        business_unit: "Unidad de Negocio",
        site: "Sitio / región",
        matricule: "Matrícula",
        civilite: "Tratamiento",
        prenom: "Nombre",
        nom: "Apellido",
        nom_naissance: "Apellido de soltera",
        date_naissance: "Fecha de nacimiento",
        gender: "Género",
        email_pro: "Correo profesional",
        email_perso: "Correo personal",
        email_correspondance: "Correo de correspondencia",
        telephone_pro: "Teléfono profesional",
        telephone_perso: "Teléfono personal",
        poste: "Puesto",
        professional_category: "Categoría",
        salary_band: "Banda salarial",
        salaire_annuel_declare: "Salario anual (€)",
        date_entree_societe: "Fecha de entrada en la empresa",
      },
      placeholders: {
        none: "-",
        societe_search: "Buscar una empresa…",
        operation_search: "Buscar una operación…",
        operation_disabled: "Elija primero una empresa",
        operation_none: "- Ninguna -",
        filiale_search: "Buscar una filial…",
        filiale_none: "- Ninguna -",
        bu_search: "Buscar una UEN…",
        bu_none: "- Ninguna -",
        site_search: "Buscar un sitio…",
        site_none: "- Ninguno -",
        email_correspondance: "Correo utilizado para las comunicaciones (por defecto: profesional)",
        matricule: "TE-1001",
      },
      options: {
        civilite_M: "Sr.",
        civilite_Mme: "Sra.",
        civilite_Mx: "Sx.",
        gender_m: "Hombre",
        gender_f: "Mujer",
        gender_x: "No especificado",
        category_cadre: "Cuadro",
        category_oetam: "OETAM (Obreros, Empleados, Técnicos, Agentes de maestría)",
        category_dirigeant: "Directivo",
        salary_sub_80k: "< 80 k€",
        salary_80k_120k: "80 - 120 k€",
        salary_above_120k: "> 120 k€",
      },
      flags: {
        is_present: "Presente en la empresa",
        is_vip: "VIP / Directivo",
        has_rqth: "RQTH (discapacidad reconocida)",
      },
      access: {
        description:
          "Marcar esta opción crea también la cuenta de usuario vinculada en el backoffice. El empleado recibirá un email de activación y definirá su contraseña en la primera conexión.",
        send_invitation: "Crear la cuenta vinculada y enviar la invitación",
        email_required:
          "Indique al menos un correo (correspondencia, profesional o personal) para poder enviar la invitación.",
        email_used: "Invitación enviada a <code>{{email}}</code>.",
      },
    },
    import: {
      title: "Importación de empleados",
      upload: "Subir archivo CSV",
      template: "Descargar plantilla",
      mapping: "Verificación del mapeo",
      preview: "Vista previa de la importación",
      confirm: "Iniciar importación",
      success: "{{count}} empleado(s) importado(s) con éxito.",
      errors: "{{count}} error(es) detectado(s).",
    },
  },
  messages: {
    title: "Mensajería",
    new_conversation: "Nueva conversación",
    search_placeholder: "Buscar una conversación…",
    no_conversations: "Ninguna conversación.",
    no_messages: "Ningún mensaje en esta conversación.",
    type_message: "Escribir un mensaje…",
    send: "Enviar",
    attachment: "Adjuntar un archivo",
    read: "Leído",
    unread: "No leído",
    tracking: {
      title: "Seguimiento de mensajes",
      description: "Vista general de todas las conversaciones de la plataforma.",
    },
  },
  parcours: {
    title: "Mi recorrido de jubilación",
    description: "Complete las etapas para producir su Balance de Jubilación Individual.",
    step_identity: "Identidad",
    step_career: "Carrera",
    step_family: "Situación familiar",
    step_documents: "Documentos",
    step_scenarios: "Escenarios",
    step_validation: "Validación",
    progress: "Progresión",
    complete_step: "Etapa completada",
    next_step: "Siguiente etapa",
    submit: "Enviar mi expediente",
    submit_confirm:
      "Una vez enviado, su expediente será transmitido al equipo Aon para producción.",
    reset: "Reiniciar",
    reset_confirm: "¿Reiniciar el recorrido? Sus datos introducidos se conservarán.",
  },
  bri: {
    title: "Mi Balance de Jubilación",
    subtitle: "Consulte y descargue su Balance de Jubilación Individual.",
    download_pdf: "Descargar PDF",
    no_bri: "Su BRI aún no está disponible.",
    generating: "Generando BRI…",
    generated_at: "Generado el",
    version: "Versión",
  },
  salary_band: {
    sub_80k: "Menos de 80 k€ / año",
    "80k_to_120k": "De 80 a 120 k€ / año",
    above_120k: "Más de 120 k€ / año",
    mixte: "Mixta (a nivel de cada empleado)",
    none: "Sin especificar",
  },
  historique: {
    title: "Historial de mis cálculos",
    subtitle: "Historial completo de sus cálculos y simulaciones.",
    no_history: "Ningún cálculo realizado por el momento.",
    date: "Fecha",
    type: "Tipo",
    result: "Resultado",
    details: "Detalles",
  },
} as const;
